
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jtfsl", function(module, exports) {
/**
 * @generated SignedSource<<7dc99622ff8ab2775d75b231f507aa88>>
 * @relayHash 0dd246a45e06b932ab1b8570b0e2a26f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9541c3f7c90ad9f1ab645d0b30662e1e580d7fd7e0951e7703e0bf175d12bd63
const $8272d98e33ae5f0d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Group",
                            "kind": "LinkedField",
                            "name": "groupsWithId",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AudienceSegmentationContextProviderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AudienceSegmentationContextProviderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0dd246a45e06b932ab1b8570b0e2a26f",
            "id": "9541c3f7c90ad9f1ab645d0b30662e1e580d7fd7e0951e7703e0bf175d12bd63",
            "metadata": {},
            "name": "AudienceSegmentationContextProviderQuery",
            "operationKind": "query",
            "text": "query AudienceSegmentationContextProviderQuery($accountId:ID){user:confluence_atlassianUser(id:$accountId){id,confluence{groupsWithId{id}}}}"
        }
    };
}();
$8272d98e33ae5f0d$var$node.hash = "d01bf7959fed02b6636fa27826de406a";
var $8272d98e33ae5f0d$export$2e2bcd8739ae039 = $8272d98e33ae5f0d$var$node;
module.exports["default"] = $8272d98e33ae5f0d$export$2e2bcd8739ae039;

});

parcelRegister("hEeUR", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");


var $1a6Dn = parcelRequire("1a6Dn");


var $8WfxO = parcelRequire("8WfxO");


var $3u0dr = parcelRequire("3u0dr");








var $3jwuS = parcelRequire("3jwuS");


var $6mKj3 = parcelRequire("6mKj3");

const $134d01bd64a6ba9b$export$e43ca933d3c87145 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $134d01bd64a6ba9b$var$getForgeAppsHeight();
        $[0] = t0;
    } else t0 = $[0];
    const [forgeAppsHeight, setForgeAppsHeight] = (0, $cozmU.useState)(t0);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isForgePageBannerFixed = !isLivePage;
    let t1;
    let t2;
    if ($[1] !== isForgePageBannerFixed) {
        t1 = ()=>{
            const listener = (e)=>{
                if ((0, $6mKj3.expVal)("confluence_pgxp_p2m_batch_1", "isEnabled", false)) setForgeAppsHeight(e?.detail?.height ?? 0);
                else setForgeAppsHeight($134d01bd64a6ba9b$var$getForgeAppsHeight());
            };
            if (isForgePageBannerFixed) document.addEventListener("forgePageBannerHeightUpdated", listener);
            return ()=>{
                if (isForgePageBannerFixed) document.removeEventListener("forgePageBannerHeightUpdated", listener);
            };
        };
        t2 = [
            isForgePageBannerFixed
        ];
        $[1] = isForgePageBannerFixed;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== forgeAppsHeight || $[5] !== isForgePageBannerFixed) {
        t3 = {
            isForgePageBannerFixed: isForgePageBannerFixed,
            forgePageBannerHeight: forgeAppsHeight
        };
        $[4] = forgeAppsHeight;
        $[5] = isForgePageBannerFixed;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ()=>{
    const [forgeAppsHeight, setForgeAppsHeight] = (0, $cozmU.useState)($134d01bd64a6ba9b$var$getForgeAppsHeight());
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isForgePageBannerFixed = !isLivePage;
    (0, $cozmU.useEffect)(()=>{
        const listener = (e)=>{
            if ((0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) setForgeAppsHeight(e?.detail?.height ?? 0);
            else setForgeAppsHeight($134d01bd64a6ba9b$var$getForgeAppsHeight());
        };
        if (isForgePageBannerFixed) document.addEventListener('forgePageBannerHeightUpdated', listener);
        return ()=>{
            if (isForgePageBannerFixed) document.removeEventListener('forgePageBannerHeightUpdated', listener);
        };
    }, [
        isForgePageBannerFixed
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        forgePageBannerHeight: forgeAppsHeight
    };
};
const $134d01bd64a6ba9b$var$getForgeAppsHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    getComputedStyle(document.documentElement).getPropertyValue('--forge-page-banner-height')) || 0;
};



var $fyKZ5 = parcelRequire("fyKZ5");

const $2a9f51add9ac11ab$export$7cfa481653c48265 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { atlGeneralWebPanelHeight: atlGeneralWebPanelHeight } = (0, $8WfxO.useATLGeneralWebPanelListener)();
    const { forgePageBannerHeight: forgePageBannerHeight } = (0, $134d01bd64a6ba9b$export$e43ca933d3c87145)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $gqqjz.FlagsStateContainer),
            (0, $1a6Dn.FloatingBannerStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== atlGeneralWebPanelHeight || $[2] !== forgePageBannerHeight || $[3] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t0
        }, (flags, floatingBanners)=>{
            const forgePageBannerHeightFeatureFlagged = forgePageBannerHeight;
            const pageHeaderAndBannerHeight = floatingBanners.getFloatingHeight() + (props.isContentHeaderFixedAtTop ? 55 + atlGeneralWebPanelHeight + forgePageBannerHeightFeatureFlagged : 0);
            const stickyTableHeaderConfig = {
                offsetTop: pageHeaderAndBannerHeight,
                defaultScrollRootId_DO_NOT_USE: "AkMainContent",
                shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: true
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fyKZ5.ADFRendererComponent), {
                flags: flags,
                ...stickyTableHeaderConfig,
                ...props
            });
        });
        $[1] = atlGeneralWebPanelHeight;
        $[2] = forgePageBannerHeight;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
});
$2a9f51add9ac11ab$export$7cfa481653c48265.displayName = 'ADFRenderer';
module.exports["ADFRenderer"] = $2a9f51add9ac11ab$export$7cfa481653c48265;

});

parcelRegister("fyKZ5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eNbr2 = parcelRequire("eNbr2");


var $kwzZh = parcelRequire("kwzZh");


var $3BY7M = parcelRequire("3BY7M");


var $iDrrr = parcelRequire("iDrrr");


var $lTECB = parcelRequire("lTECB");


var $lJlG6 = parcelRequire("lJlG6");


var $7VJPz = parcelRequire("7VJPz");


var $fgQGl = parcelRequire("fgQGl");


var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");


var $hSHWm = parcelRequire("hSHWm");





var $hjUDQ = parcelRequire("hjUDQ");


var $5KWZf = parcelRequire("5KWZf");


var $dBD3L = parcelRequire("dBD3L");


var $KDPGa = parcelRequire("KDPGa");


var $bQmwQ = parcelRequire("bQmwQ");


var $gXR7h = parcelRequire("gXR7h");


var $jmjWc = parcelRequire("jmjWc");


var $9MYUp = parcelRequire("9MYUp");


var $cbvYp = parcelRequire("cbvYp");


const $044598a12ce14eec$export$b55cedbe49066c7 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lL-x8",
    name: "CardsExtensionLoader",
    loader: async ()=>(await (parcelRequire("cFFVb"))).CardsExtension
});

const $044598a12ce14eec$var$PlatformSpotlightExtensionLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "d8j05",
    name: "PlatformSpotlightExtensionLoader",
    loader: async ()=>(await (parcelRequire("8y9pg"))).SpotlightExtension
});

const $044598a12ce14eec$var$PlatformSearchExtensionLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "24LHW",
    name: "PlatformSearchExtensionLoader",
    loader: async ()=>(await (parcelRequire("dLAmc"))).CustomSearchExtension
});

const $044598a12ce14eec$var$LinksMenuLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "khj-w",
    name: "LinksMenuLoader",
    loader: async ()=>(await (parcelRequire("gO7sx"))).LinksMenu
});

const $044598a12ce14eec$var$CarouselLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iP7CN",
    name: "CarouselLoader",
    loader: async ()=>(await (parcelRequire("hxrh7"))).Carousel
});
const $044598a12ce14eec$export$2a3fa2b29e6e4046 = ({ contentId: contentId })=>{
    const extensionHandlers = {
        [(0, $dBD3L.CARDS_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        [(0, $gXR7h.carouselExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        [(0, $bQmwQ.LINKS_MENU_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        [(0, $9MYUp.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        [(0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        [(0, $KDPGa.SEARCH_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    };
    if (contentId) {
        extensionHandlers[0, $dBD3L.CARDS_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($044598a12ce14eec$export$b55cedbe49066c7, {
                extensionNode: extension,
                contentId: contentId,
                mode: (0, $hjUDQ.ExtensionMode).RENDERER,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $gXR7h.carouselExtensionType] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($044598a12ce14eec$var$CarouselLoader, {
                extensionNode: extension,
                contentId: contentId,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $bQmwQ.LINKS_MENU_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($044598a12ce14eec$var$LinksMenuLoader, {
                mode: (0, $hjUDQ.ExtensionMode).RENDERER,
                extensionNode: extension,
                contentId: contentId,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($044598a12ce14eec$var$PlatformSpotlightExtensionLoader, {
                contentId: contentId,
                extensionNode: extension,
                mode: (0, $hjUDQ.ExtensionMode).RENDERER,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $9MYUp.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE] = ()=>null;
        extensionHandlers[0, $KDPGa.SEARCH_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($044598a12ce14eec$var$PlatformSearchExtensionLoader, {
                mode: (0, $hjUDQ.ExtensionMode).RENDERER,
                contentId: contentId,
                extensionNode: extension,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
    }
    return extensionHandlers;
};



var $7BsWq = parcelRequire("7BsWq");


var $brsfB = parcelRequire("brsfB");






const $5523d8b8240ba692$export$cde76c461119a84c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "31jfw",
    name: "LazySmartlinkAuthNudge",
    loader: async ()=>(await (parcelRequire("3XJlr"))).SmartlinkAuthNudge
});



var $gXrHX = parcelRequire("gXrHX");


var $1SPMi = parcelRequire("1SPMi");


var $yuV6Z = parcelRequire("yuV6Z");


var $8pcS0 = parcelRequire("8pcS0");


var $kLzei = parcelRequire("kLzei");


var $hMB4W = parcelRequire("hMB4W");


var $iP9x4 = parcelRequire("iP9x4");


var $3WO8q = parcelRequire("3WO8q");

var $gxhb8 = parcelRequire("gxhb8");


var $dtVue = parcelRequire("dtVue");


var $4IoVL = parcelRequire("4IoVL");


var $32x2E = parcelRequire("32x2E");


var $8WQTF = parcelRequire("8WQTF");


var $jyPfN = parcelRequire("jyPfN");


var $7W8i8 = parcelRequire("7W8i8");



var $ep3mz = parcelRequire("ep3mz");


var $cD1qu = parcelRequire("cD1qu");


var $gj42z = parcelRequire("gj42z");


var $4GlQ9 = parcelRequire("4GlQ9");


var $dPJCf = parcelRequire("dPJCf");


var $4o1RV = parcelRequire("4o1RV");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $e4o8D = parcelRequire("e4o8D");


var $6M71K = parcelRequire("6M71K");


var $6GQtz = parcelRequire("6GQtz");


var $dXIrr = parcelRequire("dXIrr");


var $9Eka4 = parcelRequire("9Eka4");


var $BjpgS = parcelRequire("BjpgS");


var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");





var $9wGTI = parcelRequire("9wGTI");


var $8wppk = parcelRequire("8wppk");














var $cVuzC = parcelRequire("cVuzC");


var $jKlwt = parcelRequire("jKlwt");


var $l07HN = parcelRequire("l07HN");





var $hmRc4 = parcelRequire("hmRc4");


var $3jwuS = parcelRequire("3jwuS");





var $1JyKZ = parcelRequire("1JyKZ");


var $aF5bm = parcelRequire("aF5bm");


var $iop2R = parcelRequire("iop2R");


var $8z3oB = parcelRequire("8z3oB");

const $2c8591f62b6cc876$var$toInternalModalState = (raw)=>{
    const extension = raw.extension;
    if (!extension) return null;
    const onClose = typeof raw.onClose === 'function' ? raw.onClose : undefined;
    return {
        resource: raw.resource ?? undefined,
        size: raw.size,
        context: raw.context,
        closeOnEscape: raw.closeOnEscape,
        closeOnOverlayClick: raw.closeOnOverlayClick,
        onClose: onClose,
        title: raw.title,
        icon: raw.icon,
        embeddedMacroLocalId: raw.embeddedMacroLocalId,
        extension: extension,
        extensionData: raw.extensionData ?? undefined,
        extensionPayload: raw.extensionPayload ?? undefined,
        isEmbeddedMacroModal: Boolean(raw.isEmbeddedMacroModal)
    };
};
const $2c8591f62b6cc876$export$3f2ad537c77fda12 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { payload: payload, flags: flags, onDismiss: onDismiss } = t0;
    let t1;
    bb0: {
        if (!payload) {
            t1 = false;
            break bb0;
        }
        const state = $2c8591f62b6cc876$var$toInternalModalState(payload);
        t1 = Boolean(state?.extension);
    }
    const canRenderModal = t1;
    if (!payload || !canRenderModal) return null;
    let t2;
    if ($[0] !== flags || $[1] !== onDismiss || $[2] !== payload) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c8591f62b6cc876$var$EmbeddedForgeMacroModalInner, {
            payload: payload,
            flags: flags,
            onDismiss: onDismiss
        });
        $[0] = flags;
        $[1] = onDismiss;
        $[2] = payload;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ payload: payload, flags: flags, onDismiss: onDismiss })=>{
    const canRenderModal = (0, $cozmU.useMemo)(()=>{
        if (!payload) return false;
        const state = $2c8591f62b6cc876$var$toInternalModalState(payload);
        return Boolean(state?.extension);
    }, [
        payload
    ]);
    if (!payload || !canRenderModal) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c8591f62b6cc876$var$EmbeddedForgeMacroModalInner, {
        payload: payload,
        flags: flags,
        onDismiss: onDismiss
    });
};
const $2c8591f62b6cc876$var$EmbeddedForgeMacroModalInner = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(95);
    const { payload: payload, flags: flags, onDismiss: onDismiss } = t0;
    let t1;
    if ($[0] !== payload) {
        t1 = $2c8591f62b6cc876$var$toInternalModalState(payload);
        $[0] = payload;
        $[1] = t1;
    } else t1 = $[1];
    const modalOptions = t1;
    const { cloudId: cloudId, environment: environment, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const workspaceARI = (0, $aF5bm.useWorkspaceARI)();
    let t2;
    if ($[2] !== workspaceARI) {
        t2 = [
            workspaceARI
        ];
        $[2] = workspaceARI;
        $[3] = t2;
    } else t2 = $[3];
    const contextIds = t2;
    const [isReducedMotion, setIsReducedMotion] = (0, $cozmU.useState)(false);
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (typeof window === "undefined") return;
            const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
            setIsReducedMotion(mq.matches);
            const onChange = ()=>setIsReducedMotion(mq.matches);
            mq.addEventListener("change", onChange);
            return ()=>mq.removeEventListener("change", onChange);
        };
        t4 = [];
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[6] !== flags) {
        t5 = (0, $8z3oB.getFlagProvider)(flags);
        $[6] = flags;
        $[7] = t5;
    } else t5 = $[7];
    const { showFlag: showFlag, closeFlag: closeFlag } = t5;
    const baseExtension = modalOptions?.extension;
    modalOptions?.extensionData;
    let t6;
    if ($[8] !== modalOptions?.extensionData) {
        t6 = modalOptions?.extensionData || {};
        $[8] = modalOptions?.extensionData;
        $[9] = t6;
    } else t6 = $[9];
    const baseExtensionData = t6;
    let t7;
    if ($[10] !== baseExtensionData.content || $[11] !== isLivePage) {
        t7 = baseExtensionData.content ? {
            ...baseExtensionData.content,
            subtype: isLivePage ? "live" : null
        } : undefined;
        $[10] = baseExtensionData.content;
        $[11] = isLivePage;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== baseExtensionData || $[14] !== t7) {
        t8 = {
            ...baseExtensionData,
            content: t7
        };
        $[13] = baseExtensionData;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    const updatedExtensionData = t8;
    const t9 = baseExtension;
    const t10 = modalOptions?.embeddedMacroLocalId;
    let t11;
    if ($[16] !== contextIds || $[17] !== t10 || $[18] !== t9 || $[19] !== updatedExtensionData) {
        t11 = {
            extension: t9,
            extensionData: updatedExtensionData,
            localId: t10,
            contextIds: contextIds,
            cachingEnabled: true
        };
        $[16] = contextIds;
        $[17] = t10;
        $[18] = t9;
        $[19] = updatedExtensionData;
        $[20] = t11;
    } else t11 = $[20];
    const getContextTokenHandler = (0, $1JyKZ.useGetContextToken)(t11);
    const [viewOnClose, setViewOnClose] = (0, $cozmU.useState)();
    modalOptions?.embeddedMacroLocalId;
    let t12;
    bb0: {
        if (!baseExtension) {
            t12 = undefined;
            break bb0;
        }
        const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = baseExtension;
        const t13 = modalOptions?.embeddedMacroLocalId || extensionId;
        let t14;
        if ($[21] !== cloudId || $[22] !== environmentId || $[23] !== environmentType || $[24] !== t13) {
            t14 = {
                workspaceId: undefined,
                cloudId: cloudId,
                localId: t13,
                environmentId: environmentId,
                environmentType: environmentType
            };
            $[21] = cloudId;
            $[22] = environmentId;
            $[23] = environmentType;
            $[24] = t13;
            $[25] = t14;
        } else t14 = $[25];
        t12 = t14;
    }
    const coreData = t12;
    let t13;
    if ($[26] !== baseExtension?.properties?.title) {
        t13 = ()=>({
                ThreeLOPrompt: (0, $cVuzC.makeThreeLOPromptForCustomUI)({
                    appName: baseExtension?.properties?.title ?? "",
                    onSuccess: $2c8591f62b6cc876$var$_temp
                })
            });
        $[26] = baseExtension?.properties?.title;
        $[27] = t13;
    } else t13 = $[27];
    baseExtension?.properties?.title;
    const getThreeLOPrompt = t13;
    const onCloseFromModalClass = modalOptions?.onClose;
    let t14;
    if ($[28] !== coreData || $[29] !== modalOptions) {
        t14 = modalOptions?.isEmbeddedMacroModal && modalOptions && coreData ? {
            extensionPayload: modalOptions.extensionPayload,
            extensionViewData: undefined,
            coreData: {
                ...coreData,
                localId: modalOptions.embeddedMacroLocalId || ""
            }
        } : {};
        $[28] = coreData;
        $[29] = modalOptions;
        $[30] = t14;
    } else t14 = $[30];
    const embeddedMacroModalProps = t14;
    let t15;
    bb1: {
        if (!coreData || !baseExtension || !modalOptions) {
            t15 = null;
            break bb1;
        }
        const t16 = userId || undefined;
        let t17;
        if ($[31] !== baseExtension || $[32] !== contextIds || $[33] !== coreData || $[34] !== embeddedMacroModalProps || $[35] !== getContextTokenHandler || $[36] !== getThreeLOPrompt || $[37] !== locale || $[38] !== modalOptions.extensionPayload || $[39] !== t16 || $[40] !== updatedExtensionData) {
            t17 = {
                accountId: t16,
                components: getThreeLOPrompt,
                contextIds: contextIds,
                coreData: coreData,
                customBridgeMethods: undefined,
                extension: baseExtension,
                extensionData: updatedExtensionData,
                extensionPayload: modalOptions.extensionPayload,
                extensionViewData: undefined,
                getContextToken: getContextTokenHandler,
                isHidden: false,
                isResizable: false,
                locale: locale,
                timezone: undefined,
                loadingComponent: undefined,
                isEmbeddedMacro: false,
                embeddedParentLocalId: undefined,
                embeddedMacroModalProps: embeddedMacroModalProps
            };
            $[31] = baseExtension;
            $[32] = contextIds;
            $[33] = coreData;
            $[34] = embeddedMacroModalProps;
            $[35] = getContextTokenHandler;
            $[36] = getThreeLOPrompt;
            $[37] = locale;
            $[38] = modalOptions.extensionPayload;
            $[39] = t16;
            $[40] = updatedExtensionData;
            $[41] = t17;
        } else t17 = $[41];
        t15 = t17;
    }
    const iframeProps = t15;
    let t16;
    bb2: {
        if (!iframeProps) {
            t16 = null;
            break bb2;
        }
        t16 = {
            ...iframeProps,
            ...embeddedMacroModalProps
        };
    }
    const modalIframeProps = t16;
    let t17;
    bb3: {
        if (!modalOptions || !baseExtension) {
            t17 = baseExtension;
            break bb3;
        }
        let t18;
        if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
            t18 = {};
            $[42] = t18;
        } else t18 = $[42];
        let resourceOverride = t18;
        if (modalOptions?.resource) {
            let t19;
            if ($[43] !== modalOptions.resource) {
                t19 = (0, $9wGTI.fg)("forge-ui-multi-entry-resource-macro-config-fix") ? (0, $l07HN.resolveDynamicResource)(modalOptions.resource) : {
                    resource: modalOptions.resource
                };
                $[43] = modalOptions.resource;
                $[44] = t19;
            } else t19 = $[44];
            resourceOverride = t19;
        }
        const t19 = `${baseExtension.type}::dynamic-modal`;
        let t20;
        if ($[45] !== baseExtension.properties || $[46] !== resourceOverride) {
            t20 = {
                ...baseExtension.properties,
                ...resourceOverride
            };
            $[45] = baseExtension.properties;
            $[46] = resourceOverride;
            $[47] = t20;
        } else t20 = $[47];
        let t21;
        if ($[48] !== baseExtension || $[49] !== t19 || $[50] !== t20) {
            t21 = {
                ...baseExtension,
                type: t19,
                properties: t20
            };
            $[48] = baseExtension;
            $[49] = t19;
            $[50] = t20;
            $[51] = t21;
        } else t21 = $[51];
        t17 = t21;
    }
    const extensionInModal = t17;
    let t18;
    bb4: {
        if (!modalOptions || !baseExtension) {
            t18 = updatedExtensionData;
            break bb4;
        }
        const base = modalOptions.extensionData || updatedExtensionData;
        let t19;
        if ($[52] !== modalOptions.context) {
            t19 = modalOptions.context ? {
                modal: modalOptions.context
            } : {};
            $[52] = modalOptions.context;
            $[53] = t19;
        } else t19 = $[53];
        let t20;
        if ($[54] !== baseExtension.type || $[55] !== modalOptions.context) {
            t20 = baseExtension.type.startsWith("jiraServiceManagement") && modalOptions.context ? {
                ...modalOptions.context
            } : {};
            $[54] = baseExtension.type;
            $[55] = modalOptions.context;
            $[56] = t20;
        } else t20 = $[56];
        let t21;
        if ($[57] !== base || $[58] !== t19 || $[59] !== t20) {
            t21 = {
                ...base,
                ...t19,
                ...t20
            };
            $[57] = base;
            $[58] = t19;
            $[59] = t20;
            $[60] = t21;
        } else t21 = $[60];
        t18 = t21;
    }
    const extensionDataInModal = t18;
    let t19;
    if ($[61] !== onDismiss) {
        t19 = ()=>{
            onDismiss();
        };
        $[61] = onDismiss;
        $[62] = t19;
    } else t19 = $[62];
    const handleModalTearDown = t19;
    let t20;
    if ($[63] !== handleModalTearDown || $[64] !== isReducedMotion || $[65] !== onCloseFromModalClass) {
        t20 = ()=>{
            onCloseFromModalClass?.();
            if (isReducedMotion) handleModalTearDown();
        };
        $[63] = handleModalTearDown;
        $[64] = isReducedMotion;
        $[65] = onCloseFromModalClass;
        $[66] = t20;
    } else t20 = $[66];
    const handleModalClose = t20;
    let t21;
    let t22;
    if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = (0, $hmRc4.getBrowserHistory)();
        t22 = (callback)=>{
            setViewOnClose(()=>callback.data);
            return true;
        };
        $[67] = t21;
        $[68] = t22;
    } else {
        t21 = $[67];
        t22 = $[68];
    }
    let t23;
    if ($[69] !== onCloseFromModalClass) {
        t23 = (closePayload)=>{
            onCloseFromModalClass?.(closePayload?.data);
            return true;
        };
        $[69] = onCloseFromModalClass;
        $[70] = t23;
    } else t23 = $[70];
    let t24;
    if ($[71] !== closeFlag || $[72] !== showFlag || $[73] !== t23) {
        t24 = {
            showFlag: showFlag,
            closeFlag: closeFlag,
            history: t21,
            onClose: t22,
            close: t23
        };
        $[71] = closeFlag;
        $[72] = showFlag;
        $[73] = t23;
        $[74] = t24;
    } else t24 = $[74];
    const bridge = t24;
    if (!modalOptions || !baseExtension || !iframeProps || !modalIframeProps) return null;
    const t25 = modalOptions.embeddedMacroLocalId ?? baseExtension.id;
    const t26 = modalOptions.size;
    const t27 = modalOptions.title;
    const t28 = modalOptions.icon;
    const t29 = modalOptions.closeOnEscape;
    const t30 = modalOptions.closeOnOverlayClick;
    let t31;
    if ($[75] !== cloudId || $[76] !== environment || $[77] !== userId) {
        t31 = (0, $iop2R.getMentionProvider)(cloudId, environment, userId);
        $[75] = cloudId;
        $[76] = environment;
        $[77] = userId;
        $[78] = t31;
    } else t31 = $[78];
    let t32;
    if ($[79] !== bridge || $[80] !== extensionDataInModal || $[81] !== extensionInModal || $[82] !== getThreeLOPrompt || $[83] !== handleModalClose || $[84] !== handleModalTearDown || $[85] !== iframeProps || $[86] !== modalOptions.closeOnEscape || $[87] !== modalOptions.closeOnOverlayClick || $[88] !== modalOptions.icon || $[89] !== modalOptions.size || $[90] !== modalOptions.title || $[91] !== t25 || $[92] !== t31 || $[93] !== viewOnClose) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKlwt.ModalCustomUIRenderer), {
            ...iframeProps,
            product: "confluence",
            getThreeLOPrompt: getThreeLOPrompt,
            extension: extensionInModal,
            extensionData: extensionDataInModal,
            localId: t25,
            onTearDown: handleModalTearDown,
            bridge: bridge,
            modalOnClose: handleModalClose,
            size: t26,
            title: t27,
            icon: t28,
            closeOnEscape: t29,
            closeOnOverlayClick: t30,
            getModalWidth: undefined,
            isIframeResizable: false,
            viewOnClose: viewOnClose,
            mentionProvider: t31
        });
        $[79] = bridge;
        $[80] = extensionDataInModal;
        $[81] = extensionInModal;
        $[82] = getThreeLOPrompt;
        $[83] = handleModalClose;
        $[84] = handleModalTearDown;
        $[85] = iframeProps;
        $[86] = modalOptions.closeOnEscape;
        $[87] = modalOptions.closeOnOverlayClick;
        $[88] = modalOptions.icon;
        $[89] = modalOptions.size;
        $[90] = modalOptions.title;
        $[91] = t25;
        $[92] = t31;
        $[93] = viewOnClose;
        $[94] = t32;
    } else t32 = $[94];
    return t32;
} : ({ payload: payload, flags: flags, onDismiss: onDismiss })=>{
    const modalOptions = (0, $cozmU.useMemo)(()=>$2c8591f62b6cc876$var$toInternalModalState(payload), [
        payload
    ]);
    const { cloudId: cloudId, environment: environment, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const workspaceARI = (0, $aF5bm.useWorkspaceARI)();
    const contextIds = (0, $cozmU.useMemo)(()=>[
            workspaceARI
        ], [
        workspaceARI
    ]);
    const [isReducedMotion, setIsReducedMotion] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        setIsReducedMotion(mq.matches);
        const onChange = ()=>setIsReducedMotion(mq.matches);
        mq.addEventListener('change', onChange);
        return ()=>mq.removeEventListener('change', onChange);
    }, []);
    const { showFlag: showFlag, closeFlag: closeFlag } = (0, $8z3oB.getFlagProvider)(flags);
    const baseExtension = modalOptions?.extension;
    const updatedExtensionData = (0, $cozmU.useMemo)(()=>{
        const baseExtensionData = modalOptions?.extensionData || {};
        return {
            ...baseExtensionData,
            content: baseExtensionData.content ? {
                ...baseExtensionData.content,
                subtype: isLivePage ? 'live' : null
            } : undefined
        };
    }, [
        isLivePage,
        modalOptions?.extensionData
    ]);
    const getContextTokenHandler = (0, $1JyKZ.useGetContextToken)({
        extension: baseExtension,
        extensionData: updatedExtensionData,
        localId: modalOptions?.embeddedMacroLocalId,
        contextIds: contextIds,
        cachingEnabled: true
    });
    const [viewOnClose, setViewOnClose] = (0, $cozmU.useState)();
    const coreData = (0, $cozmU.useMemo)(()=>{
        if (!baseExtension) return undefined;
        const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = baseExtension;
        return {
            workspaceId: undefined,
            cloudId: cloudId,
            localId: modalOptions?.embeddedMacroLocalId || extensionId,
            environmentId: environmentId,
            environmentType: environmentType
        };
    }, [
        baseExtension,
        cloudId,
        modalOptions?.embeddedMacroLocalId
    ]);
    const getThreeLOPrompt = (0, $cozmU.useCallback)(()=>{
        return {
            ThreeLOPrompt: (0, $cVuzC.makeThreeLOPromptForCustomUI)({
                appName: baseExtension?.properties?.title ?? '',
                onSuccess: ()=>{}
            })
        };
    }, [
        baseExtension?.properties?.title
    ]);
    const onCloseFromModalClass = modalOptions?.onClose;
    // Memoised so the object identity is stable across renders. Without this,
    // every render produces a fresh `{}` and any downstream useMemo that lists
    // `embeddedMacroModalProps` in its deps would invalidate on every render.
    const embeddedMacroModalProps = (0, $cozmU.useMemo)(()=>modalOptions?.isEmbeddedMacroModal && modalOptions && coreData ? {
            extensionPayload: modalOptions.extensionPayload,
            extensionViewData: undefined,
            coreData: {
                ...coreData,
                localId: modalOptions.embeddedMacroLocalId || ''
            }
        } : {}, [
        coreData,
        modalOptions
    ]);
    const iframeProps = (0, $cozmU.useMemo)(()=>{
        if (!coreData || !baseExtension || !modalOptions) return null;
        return {
            accountId: userId || undefined,
            components: getThreeLOPrompt,
            contextIds: contextIds,
            coreData: coreData,
            customBridgeMethods: undefined,
            extension: baseExtension,
            extensionData: updatedExtensionData,
            extensionPayload: modalOptions.extensionPayload,
            extensionViewData: undefined,
            getContextToken: getContextTokenHandler,
            isHidden: false,
            isResizable: false,
            locale: locale,
            timezone: undefined,
            loadingComponent: undefined,
            isEmbeddedMacro: false,
            embeddedParentLocalId: undefined,
            embeddedMacroModalProps: embeddedMacroModalProps
        };
    }, [
        baseExtension,
        contextIds,
        coreData,
        getContextTokenHandler,
        getThreeLOPrompt,
        locale,
        modalOptions,
        updatedExtensionData,
        userId,
        embeddedMacroModalProps
    ]);
    const modalIframeProps = (0, $cozmU.useMemo)(()=>{
        if (!iframeProps) return null;
        return {
            ...iframeProps,
            ...embeddedMacroModalProps
        };
    }, [
        embeddedMacroModalProps,
        iframeProps
    ]);
    const extensionInModal = (0, $cozmU.useMemo)(()=>{
        if (!modalOptions || !baseExtension) return baseExtension;
        // `openModal`'s resource is optional; only override when one is explicitly provided. When it is
        // omitted the modal defaults to the current resource, so we inherit it (and its entry) untouched.
        let resourceOverride = {};
        if (modalOptions?.resource) resourceOverride = (0, $9wGTI.fg)('forge-ui-multi-entry-resource-macro-config-fix') ? (0, $l07HN.resolveDynamicResource)(modalOptions.resource) : {
            resource: modalOptions.resource
        };
        return {
            ...baseExtension,
            type: `${baseExtension.type}::dynamic-modal`,
            properties: {
                ...baseExtension.properties,
                ...resourceOverride
            }
        };
    }, [
        baseExtension,
        modalOptions
    ]);
    const extensionDataInModal = (0, $cozmU.useMemo)(()=>{
        if (!modalOptions || !baseExtension) return updatedExtensionData;
        const base = modalOptions.extensionData || updatedExtensionData;
        return {
            ...base,
            ...modalOptions.context ? {
                modal: modalOptions.context
            } : {},
            ...baseExtension.type.startsWith('jiraServiceManagement') && modalOptions.context ? {
                ...modalOptions.context
            } : {}
        };
    }, [
        baseExtension,
        modalOptions,
        updatedExtensionData
    ]);
    const handleModalTearDown = (0, $cozmU.useCallback)(()=>{
        onDismiss();
    }, [
        onDismiss
    ]);
    const handleModalClose = (0, $cozmU.useCallback)(()=>{
        onCloseFromModalClass?.();
        if (isReducedMotion) handleModalTearDown();
    }, [
        handleModalTearDown,
        isReducedMotion,
        onCloseFromModalClass
    ]);
    const bridge = (0, $cozmU.useMemo)(()=>({
            showFlag: showFlag,
            closeFlag: closeFlag,
            history: (0, $hmRc4.getBrowserHistory)(),
            onClose: (callback)=>{
                setViewOnClose(()=>callback.data);
                return true;
            },
            close: (closePayload)=>{
                onCloseFromModalClass?.(closePayload?.data);
                return true;
            }
        }), [
        closeFlag,
        onCloseFromModalClass,
        showFlag
    ]);
    if (!modalOptions || !baseExtension || !iframeProps || !modalIframeProps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKlwt.ModalCustomUIRenderer), {
        ...iframeProps,
        product: "confluence",
        getThreeLOPrompt: getThreeLOPrompt,
        extension: extensionInModal,
        extensionData: extensionDataInModal,
        localId: modalOptions.embeddedMacroLocalId ?? baseExtension.id,
        onTearDown: handleModalTearDown,
        bridge: bridge,
        modalOnClose: handleModalClose,
        size: modalOptions.size,
        title: modalOptions.title,
        icon: modalOptions.icon,
        closeOnEscape: modalOptions.closeOnEscape,
        closeOnOverlayClick: modalOptions.closeOnOverlayClick,
        getModalWidth: undefined,
        isIframeResizable: false,
        viewOnClose: viewOnClose,
        mentionProvider: (0, $iop2R.getMentionProvider)(cloudId, environment, userId)
    });
};
function $2c8591f62b6cc876$var$_temp() {}


const $bb91119414a4e358$export$d8ebe500960648d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { document: document, flags: flags } = t0;
    const [openModalPayload, setOpenModalPayload] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (payload)=>{
            setOpenModalPayload(payload);
        };
        $[0] = t1;
    } else t1 = $[0];
    const onEmbeddedForgeOpenModal = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setOpenModalPayload(null);
        };
        $[1] = t2;
    } else t2 = $[1];
    const dismissOpenModal = t2;
    let t3;
    let t4;
    if ($[2] !== document || $[3] !== flags) {
        t3 = ()=>{
            if (!document || !(0, $9wGTI.fg)("forge_nbm_connect_to_forge_bridge")) return;
            return (0, $8wppk.registerEmbeddedMacroListeners)(document, flags, {
                onEmbeddedForgeOpenModal: onEmbeddedForgeOpenModal
            });
        };
        t4 = [
            document,
            flags,
            onEmbeddedForgeOpenModal
        ];
        $[2] = document;
        $[3] = flags;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[6] !== flags || $[7] !== openModalPayload) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c8591f62b6cc876$export$3f2ad537c77fda12), {
            payload: openModalPayload,
            flags: flags,
            onDismiss: dismissOpenModal
        });
        $[6] = flags;
        $[7] = openModalPayload;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ document: document, flags: flags })=>{
    const [openModalPayload, setOpenModalPayload] = (0, $cozmU.useState)(null);
    const onEmbeddedForgeOpenModal = (0, $cozmU.useCallback)((payload)=>{
        setOpenModalPayload(payload);
    }, []);
    const dismissOpenModal = (0, $cozmU.useCallback)(()=>{
        setOpenModalPayload(null);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!document || !(0, $9wGTI.fg)('forge_nbm_connect_to_forge_bridge')) return;
        return (0, $8wppk.registerEmbeddedMacroListeners)(document, flags, {
            onEmbeddedForgeOpenModal: onEmbeddedForgeOpenModal
        });
    }, [
        document,
        flags,
        onEmbeddedForgeOpenModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c8591f62b6cc876$export$3f2ad537c77fda12), {
        payload: openModalPayload,
        flags: flags,
        onDismiss: dismissOpenModal
    });
};






var $6Trhx = parcelRequire("6Trhx");


var $edEsl = parcelRequire("edEsl");


var $04e9M = parcelRequire("04e9M");


var $eXfot = parcelRequire("eXfot");


var $6s78L = parcelRequire("6s78L");

async function $ad68e9e7df73622d$export$ee66267d3930a21(contentId, batch) {
    const updateBatch = batch.map((update)=>{
        const { objectKey: objectKey, state: state } = update;
        const status = state === 'DONE' ? 'CHECKED' : 'UNCHECKED';
        return {
            taskId: objectKey.localId,
            status: status
        };
    });
    const taskBatch = {
        contentId: contentId,
        tasks: updateBatch,
        trigger: 'VIEW_PAGE'
    };
    try {
        return await (0, $6s78L.mutateInterop)({
            mutation: (0, $eXfot.SetBatchedTaskStatusMutation),
            variables: taskBatch,
            __callerPackage__: "adf-renderer"
        });
    } catch (error) {
        const client = await (0, $04e9M.getAnalyticsWebClient)();
        client.sendOperationalEvent({
            source: 'page',
            action: 'batchTaskUpdate',
            actionSubject: 'checkbox',
            attributes: {
                error: error.message || String(error),
                stack: error.stack
            }
        });
    }
}















const $05271241466f5e2e$var$ViewPageAttachmentForgeActionsPortalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "26C7v",
    name: "ViewPageAttachmentForgeActionsPortalLoader",
    loader: async ()=>(await (parcelRequire("5IQv3"))).ViewPageAttachmentForgeActionsPortal
});
$05271241466f5e2e$var$ViewPageAttachmentForgeActionsPortalLoader.displayName = 'lazy(ViewPageAttachmentForgeActionsPortal)';
const $05271241466f5e2e$export$b8cbd42b7b7bd9d2 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { contentId: contentId, contentType: contentType, isViewPage: isViewPage, spaceKey: spaceKey } = t0;
    if (!isViewPage || !contentId || !spaceKey || !contentType || !(0, $9wGTI.fg)("forge_attachment_display_conditions")) return null;
    let t1;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== isViewPage || $[3] !== spaceKey) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($05271241466f5e2e$var$ViewPageAttachmentForgeActionsPortalLoader, {
            contentId: contentId,
            contentType: contentType,
            isViewPage: isViewPage,
            spaceKey: spaceKey
        });
        $[0] = contentId;
        $[1] = contentType;
        $[2] = isViewPage;
        $[3] = spaceKey;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};



var $1P2f3 = parcelRequire("1P2f3");

const $1af8a83cb114ff50$var$EXTENSION_KEYS_TO_HIDE_WHILE_PENDING = [
    (0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS
];
const $1af8a83cb114ff50$export$3422b9c70e187e34 = {
    enabled: true,
    severityDegradedThreshold: 4747,
    severityNormalThreshold: 3775
};
const $1af8a83cb114ff50$var$logger = (0, $7W8i8.getLogger)('ADFRenderer');
const $1af8a83cb114ff50$export$c02e908ea3c1fe52 = {
    enabled: true,
    thresholds: {
        blocking: 1.5,
        degraded: 1
    }
};
const $1af8a83cb114ff50$var$mergeDataProviders = ({ hasViewUserProfilePermission: hasViewUserProfilePermission, handleActionToggle: handleActionToggle, handleInviteItemClick: handleInviteItemClick, getDataProviders: getDataProviders, providerFactory: providerFactory, isExternalShare: isExternalShare, contentId: contentId, spaceKey: spaceKey, pageContextContentId: pageContextContentId, cloudId: cloudId, userId: userId, userRole: userRole, flags: flags, profilecardProvider: profilecardProvider, intl: intl, mediaToken: mediaToken, emojiResourceParams: emojiResourceParams })=>{
    const providers = {};
    if (getDataProviders) Object.assign(providers, getDataProviders());
    if (contentId || mediaToken) {
        providers.mediaProvider = (0, $4IoVL.createRendererMediaProvider)({
            contentId: contentId,
            spaceKey: spaceKey,
            mediaDspContentId: pageContextContentId,
            isExternalShare: isExternalShare,
            mediaToken: mediaToken
        });
        providers.taskDecisionProvider = Promise.resolve(new (0, $3WO8q.ConfluenceTaskDecisionProvider)(intl, flags, contentId, handleActionToggle));
    }
    if (cloudId && userId) providers.mentionProvider = (0, $dtVue.createMentionsConfig)(cloudId, userId, undefined, undefined, handleInviteItemClick, userRole).then((config)=>config.mentionResource).catch((err)=>{
        if ($1P2f3.env.NODE_ENV !== 'production') $1af8a83cb114ff50$var$logger.error`Failed to initialise mention resource ${err}`;
        return Promise.reject();
    });
    if (emojiResourceParams && cloudId) providers.emojiProvider = (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
    if (cloudId) // If global view user profile is enabled then user can view profile card
    {
        if (hasViewUserProfilePermission) providers.profilecardProvider = profilecardProvider;
    }
    if (contentId && spaceKey) providers.contextIdentifierProvider = Promise.resolve({
        containerId: spaceKey,
        objectId: contentId,
        product: 'confluence'
    });
    providers.cardProvider = Promise.resolve(new (0, $6GQtz.ConfluenceEditorCardProvider)());
    const keys = Object.keys(providers);
    if (keys.length) {
        providerFactory = providerFactory || (0, $eNbr2.default).create({});
        for (const provider of Object.keys(providers))providerFactory.setProvider(provider, providers[provider]);
    }
    return {
        providerFactory: providerFactory,
        providers: providers
    };
};
const $1af8a83cb114ff50$var$projectLinkerHandlers = {
    'com.atlassian.confluence.project-linker': ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
};
const $1af8a83cb114ff50$export$58eac04eb6213951 = ()=>(0, $iDrrr.fg)('platform_renderer_unsupported_content_tracking') ? $1af8a83cb114ff50$export$c02e908ea3c1fe52 : undefined;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS = {};
// `parentProduct` is a query param set by Embedded Confluence hosts (e.g. `?parentProduct=JSM`).
const $1af8a83cb114ff50$var$useParentProduct = (0, $dPJCf.createSingleQueryParamHook)('parentProduct');
const $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS = ()=>$1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES = [];
const $1af8a83cb114ff50$export$cec675c14d32c246 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { document: document, dataProviders: dataProviders, extensionHandlers: extensionHandlers = $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS, getExtensionHandlers: getExtensionHandlers = $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS, eventHandlers: eventHandlers, appearance: appearance, contentMode: contentMode, adfStage: adfStage = 'stage0', portal: portal, onRendered: onRendered, onRendererRendered: onRendererRendered, renderWhenReady: renderWhenReady, allowStickyHeaders: allowStickyHeaders = true, allowPlaceholderText: allowPlaceholderText = false, isTruncatedContent: isTruncatedContent, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, flags: flags, offsetTop: offsetTop, defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE, shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE, mediaToken: mediaToken, onError: onError, UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment = true, UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing = true, UNSTABLE_isPresentational: UNSTABLE_isPresentational = false, extensionViewportSizes: extensionViewportSizes = $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail, allowRendererContainerStyles: allowRendererContainerStyles, pageMode: pageMode, ...rest } = props;
    const intl = (0, $kSwu1.useIntl)();
    const [isTaskToggled, setIsTaskToggled] = (0, $cozmU.useState)(false);
    const initialState = window['__SSR_SMARTLINKS__'];
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const { storeOptions: storeOptions, SuspenseWrapperForUrl: SuspenseWrapperForUrl } = (0, $btIEy.useStoreOptions)(initialState, isPageSSR, {
        useSSRStore: (0, $6mKj3.expVal)('confluence_smartlinks_suspense', 'isEnabled', false)
    });
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const parentProduct = $1af8a83cb114ff50$var$useParentProduct();
    // Fix for HOT-99954 - Issue where embedded pages SSR SmartLinks open in same tab
    const shouldSSRsmartLinks = isPageSSR && !isEmbedded && !(0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags, isLicensed: isLicensed, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled, isHideTitleInUrl: isHideTitleInUrl, timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [pageContextContentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { openCoreInvites: openCoreInvites, userRole: userRole } = (0, $cozmU.useContext)((0, $hSHWm.CoreInvitesContext));
    const [shouldRefetchContent, setShouldRefetchContent] = (0, $cozmU.useState)(false);
    const pendingTaskPatchRef = (0, $cozmU.useRef)({
        states: new Map()
    });
    const flushTaskStatusPatch = (0, $cozmU.useCallback)(()=>{
        const pending = pendingTaskPatchRef.current;
        pendingTaskPatchRef.current = {
            states: new Map()
        };
        return {
            contentId: pending.contentId,
            contentType: pending.contentType,
            spaceKey: pending.spaceKey,
            taskStatusUpdates: Array.from(pending.states, ([localId, state])=>({
                    localId: localId,
                    state: state
                }))
        };
    }, []);
    const contentId = props.contentId || pageContextContentId;
    const contentType = props.contentType || pageContextContentType;
    const spaceKey = props.spaceKey || pageContextSpaceKey;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const taskBatcherRef = (0, $cozmU.useRef)(new (0, $gxhb8.TaskBatcher)((0, $6mKj3.expVal)('confluence_frontend_task_batching_interval', 'value', 3000)));
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    // Handlers for batched task update
    const handleBatchTaskUpdate = (0, $cozmU.useCallback)((batch)=>{
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        (0, $ad68e9e7df73622d$export$ee66267d3930a21)(contentId, batch).then(()=>{
            setIsTaskToggled(false);
            setShouldRefetchContent(true);
        });
    }, [
        contentId,
        setShouldRefetchContent
    ]);
    const handleActionToggle = (0, $cozmU.useCallback)((objectKey, state)=>{
        setIsTaskToggled(true);
        taskBatcherRef.current.add({
            objectKey: objectKey,
            state: state
        });
        // Capture on toggle, not after the batched mutation resolves, so navigating away within
        // the batch interval still reconciles the cache.
        const pending = pendingTaskPatchRef.current;
        pending.contentId = contentId;
        pending.contentType = contentType;
        pending.spaceKey = spaceKey;
        pending.states.set(objectKey.localId, state);
    }, [
        taskBatcherRef,
        contentId,
        contentType,
        spaceKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        // there is a document check - we do not want to call registerGlobalMediaViewedListener
        // with no content
        if (document) (0, $edEsl.registerGlobalMediaViewedListener)({
            contentType: contentType
        });
        onRendered && onRendered();
        taskBatcherRef.current.onFlush(handleBatchTaskUpdate);
        return ()=>{
            if (document) (0, $edEsl.removeGlobalMediaViewedListener)();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        taskBatcherRef,
        handleBatchTaskUpdate
    ]);
    (0, $cozmU.useEffect)(()=>{
        setShouldRefetchContent(false);
    // WS-4098 - When the contentId changes or when we mount we don't need to refetch
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleBeforeUnload = (event)=>{
            if (isTaskToggled) {
                event.preventDefault();
                event.returnValue = ''; // This triggers the alert in all browsers
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTaskToggled,
        contentId
    ]);
    // Setting up emoji resources for ssr and data providers
    const emojiResourceParams = (0, $cozmU.useMemo)(()=>{
        if (cloudId) return (0, $yuV6Z.createEmojiProviderParameters)({
            cloudId: cloudId,
            userId: userId,
            isLicensed: isLicensed,
            isLoggedIn: isLoggedIn,
            onEmojiLoadSuccess: onEmojiLoadSuccess,
            onEmojiLoadFail: onEmojiLoadFail
        });
    }, [
        cloudId,
        userId,
        isLicensed,
        isLoggedIn,
        onEmojiLoadSuccess,
        onEmojiLoadFail
    ]);
    const emojiResourceConfig = (0, $cozmU.useMemo)(()=>{
        if (emojiResourceParams) return (0, $32x2E.getEmojiConfig)(emojiResourceParams.cloudId, emojiResourceParams.userId, emojiResourceParams.disableUpload, emojiResourceParams.emojiSSRConfig, undefined, emojiResourceParams.emojiLoadCallbacks);
    }, [
        emojiResourceParams
    ]);
    const { isExternalShareRequest: isExternalShareRequest } = (0, $cozmU.useContext)((0, $gXrHX.ExternalShareContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const mergedExtensionHandlers = (0, $cozmU.useMemo)(()=>{
        return {
            ...getExtensionHandlers?.(),
            ...extensionHandlers,
            ...(0, $044598a12ce14eec$export$2a3fa2b29e6e4046)({
                contentId: contentId
            }),
            ...(0, $7VJPz.getRendererSmartButtonExtensionHandlers)({
                contentId: contentId,
                contentType: contentType,
                cloudId: cloudId
            }),
            ...$1af8a83cb114ff50$var$projectLinkerHandlers
        };
    }, [
        extensionHandlers,
        getExtensionHandlers,
        contentId,
        contentType,
        cloudId
    ]);
    const mediaSSR = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShareRequest,
        mediaToken: mediaToken
    });
    // -- Matches fabric-feature-flags.ts
    const isStickyHeadersEnabled = allowStickyHeaders;
    const errorHandler = (0, $cozmU.useCallback)((error)=>{
        onError?.(error);
    }, [
        onError
    ]);
    const { shimAdfUrls: shimAdfUrls } = (0, $4o1RV.useNavigationPolicy)();
    const editorFeatureFlags = (0, $7BsWq.useEditorFeatureFlags)();
    const profilecardProvider = (0, $brsfB.useProfilecardProvider)({
        push: push,
        userId: userId,
        cloudId: cloudId,
        featureFlags: featureFlags
    });
    const shouldControlDataExport = (0, $4IoVL.controlDataExportOnCertainFeatures)(window.location.pathname);
    // ----------------------------------
    // When hiding content titles in URLs, also disable heading anchor links to prevent exposing UGC in generated anchor URLs.
    const shouldHideHeadingAnchorLinks = isHideTitleInUrl && (0, $6mKj3.expValEquals)('confluence_hide_content_title_in_url', 'isEnabled', true);
    // When the page is rendered inside a JSM Knowledge Base embed, disable heading anchor links.
    // The "Copy link to heading" affordance links back to Confluence and is not meaningful in the
    // JSM KB context (the article is surfaced under a JSM URL), so it is suppressed there.
    const shouldHideHeadingAnchorLinksForJsmEmbed = isEmbedded && parentProduct === 'JSM' && (0, $6mKj3.expValEquals)('confluence_disable_heading_anchor_jsm_kb_embed', 'isEnabled', true);
    const allowHeadingAnchorLinks = (0, $cozmU.useMemo)(()=>shouldHideHeadingAnchorLinks || shouldHideHeadingAnchorLinksForJsmEmbed ? false : {
            allowNestedHeaderLinks: true,
            activeHeadingId: props.queryHash
        }, [
        props.queryHash,
        shouldHideHeadingAnchorLinks,
        shouldHideHeadingAnchorLinksForJsmEmbed
    ]);
    // Build media viewer extensions to add the comments button to the preview header
    const mediaViewerExtensions = (0, $BjpgS.useMediaCommentExtensions)({
        isViewPage: true,
        analyticsSource: 'viewPageScreen',
        flags: flags
    });
    const fallbackMediaNameFetcher = (0, $cozmU.useMemo)(()=>contentId ? (0, $6Trhx.createFallbackMediaNameFetcher)(contentId) : undefined, [
        contentId
    ]);
    const media = (0, $cozmU.useMemo)(()=>({
            allowLinking: true,
            allowCaptions: true,
            featureFlags: {
                mediaInline: true
            },
            mediaViewerExtensions: mediaViewerExtensions,
            ssr: mediaSSR,
            fallbackMediaNameFetcher: (0, $6mKj3.expVal)('platform_editor_media_name_fallback', 'isEnabled', false) ? fallbackMediaNameFetcher : undefined
        }), [
        mediaSSR,
        mediaViewerExtensions,
        fallbackMediaNameFetcher
    ]);
    const CompetitorPromptWithAppearance = (0, $cozmU.useMemo)(()=>{
        return (competitorPromptProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dXIrr.PromptPopupContainer), {
                ...competitorPromptProps,
                editorAppearance: appearance
            });
    }, [
        appearance
    ]);
    const actionOptions = (0, $cozmU.useMemo)(()=>{
        const isFullPage = appearance === 'full-page' || appearance === 'full-width' || appearance === 'max';
        if (isFullPage) return {
            hide: false,
            rovoChatAction: {
                optIn: true
            }
        };
    }, [
        appearance
    ]);
    const getResolvingPlaceholder = (0, $cozmU.useCallback)((url)=>window.__SSR_SMARTLINKS_TITLES__?.[url], []);
    const smartLinks = (0, $cozmU.useMemo)(()=>({
            ssr: shouldSSRsmartLinks,
            hideHoverPreview: false,
            CompetitorPrompt: CompetitorPromptWithAppearance,
            SuspenseWrapperForUrl: SuspenseWrapperForUrl,
            actionOptions: actionOptions,
            ...(0, $6mKj3.expVal)('confluence_frontend_smartlinks_title_while_loading', 'isEnabled', false) ? {
                getResolvingPlaceholder: getResolvingPlaceholder
            } : undefined
        }), [
        actionOptions,
        shouldSSRsmartLinks,
        CompetitorPromptWithAppearance,
        SuspenseWrapperForUrl,
        getResolvingPlaceholder
    ]);
    const stickyHeaders = (0, $cozmU.useMemo)(()=>isStickyHeadersEnabled ? {
            offsetTop: offsetTop,
            defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE,
            shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
        } : undefined, [
        isStickyHeadersEnabled,
        offsetTop,
        defaultScrollRootId_DO_NOT_USE,
        shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
    ]);
    const mergedDataProviders = (0, $cozmU.useMemo)(()=>$1af8a83cb114ff50$var$mergeDataProviders({
            contentId: // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
            contentId,
            spaceKey: // @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
            spaceKey,
            pageContextContentId: pageContextContentId,
            cloudId: cloudId,
            userId: userId,
            flags: flags,
            featureFlags: featureFlags,
            push: push,
            intl: intl,
            providerFactory: dataProviders,
            profilecardProvider: profilecardProvider,
            isExternalShare: isExternalShareRequest,
            handleActionToggle: handleActionToggle,
            hasViewUserProfilePermission: hasViewUserProfilePermission,
            handleInviteItemClick: openCoreInvites,
            userRole: userRole,
            mediaToken: mediaToken,
            emojiResourceParams: emojiResourceParams
        }), [
        contentId,
        spaceKey,
        pageContextContentId,
        cloudId,
        userId,
        flags,
        featureFlags,
        push,
        intl,
        dataProviders,
        profilecardProvider,
        isExternalShareRequest,
        handleActionToggle,
        hasViewUserProfilePermission,
        openCoreInvites,
        userRole,
        mediaToken,
        emojiResourceParams
    ]);
    const SyncedBlockNodeComponent = (0, $9Eka4.useMemoizedSyncedBlockProviderNodeComponent)({
        doc: document,
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        mergedDataProviderDefinitions: mergedDataProviders.providers,
        // Pass the same sticky header config as the page so tables in synced blocks use
        // the same scroll root (e.g. AkMainContent) and offset — required for sticky to work.
        stickyHeadersConfig: stickyHeaders ?? undefined,
        contentMode: contentMode
    });
    const nodeComponents = (0, $cozmU.useMemo)(()=>{
        if (SyncedBlockNodeComponent) return {
            syncBlock: SyncedBlockNodeComponent
        };
    }, [
        SyncedBlockNodeComponent
    ]);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Store the finalDocument ADF in context so it can be accessed by comment editor
    // and other components (e.g. SmartlinkAuthNudge) without prop threading.
    const { setPageAdf: setPageAdf } = (0, $8WQTF.useRendererActionsDispatch)();
    (0, $cozmU.useEffect)(()=>{
        if (appearance === 'full-page' || appearance === 'full-width' || appearance === 'max') {
            if (document) {
                const finalDocument = shimAdfUrls(document);
                setPageAdf(finalDocument);
            } else setPageAdf(undefined);
        }
    }, [
        appearance,
        document,
        setPageAdf,
        shimAdfUrls
    ]);
    if (!document) return null;
    const finalDocument = shimAdfUrls(document);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1SPMi.RendererAnalyticsListener), {
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        objectId: contentId,
        objectType: contentType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.RendererWithAnalytics), {
        // This flag is used for fixing table width in SSR mode and for hydration
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        enableSsrInlineScripts: Boolean(undefined),
        // include renderer inline script from above on first render to prevent hydration mismatch
        noOpSSRInlineScript: renderServerPlaceholder,
        timeZone: timeZone || tenantTimeZone || undefined,
        adfStage: adfStage,
        document: finalDocument,
        appearance: appearance,
        contentMode: contentMode,
        stickyHeaders: stickyHeaders,
        extensionHandlers: mergedExtensionHandlers,
        hideExtensionKeysWhilePending: (0, $6mKj3.expValEquals)('confluence_hide_pending_extension_fallback', 'isEnabled', true) ? $1af8a83cb114ff50$var$EXTENSION_KEYS_TO_HIDE_WHILE_PENDING : undefined,
        eventHandlers: eventHandlers,
        featureFlags: editorFeatureFlags,
        dataProviders: mergedDataProviders.providerFactory,
        portal: portal,
        allowColumnSorting: true,
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        allowAltTextOnImages: true,
        media: media,
        emojiResourceConfig: emojiResourceConfig,
        allowCopyToClipboard: true,
        allowWrapCodeBlock: true,
        ...rest,
        onRendered: onRendererRendered,
        useSpecBasedValidator: true,
        truncated: isTruncatedContent,
        maxHeight: maxHeight,
        fadeOutHeight: fadeOutHeight,
        analyticsEventSeverityTracking: $1af8a83cb114ff50$export$3422b9c70e187e34,
        unsupportedContentLevelsTracking: $1af8a83cb114ff50$export$58eac04eb6213951(),
        allowPlaceholderText: allowPlaceholderText,
        allowCustomPanels: true,
        smartLinks: smartLinks,
        extensionViewportSizes: extensionViewportSizes,
        onError: errorHandler,
        UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment,
        UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing,
        UNSTABLE_isPresentational: UNSTABLE_isPresentational,
        allowRendererContainerStyles: allowRendererContainerStyles,
        shouldDisplayExtensionAsInline: (0, $hMB4W.shouldDisplayExtensionAsInline),
        allowFixedColumnWidthOption: (0, $iDrrr.fg)('platform_editor_table_fixed_column_width_prop') ? appearance === 'full-page' || appearance === 'full-width' : undefined,
        ...nodeComponents && {
            nodeComponents: nodeComponents
        }
    }), renderWhenReady && renderWhenReady()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fgQGl.ContentRefetchHandler), {
        contentId: contentId,
        shouldRefetch: (0, $6mKj3.expVal)('task_cache_invalidation_fix', 'isEnabled', false) ? false : shouldRefetchContent,
        flushTaskStatusPatch: (0, $6mKj3.expVal)('task_cache_invalidation_fix', 'isEnabled', false) ? flushTaskStatusPatch : undefined
    }), pageMode && pageMode === (0, $cD1qu.PageMode).VIEW && !isEmbedded && (0, $6mKj3.expValEquals)('cc_smart_link_nudge_kill_switch', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5523d8b8240ba692$export$cde76c461119a84c), {
        contentId: contentId,
        contentType: contentType,
        isLivePage: isLivePage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedFollowData.feedConfigError,
        mutationError: feedFollowData.mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb91119414a4e358$export$d8ebe500960648d), {
        document: document,
        flags: flags
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $05271241466f5e2e$export$b8cbd42b7b7bd9d2), {
        contentId: contentId,
        contentType: contentType,
        isViewPage: pageMode === (0, $cD1qu.PageMode).VIEW,
        spaceKey: spaceKey
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        ...(0, $kLzei.getSmartCardRenderers)(),
        ...storeOptions,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        shouldControlDataExport: shouldControlDataExport,
        product: "CONFLUENCE"
    }, content);
});
module.exports["ANALYTICS_EVENT_SEVERITY_TRACKING"] = $1af8a83cb114ff50$export$3422b9c70e187e34;
module.exports["UNSUPPORTED_CONTENT_THRESHOLDS"] = $1af8a83cb114ff50$export$c02e908ea3c1fe52;
module.exports["ADFRendererComponent"] = $1af8a83cb114ff50$export$cec675c14d32c246;

});

parcelRegister("fgQGl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $83Z6R = parcelRequire("83Z6R");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $cLo2u = parcelRequire("cLo2u");


var $dPJCf = parcelRequire("dPJCf");


var $ep3mz = parcelRequire("ep3mz");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");






const $ef083f8573fb553b$var$applyTaskStates = (root, states)=>{
    let changed = false;
    const stack = [
        root
    ];
    while(stack.length > 0){
        const node = stack.pop();
        if (!node || typeof node !== 'object') continue;
        const localId = node.type === 'taskItem' ? node.attrs?.localId : undefined;
        if (localId && states.has(localId)) {
            const nextState = states.get(localId);
            if (node.attrs && nextState && node.attrs.state !== nextState) {
                node.attrs.state = nextState;
                changed = true;
            }
        }
        if (Array.isArray(node.content)) stack.push(...node.content);
    }
    return changed;
};
const $ef083f8573fb553b$export$308244febf715de3 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, taskStatusUpdates: taskStatusUpdates })=>{
    if (!contentId || taskStatusUpdates.length === 0) return;
    const query = contentType === 'blogpost' ? (0, $f9opb.default) : (0, $jgc4t.default);
    const variables = {
        contentId: contentId,
        spaceKey: spaceKey,
        isSSR: false,
        useNewContentTopper: false,
        preloadLabels: false,
        includeAgentTrustReceiptData: false,
        fetchAgentSessionsMarker: false,
        agentSessionsPropertyKey: ''
    };
    try {
        const data = (0, $l1uFv.readQueryInterop)({
            query: query,
            variables: variables,
            __callerPackage__: "content-body"
        });
        const content = data?.content;
        const nodes = content?.nodes;
        const dynamic = nodes?.[0]?.body?.dynamic;
        if (!dynamic || dynamic.representation !== 'atlas_doc_format' || !dynamic.value) return;
        const adf = JSON.parse(dynamic.value);
        const states = new Map(taskStatusUpdates.map(({ localId: localId, state: state })=>[
                localId,
                state
            ]));
        if (!$ef083f8573fb553b$var$applyTaskStates(adf, states)) return;
        const patchedValue = JSON.stringify(adf);
        (0, $fEmGS.writeQueryInterop)({
            query: query,
            variables: variables,
            data: {
                ...data,
                content: {
                    ...content,
                    nodes: nodes.map((node, index)=>index === 0 && node ? {
                            ...node,
                            body: {
                                ...node.body,
                                dynamic: {
                                    ...node.body?.dynamic,
                                    value: patchedValue
                                }
                            }
                        } : node)
                }
            },
            __callerPackage__: "content-body"
        });
    } catch  {
    // Best-effort: a missing/unreadable cache entry must not throw while leaving the page.
    }
};


const $96596a053dd4ef1e$export$d1bbac313eb9a2c1 = ({ contentId: contentId, shouldRefetch: shouldRefetch, refetchImmediately: refetchImmediately, onRefetchComplete: onRefetchComplete, flushTaskStatusPatch: flushTaskStatusPatch })=>{
    const history = (0, $dPJCf.useHistory)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $f9opb.default) : (0, $jgc4t.default);
    const executeQuery = (0, $83Z6R.useLazyQueryPromiseInterop)(chooseContentUnifiedQuery, {
        fetchPolicy: 'network-only'
    });
    // Store onRefetchComplete in a ref so the effect can always call the latest
    // version without needing it in the dependency array. This prevents callers
    // that pass an unstable function reference from causing an infinite refetch
    // loop when refetchImmediately is true.
    const onRefetchCompleteRef = (0, $cozmU.useRef)(onRefetchComplete);
    onRefetchCompleteRef.current = onRefetchComplete;
    const flushTaskStatusPatchRef = (0, $cozmU.useRef)(flushTaskStatusPatch);
    flushTaskStatusPatchRef.current = flushTaskStatusPatch;
    // Runs when the page is left (contentId changes or unmount). flushTaskStatusPatch drains the
    // patch context captured at toggle time; this component's own contentId can't be used because
    // the renderer instance is reused across SPA navigations and its contentId drifts to the next
    // page before this fires. Running on leave keeps the broadcasting cache write off the mounted
    // renderer.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            const flush = flushTaskStatusPatchRef.current;
            if (!flush) return;
            const { taskStatusUpdates: taskStatusUpdates, ...context } = flush();
            if (taskStatusUpdates.length === 0) return;
            (0, $ef083f8573fb553b$export$308244febf715de3)({
                ...context,
                taskStatusUpdates: taskStatusUpdates
            });
        };
    }, [
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        let unlisten;
        if (shouldRefetch && contentId) {
            const queryVariable = {
                contentId: contentId,
                spaceKey: spaceKey,
                isSSR: isSSR,
                useNewContentTopper: true
            };
            const refetchFn = async ()=>{
                let versionNumber;
                try {
                    const queryResult = await executeQuery({
                        context: {
                            single: true
                        },
                        variables: queryVariable
                    });
                    versionNumber = queryResult.content?.nodes?.[0]?.version?.number;
                } catch  {
                // NOTE: We intentionally swallow any possible error here as this query is only aimed to
                // populate the cache with just published content. Should any error occur here after
                // successful publishing the page, the Apollo cache for the query will be invalidated
                // anyway and View Page will fetch the page and handle possible errors.
                }
                // If a callback is supplied, call it regardless
                onRefetchCompleteRef.current && onRefetchCompleteRef.current(versionNumber);
            };
            if (refetchImmediately) refetchFn();
            else unlisten = history?.listen(refetchFn);
        }
        return ()=>{
            // Call the unlistener when this component unmounts
            unlisten && unlisten();
        };
    }, [
        shouldRefetch,
        executeQuery,
        contentId,
        spaceKey,
        isSSR,
        history,
        refetchImmediately
    ]);
    return null;
};
module.exports["ContentRefetchHandler"] = $96596a053dd4ef1e$export$d1bbac313eb9a2c1;

});

parcelRegister("5KWZf", function(module, exports) {
const $23f879aa41f3f099$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $23f879aa41f3f099$export$df3c2062a081a534 = 'com.atlassian.confluence.spotlight';
const $23f879aa41f3f099$export$4454075c4322ae47 = 'com.atlassian.confluence.hub-section';
const $23f879aa41f3f099$export$2dd5fc71941a6787 = 'com.atlassian.confluence.knowledge-cards';
const $23f879aa41f3f099$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $23f879aa41f3f099$export$514105ca7c79025d = 'com.atlassian.confluence.carousel';
const $23f879aa41f3f099$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $23f879aa41f3f099$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $23f879aa41f3f099$export$8e1a1e8b8109dbf3 = '#DDDEE1';
const $23f879aa41f3f099$export$8161b1f4e2928fa0 = '--hub-primary-color';
const $23f879aa41f3f099$export$94d2a2331edd895d = '--hub-primary-text-color';
const $23f879aa41f3f099$export$64de52c9db8240f6 = '--hub-primary-link-color';
const $23f879aa41f3f099$export$4c91e7265b76e3a1 = '32px';
const $23f879aa41f3f099$export$d713f99e5e84a256 = '40px'; // Pre-standardization height for CSM fallback
const $23f879aa41f3f099$export$6faa4a850bc4d0ce = 'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
const $23f879aa41f3f099$export$ea77880e3935182d = 'unknown';
const $23f879aa41f3f099$export$c7f012c6e67c4217 = 0;
module.exports["CARDS_EXTENSION_TYPE"] = $23f879aa41f3f099$export$81e5b59a1e176638;
module.exports["SPOTLIGHT_EXTENSION_TYPE"] = $23f879aa41f3f099$export$df3c2062a081a534;
module.exports["SECTION_EXTENSION_TYPE"] = $23f879aa41f3f099$export$4454075c4322ae47;
module.exports["RESOURCE_TILES_EXTENSION_TYPE"] = $23f879aa41f3f099$export$2dd5fc71941a6787;
module.exports["LINKS_MENU_EXTENSION_TYPE"] = $23f879aa41f3f099$export$9fdf64a495514b4;
module.exports["CAROUSEL_EXTENSION_TYPE"] = $23f879aa41f3f099$export$514105ca7c79025d;
module.exports["SEARCH_EXTENSION_TYPE"] = $23f879aa41f3f099$export$cb2d1b0c753e69e6;
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE"] = $23f879aa41f3f099$export$c14e692c91462ed4;
module.exports["HUB_PRIMARY_COLOR_CSS_VAR"] = $23f879aa41f3f099$export$8161b1f4e2928fa0;
module.exports["HUB_PRIMARY_TEXT_COLOR_CSS_VAR"] = $23f879aa41f3f099$export$94d2a2331edd895d;
module.exports["HUB_PRIMARY_LINK_COLOR_CSS_VAR"] = $23f879aa41f3f099$export$64de52c9db8240f6;
module.exports["HUB_LOGO_HEIGHT"] = $23f879aa41f3f099$export$4c91e7265b76e3a1;
module.exports["HUB_LOGO_HEIGHT_LEGACY"] = $23f879aa41f3f099$export$d713f99e5e84a256;

});

parcelRegister("dBD3L", function(module, exports) {
const $e93ae61a08cdbc4f$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $e93ae61a08cdbc4f$export$8a4891a61ff91b00 = 'cards';
const $e93ae61a08cdbc4f$export$67bfcae6d68bb0bf = 'cardsExtension';
const $e93ae61a08cdbc4f$export$7f17fab0aecb44ed = 'cardsExtensionConfig';
const $e93ae61a08cdbc4f$export$6a35a50674becbae = 'cardsExtensionConfigBackgroundColor';
const $e93ae61a08cdbc4f$export$9bf56665bf6ea6ed = 'cardsExtensionConfigBorderColor';
const $e93ae61a08cdbc4f$export$cf23b6d2fd159502 = 'cardsExtensionConfigTextColor';
const $e93ae61a08cdbc4f$export$131b76b4d30d2b44 = '2';
const $e93ae61a08cdbc4f$export$a08b7507bedba276 = '3';
const $e93ae61a08cdbc4f$export$c87753a8bb0c4e75 = '4';
const $e93ae61a08cdbc4f$export$b84f9a7c097c895c = '5';
const $e93ae61a08cdbc4f$export$5e905747d7497a1f = [
    {
        src: 'https://images.unsplash.com/photo-1571327352610-1c5484ccc840?auto=format&fit=crop&q=80&w=450',
        alt: 'closed wooden window'
    },
    {
        src: 'https://images.unsplash.com/photo-1566486106118-e1c24ad08802?auto=format&fit=crop&q=80&w=450',
        alt: 'green coconut trees'
    },
    {
        src: 'https://images.unsplash.com/photo-1602021224139-a6ba7e601732?auto=format&fit=crop&q=80&w=450',
        alt: 'white and black striped chair'
    },
    {
        src: 'https://images.unsplash.com/photo-1722259038071-6082eaf397ff?auto=format&fit=crop&q=80&w=450',
        alt: 'surfboard on top of a cement wall'
    },
    {
        src: 'https://images.unsplash.com/photo-1555001356-333dbc0f8b48?auto=format&fit=crop&q=80&w=450',
        alt: 'white stairs'
    },
    {
        src: 'https://images.unsplash.com/photo-1680258551363-6b5fd1ac2048?auto=format&fit=crop&q=80&w=450',
        alt: 'swimming pool tiles'
    }
];
module.exports["CARDS_EXTENSION_TYPE"] = $e93ae61a08cdbc4f$export$81e5b59a1e176638;
module.exports["CARDS_EXTENSION_KEY"] = $e93ae61a08cdbc4f$export$8a4891a61ff91b00;
module.exports["CARDS_EXTENSION_ANALYTIC_SOURCE"] = $e93ae61a08cdbc4f$export$67bfcae6d68bb0bf;
module.exports["CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE"] = $e93ae61a08cdbc4f$export$7f17fab0aecb44ed;
module.exports["CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE"] = $e93ae61a08cdbc4f$export$6a35a50674becbae;
module.exports["CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE"] = $e93ae61a08cdbc4f$export$9bf56665bf6ea6ed;
module.exports["CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE"] = $e93ae61a08cdbc4f$export$cf23b6d2fd159502;
module.exports["CARDS_EXTENSION_VERSION_5"] = $e93ae61a08cdbc4f$export$b84f9a7c097c895c;
module.exports["CARDS_IMAGES_V5"] = $e93ae61a08cdbc4f$export$5e905747d7497a1f;

});

parcelRegister("KDPGa", function(module, exports) {
const $7c2bfd2e70fd959d$export$e03f5e560317f88a = '1';
const $7c2bfd2e70fd959d$export$5e16975fb5214c6c = 'company-hub-search';
const $7c2bfd2e70fd959d$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $7c2bfd2e70fd959d$export$ec7b7d5be35b7dd3 = 'customSearchExtension';
module.exports["SEARCH_EXTENSION_VERSION_1"] = $7c2bfd2e70fd959d$export$e03f5e560317f88a;
module.exports["SEARCH_EXTENSION_KEY"] = $7c2bfd2e70fd959d$export$5e16975fb5214c6c;
module.exports["SEARCH_EXTENSION_TYPE"] = $7c2bfd2e70fd959d$export$cb2d1b0c753e69e6;
module.exports["CUSTOM_SEARCH_EXTENSION_ANALYTIC_SOURCE"] = $7c2bfd2e70fd959d$export$ec7b7d5be35b7dd3;

});

parcelRegister("bQmwQ", function(module, exports) {
const $6342bff3d053fae3$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $6342bff3d053fae3$export$ed5854f17099adbf = 'linksMenuExtension';
module.exports["LINKS_MENU_EXTENSION_TYPE"] = $6342bff3d053fae3$export$9fdf64a495514b4;
module.exports["LINKS_MENU_EXTENSION_ANALYTIC_SOURCE"] = $6342bff3d053fae3$export$ed5854f17099adbf;

});

parcelRegister("gXR7h", function(module, exports) {
const $e97883ecdb0f2de9$export$a06ac4f1777262dc = 'com.atlassian.confluence.carousel';
const $e97883ecdb0f2de9$export$6c8179fa243b4399 = 'carousel';
const $e97883ecdb0f2de9$export$ca14f22a239c4ae9 = 'carouselExtension';
const $e97883ecdb0f2de9$export$4cb671946a80c52e = 'carouselExtensionConfig';
const $e97883ecdb0f2de9$export$93995a2609cff38d = 8;
const $e97883ecdb0f2de9$export$3a86d0fc7eb402f4 = 'carousel-navigation-frame-';
const $e97883ecdb0f2de9$export$9575b4f5d97a1c29 = '1';
const $e97883ecdb0f2de9$export$b429752dfe934bea = '2';
const $e97883ecdb0f2de9$export$c5c6e75ceae0cc22 = 10;
module.exports["carouselExtensionType"] = $e97883ecdb0f2de9$export$a06ac4f1777262dc;
module.exports["carouselExtensionKey"] = $e97883ecdb0f2de9$export$6c8179fa243b4399;
module.exports["carouselContentAnalyticSource"] = $e97883ecdb0f2de9$export$ca14f22a239c4ae9;
module.exports["carouselConfigAnalyticSource"] = $e97883ecdb0f2de9$export$4cb671946a80c52e;
module.exports["AUTOPLAY_SECONDS"] = $e97883ecdb0f2de9$export$93995a2609cff38d;
module.exports["ARIA_CONTROLS_PREFIX"] = $e97883ecdb0f2de9$export$3a86d0fc7eb402f4;
module.exports["CAROUSEL_VERSION_2"] = $e97883ecdb0f2de9$export$b429752dfe934bea;
module.exports["FRAMES_LIMIT_V2"] = $e97883ecdb0f2de9$export$c5c6e75ceae0cc22;

});

parcelRegister("9MYUp", function(module, exports) {
const $2e285551d02f5ba2$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $2e285551d02f5ba2$export$ca3a94184e0fbd97 = 'hub-element-placeholder';
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE"] = $2e285551d02f5ba2$export$c14e692c91462ed4;
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY"] = $2e285551d02f5ba2$export$ca3a94184e0fbd97;

});

parcelRegister("cbvYp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cfM7x = parcelRequire("cfM7x");


var $4IoVL = parcelRequire("4IoVL");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $1NBp8 = parcelRequire("1NBp8");


var $6M71K = parcelRequire("6M71K");


var $5kjCz = parcelRequire("5kjCz");


var $hUS75 = parcelRequire("hUS75");


var $4KFTW = parcelRequire("4KFTW");


var $bX5uj = parcelRequire("bX5uj");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $6mKj3 = parcelRequire("6mKj3");


var $aJPUt = parcelRequire("aJPUt");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $lOeVN = parcelRequire("lOeVN");


var $bAIqi = parcelRequire("bAIqi");


var $bflGB = parcelRequire("bflGB");



var $hl1Kw = parcelRequire("hl1Kw");


var $cEgMD = parcelRequire("cEgMD");


var $78QFu = parcelRequire("78QFu");


var $ep3mz = parcelRequire("ep3mz");


var $2YtTU = parcelRequire("2YtTU");





var $9DHhW = parcelRequire("9DHhW");


var $4yccB = parcelRequire("4yccB");


var $5Gcps = parcelRequire("5Gcps");





var $7QM6o = parcelRequire("7QM6o");










const $4305591bcf0ed0e4$export$bd1b893a71ee8dab = (link)=>{
    const [analyticFields, setAnalyticFields] = (0, $cozmU.useState)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const fetchData = async ()=>{
            const client = new (0, $4yccB.default)();
            try {
                const queriedMetadata = !!link && await client.fetchData(link);
                if (!queriedMetadata || !queriedMetadata.meta) return;
                const { containerId: initialContainerId, tenantId: initialTenantId, objectId: initialObjectId } = queriedMetadata.meta || {};
                if (!initialObjectId) return;
                const newObjectId = await (0, $5Gcps.getClickAndViewEventObjectIdFromLinkData)(initialObjectId, initialContainerId);
                setAnalyticFields({
                    containerId: initialContainerId,
                    tenantId: initialTenantId,
                    objectId: newObjectId
                });
            } catch (error) {
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).PERFORMANCE_INSIGHTS
                });
                (0, $7Sm4c.markErrorAsHandled)(error);
            }
        };
        fetchData();
    }, [
        link
    ]);
    const { tenantId: tenantId, objectId: objectId } = analyticFields || {};
    const handleClick = ()=>{
        if (tenantId === cloudId) createAnalyticsEvent?.((0, $5Gcps.generateClickEventPayload)(activationId, cloudId, objectId, spaceId)).fire();
    };
    const handleView = ()=>{
        if (tenantId === cloudId) createAnalyticsEvent?.((0, $5Gcps.generateViewEventPayload)(activationId, cloudId, objectId, spaceId)).fire();
    };
    return {
        handleClick: analyticFields ? handleClick : undefined,
        handleView: analyticFields ? handleView : undefined
    };
};



var $biMIt = parcelRequire("biMIt");

/**
 * @generated SignedSource<<5d9f0f9b4d004db5c39c281d1073c821>>
 * @relayHash aea879681eafb8d8dc2e8d788d24714d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ac8d9edb75319a93ed7a159d48491fc0f2f009e88d49acb7b2f4c6dd571ae406
const $53bd2fb7fcb3ebe9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": 25,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "PaginatedGroupList",
            "kind": "LinkedField",
            "name": "groups",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Group",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSegmentationTargetGroupsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSegmentationTargetGroupsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "aea879681eafb8d8dc2e8d788d24714d",
            "id": "ac8d9edb75319a93ed7a159d48491fc0f2f009e88d49acb7b2f4c6dd571ae406",
            "metadata": {},
            "name": "useSegmentationTargetGroupsQuery",
            "operationKind": "query",
            "text": "query useSegmentationTargetGroupsQuery($after:String,$first:Int=25){groups(after:$after,first:$first){nodes{id,name},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$53bd2fb7fcb3ebe9$var$node.hash = "b1d866007d469142c79544536019c0ef";
var $53bd2fb7fcb3ebe9$export$2e2bcd8739ae039 = $53bd2fb7fcb3ebe9$var$node;









var $1uFM6 = parcelRequire("1uFM6");





var $jMyy4 = parcelRequire("jMyy4");

const $a453bfc5db2076e7$export$df3f3e4ed2d81d7 = ({ nextCursor: nextCursor, initialGroupIds: initialGroupIds })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $53bd2fb7fcb3ebe9$export$2e2bcd8739ae039), {
        variables: {
            after: nextCursor
        },
        skip: initialGroupIds.length === 0,
        __callerPackage__: "custom-sites-extensions"
    });
    let errorComponent = undefined;
    if (error && !loading) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else errorComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    return {
        data: data,
        loading: loading,
        errorComponent: errorComponent
    };
};


const $73ff39965b133879$var$useFeedbackCollectorWrapper = ({ source: source, type: type })=>{
    return (0, $lOeVN.useFeedbackCollector)({
        source: source,
        type: type
    });
};
const $73ff39965b133879$var$useSegmentationTargetGroupsWrapper = ({ nextCursor: nextCursor, initialGroupIds: initialGroupIds = [] })=>{
    return (0, $a453bfc5db2076e7$export$df3f3e4ed2d81d7)({
        nextCursor: nextCursor,
        initialGroupIds: initialGroupIds
    });
};
const $73ff39965b133879$var$ShortcutListenerWrapper = ({ accelerator: accelerator, listener: listener })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bflGB.ShortcutListener), {
        accelerator: accelerator,
        listener: listener
    });
};
const $73ff39965b133879$var$ExtensionConfigUpsellLoaderWrapper = ({ feature: feature })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bAIqi.ExtensionConfigUpsellLoader), {
        feature: feature
    });
};
const $73ff39965b133879$var$submitError = (error)=>{
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
};
const $73ff39965b133879$var$SmartCardProvider = ({ children: children })=>{
    return(// disable preview panel functionality for cards
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        isPreviewPanelAvailable: (_ari)=>false
    }, children));
};
const $73ff39965b133879$export$ae511a2e03f02bcc = ({ contentId: contentId, fileId: fileId })=>{
    // When experiment is enabled, store in format: {contentId}/{fileId}
    // This allows us to track which page the image was originally uploaded to
    // When copy-pasting to another page, useMediaConfig will extract the original contentId
    // Check if the fileId already contains the contentId prefix (e.g., from linked page header)
    // If it already has a "/", it's in format {contentId}/{fileId} and we don't add another prefix
    if ((0, $6mKj3.expValEquals)('ccpi_broken_upload_images_for_confluence', 'isEnabled', true)) return fileId.includes('/') ? fileId : `${contentId}/${fileId}`;
    return fileId;
};
const $73ff39965b133879$export$52286abe2bf4f236 = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const start = (0, $cozmU.useCallback)(({ analyticsSource: analyticsSource })=>{
        experienceTracker.start({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE),
            attributes: {
                source: analyticsSource
            }
        });
    }, [
        experienceTracker
    ]);
    const succeed = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    const stopOnError = (0, $cozmU.useCallback)(({ error: error })=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return {
        start: start,
        succeed: succeed,
        stopOnError: stopOnError
    };
};
const $73ff39965b133879$export$50a2d523eb80eb6f = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const start = (0, $cozmU.useCallback)(({ analyticsSource: analyticsSource, confluencePageId: confluencePageId })=>{
        experienceTracker.start({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            attributes: {
                source: analyticsSource,
                contentId: confluencePageId
            }
        });
    }, [
        experienceTracker
    ]);
    const abort = (0, $cozmU.useCallback)(({ reason: reason })=>{
        experienceTracker.abort({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            reason: reason
        });
    }, [
        experienceTracker
    ]);
    const succeed = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    const stopOnError = (0, $cozmU.useCallback)(({ error: error })=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return {
        start: start,
        abort: abort,
        succeed: succeed,
        stopOnError: stopOnError
    };
};
const $73ff39965b133879$export$4bd687f80e42155a = (activeContentId, maybeCustomCoverImage)=>{
    if (maybeCustomCoverImage.indexOf('/') !== -1) {
        const temp = maybeCustomCoverImage.split('/');
        return [
            temp[0],
            temp[1]
        ];
    }
    // If it's not a stored cover image, we return original contentId & imageSrc
    return [
        activeContentId,
        maybeCustomCoverImage
    ];
};
const $73ff39965b133879$export$7f746b47c356effa = ({ contentId: contentId, imageSrc: imageSrc })=>{
    const [mediaConfig, setMediaConfig] = (0, $cozmU.useState)(null);
    // When imageSrc is a stored cover image, it comes in format '{contentId}/{fileId}'
    // We need to split the string to get the collectionId and fileId
    const [collectionId, fileId] = $73ff39965b133879$export$4bd687f80e42155a(contentId, imageSrc);
    (0, $cozmU.useEffect)(()=>{
        async function createMediaConfig() {
            if (!(0, $4IoVL.createRendererMediaProvider)) return;
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentId: collectionId,
                isExternalShare: false
            });
            if (!viewMediaClientConfig) {
                setMediaConfig(null);
                return;
            }
            setMediaConfig({
                collection: `contentId-${collectionId}`,
                authProvider: viewMediaClientConfig.authProvider,
                fileId: fileId
            });
        }
        createMediaConfig();
    }, [
        collectionId,
        fileId
    ]);
    return mediaConfig;
};
const $73ff39965b133879$export$9a7b37d3055a69a6 = ({ mode: mode, extensionNode: extensionNode, contentId: contentId = '', children: children })=>{
    const mediaUploadExperienceTracker = $73ff39965b133879$export$52286abe2bf4f236();
    const aiDescriptionExperienceTracker = $73ff39965b133879$export$50a2d523eb80eb6f();
    const sessionData = (0, $bQm3c.useSessionData)();
    const { cloudId: cloudId, displayName: displayName, isAdminHubAIEnabled: isAdminHubAIEnabled, orgId: orgId, userId: userId } = sessionData || {};
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isTargetAudience: isTargetAudience } = (0, $cozmU.useContext)((0, $biMIt.AudienceSegmentationContext));
    const shouldShowPremiumUpsell = (0, $2YtTU.usePremiumGate)();
    const ConfigUpsellScreen = (0, $cozmU.useMemo)(()=>shouldShowPremiumUpsell ? ({ feature: feature })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73ff39965b133879$var$ExtensionConfigUpsellLoaderWrapper, {
                feature: feature
            }) : undefined, [
        shouldShowPremiumUpsell
    ]);
    const experienceStartComponent = (0, $cozmU.useCallback)(()=>{
        if (!extensionNode) return null;
        const macroAttributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode);
        const experienceName = (0, $5kjCz.getExperienceName)(mode, extensionNode);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            attributes: macroAttributes,
            extensionKey: extensionNode.extensionKey,
            contentId: contentId,
            mode: mode,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        });
    }, [
        extensionNode,
        contentId,
        mode
    ]);
    const experienceSuccessComponent = (0, $cozmU.useCallback)(()=>{
        if (!extensionNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: (0, $5kjCz.getExperienceName)(mode, extensionNode),
            contentId: contentId,
            extensionKey: extensionNode.extensionKey,
            mode: mode,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode)
        });
    }, [
        extensionNode,
        contentId,
        mode
    ]);
    const experienceStopComponent = (0, $cozmU.useCallback)(({ error: error })=>{
        if (!extensionNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hUS75.MacroExperienceStop), {
            error: error,
            name: (0, $5kjCz.getExperienceName)(mode, extensionNode),
            contentId: contentId,
            extensionKey: extensionNode.extensionKey,
            mode: mode,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode)
        });
    }, [
        mode,
        extensionNode,
        contentId
    ]);
    const isSSRProductInDarkMode = (0, $cozmU.useMemo)(()=>{
        return undefined;
    }, []);
    const errorBoundaryComponent = (0, $cozmU.useMemo)(()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
            }, children), []);
    const errorDisplayComponent = (0, $cozmU.useMemo)(()=>({ error: error, childrenComponents: childrenComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }, childrenComponents), []);
    const useAnalyticsActions = (0, $cozmU.useMemo)(()=>({
            useLinkAnalyticActions: $4305591bcf0ed0e4$export$bd1b893a71ee8dab
        }), []);
    const value = (0, $cozmU.useMemo)(()=>({
            experienceStartComponent: experienceStartComponent,
            experienceSuccessComponent: experienceSuccessComponent,
            experienceStopComponent: experienceStopComponent,
            cloudId: cloudId,
            searchConfigProvider: {
                peopleDirectoryUrl: (0, $1NBp8.PEOPLE_DIRECTORY).toUrl(),
                advancedSearchUrl: (0, $1NBp8.ADVANCED_SEARCH).toUrl(),
                searchSessionId: searchSessionId || ''
            },
            displayName: displayName || '',
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            orgId: orgId || '',
            userId: userId || '',
            errorBoundaryComponent: errorBoundaryComponent,
            errorDisplayComponent: errorDisplayComponent,
            submitError: $73ff39965b133879$var$submitError,
            markErrorAsHandled: $7Sm4c.markErrorAsHandled,
            useMediaConfig: $73ff39965b133879$export$7f746b47c356effa,
            createEditorMediaProvider: $4IoVL.createEditorMediaProvider,
            mediaUploadExperienceTracker: mediaUploadExperienceTracker,
            transformUploadedImageId: $73ff39965b133879$export$ae511a2e03f02bcc,
            aiDescriptionExperienceTracker: aiDescriptionExperienceTracker,
            useFeedbackCollector: $73ff39965b133879$var$useFeedbackCollectorWrapper,
            shortcutListener: $73ff39965b133879$var$ShortcutListenerWrapper,
            shouldShowPremiumUpsell: shouldShowPremiumUpsell,
            ConfigUpsellScreen: ConfigUpsellScreen,
            useSegmentationTargetGroups: $73ff39965b133879$var$useSegmentationTargetGroupsWrapper,
            isSSRProductInDarkMode: isSSRProductInDarkMode,
            analyticsContext: {
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            },
            useAnalyticsActions: useAnalyticsActions,
            isCompanyHub: (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey),
            isTargetAudience: isTargetAudience,
            smartCardProviderComponent: $73ff39965b133879$var$SmartCardProvider,
            showConfigPreambleSupportLink: true,
            enableTargeting: true,
            enableUnifiedSearchFeatures: true,
            enableSmartCardsFields: true
        }), [
        experienceSuccessComponent,
        experienceStopComponent,
        cloudId,
        displayName,
        isAdminHubAIEnabled,
        orgId,
        userId,
        searchSessionId,
        shouldShowPremiumUpsell,
        ConfigUpsellScreen,
        isSSRProductInDarkMode,
        errorBoundaryComponent,
        errorDisplayComponent,
        experienceStartComponent,
        mediaUploadExperienceTracker,
        aiDescriptionExperienceTracker,
        useAnalyticsActions,
        spaceKey,
        isTargetAudience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfM7x.ProductDependenciesContext).Provider, {
        value: value
    }, children);
};
const $73ff39965b133879$export$443fd6903ad182a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($73ff39965b133879$export$9a7b37d3055a69a6, props, children);
module.exports["ConfluenceDependenciesProvider"] = $73ff39965b133879$export$443fd6903ad182a1;

});

parcelRegister("bAIqi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c1c72132c26b9ae6$export$349c99e57ed161b9 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "at4mJ",
    name: "ExtensionConfigUpsellLoader",
    loader: async ()=>(await (parcelRequire("eQzNt"))).ExtensionConfigUpsell
});

const $c1c72132c26b9ae6$export$25389a114c9b393f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "rxN2C",
    name: "ExtensionInsertUpsellLoader",
    loader: async ()=>(await (parcelRequire("yfb2a"))).ExtensionInsertUpsell
});
module.exports["ExtensionConfigUpsellLoader"] = $c1c72132c26b9ae6$export$349c99e57ed161b9;
module.exports["ExtensionInsertUpsellLoader"] = $c1c72132c26b9ae6$export$25389a114c9b393f;

});

parcelRegister("eQzNt", function(module, exports) {

let $acf1b08bae7e74af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $acf1b08bae7e74af$var$load("hOaAV"),
    $acf1b08bae7e74af$var$load("6XCf4"),
    $acf1b08bae7e74af$var$load("fINdN"),
    $acf1b08bae7e74af$var$load("1qlDN"),
    $acf1b08bae7e74af$var$load("1yVM6"),
    $acf1b08bae7e74af$var$load("aEiTV"),
    $acf1b08bae7e74af$var$load("9wTrW")
]).then(()=>parcelRequire('d1uaq'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("yfb2a", function(module, exports) {

let $066ef2eb82643026$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $066ef2eb82643026$var$load("hOaAV"),
    $066ef2eb82643026$var$load("6XCf4"),
    $066ef2eb82643026$var$load("fINdN"),
    $066ef2eb82643026$var$load("1qlDN"),
    $066ef2eb82643026$var$load("1yVM6"),
    $066ef2eb82643026$var$load("aEiTV"),
    $066ef2eb82643026$var$load("5HTv6")
]).then(()=>parcelRequire('f4NfX'));

});

parcelRegister("2YtTU", function(module, exports) {
/**
 * @generated SignedSource<<8bb9bdb80921f64e532e9a0a860836ba>>
 * @relayHash b3b58abba516a7066e43fee230bb62d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd5ecfcc11044bcdaad98bea20a111b89a5005066669b87b37b1b8d5ea4e1ca6
const $ce65a234c274b394$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PremiumExtensionsFeature",
                    "kind": "LinkedField",
                    "name": "premiumExtensions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "usePremiumGatePremiumGateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "usePremiumGatePremiumGateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "b3b58abba516a7066e43fee230bb62d7",
            "id": "dd5ecfcc11044bcdaad98bea20a111b89a5005066669b87b37b1b8d5ea4e1ca6",
            "metadata": {},
            "name": "usePremiumGatePremiumGateQuery",
            "operationKind": "query",
            "text": "query usePremiumGatePremiumGateQuery{entitlements{premiumExtensions{isEntitled}}}"
        }
    };
}();
$ce65a234c274b394$var$node.hash = "53ba2ea71d0cb2a819a38d3bb3e49b44";
var $ce65a234c274b394$export$2e2bcd8739ae039 = $ce65a234c274b394$var$node;



var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $jMyy4 = parcelRequire("jMyy4");

const $50d2dd6da149924b$export$31a131ac01af5546 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const canSkipEntitlementCheck = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $ce65a234c274b394$export$2e2bcd8739ae039), {
        skip: canSkipEntitlementCheck,
        __callerPackage__: "custom-sites-extensions"
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !canSkipEntitlementCheck && !data?.entitlements.premiumExtensions.isEntitled;
};
module.exports["usePremiumGate"] = $50d2dd6da149924b$export$31a131ac01af5546;

});

parcelRegister("5Gcps", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");

/**
 * @generated SignedSource<<4ec0d41eabd26d29b4ef59d463a9ba52>>
 * @relayHash 2ce4acba36ec591640edbadf9a4c0da1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45b6c1dc2b39de9dbacf64bc05ff8155b28c306f24693e370416db912823d81a
const $c81d24d8a5f7522b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "spaceId",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceMetadataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedSpaceList",
                    "kind": "LinkedField",
                    "name": "spaces",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceMetadataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedSpaceList",
                    "kind": "LinkedField",
                    "name": "spaces",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "2ce4acba36ec591640edbadf9a4c0da1",
            "id": "45b6c1dc2b39de9dbacf64bc05ff8155b28c306f24693e370416db912823d81a",
            "metadata": {},
            "name": "SpaceMetadataQuery",
            "operationKind": "query",
            "text": "query SpaceMetadataQuery($id:Long!){spaces(spaceId:$id){nodes{homepage{id},id}}}"
        }
    };
}();
$c81d24d8a5f7522b$var$node.hash = "ebea840491a8ee540fbdcc7340dcbf80";
var $c81d24d8a5f7522b$export$2e2bcd8739ae039 = $c81d24d8a5f7522b$var$node;


const $e798eb82c10075ec$export$10df301dbc20c6db = (0, $c81d24d8a5f7522b$export$2e2bcd8739ae039);


const $9f3924c176ad2a57$export$2dd23eaa621322c4 = (activationId, cloudId, objectId, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'viewed',
            actionSubject: 'companyHubLink',
            source: 'companyHub',
            objectType: 'page',
            objectId: objectId,
            attributes: {
                activationId: activationId,
                spaceId: spaceId,
                spaceType: 'system',
                pageType: 'page',
                cloudId: cloudId
            }
        }
    });
const $9f3924c176ad2a57$export$e25d369331b443dc = (activationId, cloudId, objectId, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'clicked',
            actionSubject: 'companyHubLink',
            source: 'companyHub',
            objectType: objectId ? 'page' : null,
            objectId: objectId,
            attributes: {
                activationId: activationId,
                spaceId: spaceId,
                spaceType: 'system',
                pageType: objectId ? 'page' : null,
                cloudId: cloudId
            }
        }
    });
const $9f3924c176ad2a57$export$95c55278d4aca494 = async (objectId, destinationContainerId)=>{
    if (destinationContainerId === objectId) {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $e798eb82c10075ec$export$10df301dbc20c6db),
            variables: {
                id: destinationContainerId
            },
            __callerPackage__: "analytics"
        });
        const homepageId = data?.spaces?.nodes?.[0]?.homepage?.id;
        if (!homepageId) return;
        return homepageId;
    }
    return objectId;
};
module.exports["generateViewEventPayload"] = $9f3924c176ad2a57$export$2dd23eaa621322c4;
module.exports["generateClickEventPayload"] = $9f3924c176ad2a57$export$e25d369331b443dc;
module.exports["getClickAndViewEventObjectIdFromLinkData"] = $9f3924c176ad2a57$export$95c55278d4aca494;

});

parcelRegister("biMIt", function(module, exports) {

var $jtfsl = parcelRequire("jtfsl");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $ab43be195aa7029f$var$AudienceSegmentationContextProviderQuery = (0, $jtfsl.default);
const $ab43be195aa7029f$export$f8421e3bf566787d = 'accessible-to-anyone';
const $ab43be195aa7029f$export$6fb8438eed1d64ed = /*#__PURE__*/ (0, $cozmU.createContext)({
    isCompanyHub: false,
    currentAudienceGroupIds: [],
    setCurrentAudienceGroupIds: ()=>{},
    isTargetAudience: ()=>true,
    isSegmentationApplied: false,
    setIsSegmentationApplied: ()=>{}
});
const $ab43be195aa7029f$var$AudienceSegmentationContextProviderInternal = ({ children: children, isCompanyHub: isCompanyHub, initialAudienceGroupIds: initialAudienceGroupIds = [], initialSegmentationApplied: initialSegmentationApplied = false, shouldFetchUserGroups: shouldFetchUserGroups = false })=>{
    const [currentAudienceGroupIds, setCurrentAudienceGroupIds] = (0, $cozmU.useState)(initialAudienceGroupIds);
    const [isSegmentationApplied, setIsSegmentationApplied] = (0, $cozmU.useState)(initialSegmentationApplied);
    const isTargetAudience = (0, $cozmU.useCallback)((targetGroupIds)=>{
        if (!isCompanyHub || // if we are outside of company hub, no filtering
        targetGroupIds === undefined // if no target groups are provided, no filtering
        ) return true;
        setIsSegmentationApplied(true);
        const audienceGroupIdsSet = new Set(currentAudienceGroupIds);
        if (audienceGroupIdsSet.has($ab43be195aa7029f$export$f8421e3bf566787d)) return false;
        return targetGroupIds?.some((allowedGroup)=>audienceGroupIdsSet.has(allowedGroup));
    }, [
        currentAudienceGroupIds,
        isCompanyHub
    ]);
    const audienceSegmentationContextValue = (0, $cozmU.useMemo)(()=>({
            currentAudienceGroupIds: currentAudienceGroupIds,
            setCurrentAudienceGroupIds: setCurrentAudienceGroupIds,
            isCompanyHub: isCompanyHub,
            isTargetAudience: isTargetAudience,
            isSegmentationApplied: isSegmentationApplied,
            setIsSegmentationApplied: setIsSegmentationApplied
        }), [
        currentAudienceGroupIds,
        isCompanyHub,
        isTargetAudience,
        isSegmentationApplied
    ]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { error: queryError, loading: queryLoading } = (0, $jMyy4.useQueryInterop)($ab43be195aa7029f$var$AudienceSegmentationContextProviderQuery, {
        skip: !shouldFetchUserGroups || !isCompanyHub,
        variables: {
            accountId: userId
        },
        onCompleted: (data)=>{
            const userGroupIds = data?.user?.confluence?.groupsWithId?.map((result)=>result?.id).filter((id)=>!!id) ?? [];
            // onCompleted shouldn't be called if we skip the query but this is to ensure
            // the state doesn't get set when the fixture mock gives this query the default value
            shouldFetchUserGroups && setCurrentAudienceGroupIds(userGroupIds);
        },
        __callerPackage__: "custom-sites-extensions"
    });
    const errorDisplay = (0, $cozmU.useMemo)(()=>{
        if (queryError && !queryLoading) {
            if ((0, $1uFM6.isUnauthorizedError)(queryError)) (0, $7Sm4c.markErrorAsHandled)(queryError);
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: queryError
            });
        }
        return null;
    }, [
        queryError,
        queryLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab43be195aa7029f$export$6fb8438eed1d64ed.Provider, {
        value: audienceSegmentationContextValue
    }, errorDisplay, children);
};
const $ab43be195aa7029f$export$23b23ee9c5e80f4e = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
})($ab43be195aa7029f$var$AudienceSegmentationContextProviderInternal);
module.exports["COMMON_VIEW_ID"] = $ab43be195aa7029f$export$f8421e3bf566787d;
module.exports["AudienceSegmentationContext"] = $ab43be195aa7029f$export$6fb8438eed1d64ed;
module.exports["AudienceSegmentationContextProvider"] = $ab43be195aa7029f$export$23b23ee9c5e80f4e;

});

parcelRegister("cFFVb", function(module, exports) {

let $9399d50bf3952ebe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9399d50bf3952ebe$var$load("iFg9Z"),
    $9399d50bf3952ebe$var$load("kaExo"),
    $9399d50bf3952ebe$var$load("gkVge"),
    $9399d50bf3952ebe$var$load("hUbK8"),
    $9399d50bf3952ebe$var$load("7H1j2"),
    $9399d50bf3952ebe$var$load("rF2nk"),
    $9399d50bf3952ebe$var$load("5iv5O"),
    $9399d50bf3952ebe$var$load("dgmjH"),
    $9399d50bf3952ebe$var$load("6UOty"),
    $9399d50bf3952ebe$var$load("xS2oU"),
    $9399d50bf3952ebe$var$load("4jxHc"),
    $9399d50bf3952ebe$var$load("1xRFJ"),
    $9399d50bf3952ebe$var$load("b0ARW"),
    $9399d50bf3952ebe$var$load("1Gr4q"),
    $9399d50bf3952ebe$var$load("91eG9"),
    $9399d50bf3952ebe$var$load("kSgPY"),
    $9399d50bf3952ebe$var$load("7EorR"),
    $9399d50bf3952ebe$var$load("aJLFD"),
    $9399d50bf3952ebe$var$load("ariuh"),
    $9399d50bf3952ebe$var$load("fAzyA"),
    $9399d50bf3952ebe$var$load("Wowvf"),
    $9399d50bf3952ebe$var$load("cvcNg"),
    $9399d50bf3952ebe$var$load("6OMo6"),
    $9399d50bf3952ebe$var$load("aaRXj"),
    $9399d50bf3952ebe$var$load("fHlIz"),
    $9399d50bf3952ebe$var$load("4QwAJ"),
    $9399d50bf3952ebe$var$load("3i44s"),
    $9399d50bf3952ebe$var$load("5kI0b"),
    $9399d50bf3952ebe$var$load("kYkz1"),
    $9399d50bf3952ebe$var$load("jfYeU"),
    $9399d50bf3952ebe$var$load("b4nm1"),
    $9399d50bf3952ebe$var$load("geXPZ"),
    $9399d50bf3952ebe$var$load("aQ5uu"),
    $9399d50bf3952ebe$var$load("hDJ0x"),
    $9399d50bf3952ebe$var$load("jfSwd"),
    $9399d50bf3952ebe$var$load("1dC87"),
    $9399d50bf3952ebe$var$load("3fvOY"),
    $9399d50bf3952ebe$var$load("fV46K"),
    $9399d50bf3952ebe$var$load("9ZFGK"),
    $9399d50bf3952ebe$var$load("fkLbQ"),
    $9399d50bf3952ebe$var$load("bMNgp"),
    $9399d50bf3952ebe$var$load("1T8H1"),
    $9399d50bf3952ebe$var$load("fyKFO"),
    $9399d50bf3952ebe$var$load("d9sg7"),
    $9399d50bf3952ebe$var$load("l0N35"),
    $9399d50bf3952ebe$var$load("bU9L5"),
    $9399d50bf3952ebe$var$load("6wr18"),
    $9399d50bf3952ebe$var$load("39XCn"),
    $9399d50bf3952ebe$var$load("iYZAq"),
    $9399d50bf3952ebe$var$load("jOE2W"),
    $9399d50bf3952ebe$var$load("jTOhL"),
    $9399d50bf3952ebe$var$load("f0ENc"),
    $9399d50bf3952ebe$var$load("hhss7"),
    $9399d50bf3952ebe$var$load("ffEVr"),
    $9399d50bf3952ebe$var$load("bru8i")
]).then(()=>parcelRequire('eKNXi'));

});

parcelRegister("8y9pg", function(module, exports) {

let $6398cb9f7baba4e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6398cb9f7baba4e3$var$load("5iv5O"),
    $6398cb9f7baba4e3$var$load("iFg9Z"),
    $6398cb9f7baba4e3$var$load("kaExo"),
    $6398cb9f7baba4e3$var$load("9H9gx"),
    $6398cb9f7baba4e3$var$load("hUbK8"),
    $6398cb9f7baba4e3$var$load("fqJr7"),
    $6398cb9f7baba4e3$var$load("7H1j2"),
    $6398cb9f7baba4e3$var$load("rF2nk"),
    $6398cb9f7baba4e3$var$load("xS2oU"),
    $6398cb9f7baba4e3$var$load("4jxHc"),
    $6398cb9f7baba4e3$var$load("1Gr4q"),
    $6398cb9f7baba4e3$var$load("91eG9"),
    $6398cb9f7baba4e3$var$load("kSgPY"),
    $6398cb9f7baba4e3$var$load("7EorR"),
    $6398cb9f7baba4e3$var$load("9ZFGK"),
    $6398cb9f7baba4e3$var$load("fkLbQ"),
    $6398cb9f7baba4e3$var$load("bMNgp"),
    $6398cb9f7baba4e3$var$load("1T8H1"),
    $6398cb9f7baba4e3$var$load("fyKFO"),
    $6398cb9f7baba4e3$var$load("d9sg7"),
    $6398cb9f7baba4e3$var$load("l0N35"),
    $6398cb9f7baba4e3$var$load("bU9L5"),
    $6398cb9f7baba4e3$var$load("Wowvf"),
    $6398cb9f7baba4e3$var$load("6wr18"),
    $6398cb9f7baba4e3$var$load("39XCn"),
    $6398cb9f7baba4e3$var$load("f0ENc"),
    $6398cb9f7baba4e3$var$load("ffEVr"),
    $6398cb9f7baba4e3$var$load("hhss7"),
    $6398cb9f7baba4e3$var$load("6OMo6"),
    $6398cb9f7baba4e3$var$load("aaRXj"),
    $6398cb9f7baba4e3$var$load("fHlIz"),
    $6398cb9f7baba4e3$var$load("4QwAJ"),
    $6398cb9f7baba4e3$var$load("3i44s"),
    $6398cb9f7baba4e3$var$load("5kI0b"),
    $6398cb9f7baba4e3$var$load("kYkz1"),
    $6398cb9f7baba4e3$var$load("jfYeU"),
    $6398cb9f7baba4e3$var$load("b4nm1"),
    $6398cb9f7baba4e3$var$load("geXPZ"),
    $6398cb9f7baba4e3$var$load("aQ5uu"),
    $6398cb9f7baba4e3$var$load("jfSwd"),
    $6398cb9f7baba4e3$var$load("fV46K"),
    $6398cb9f7baba4e3$var$load("jOE2W"),
    $6398cb9f7baba4e3$var$load("jTOhL"),
    $6398cb9f7baba4e3$var$load("96rwC")
]).then(()=>parcelRequire('bZm0X'));

});

parcelRegister("dLAmc", function(module, exports) {

let $a05bddebe6e75ef6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a05bddebe6e75ef6$var$load("gkVge"),
    $a05bddebe6e75ef6$var$load("cvcNg"),
    $a05bddebe6e75ef6$var$load("6wr18"),
    $a05bddebe6e75ef6$var$load("hDJ0x"),
    $a05bddebe6e75ef6$var$load("xS2oU"),
    $a05bddebe6e75ef6$var$load("4jxHc"),
    $a05bddebe6e75ef6$var$load("1aqfs"),
    $a05bddebe6e75ef6$var$load("9w623"),
    $a05bddebe6e75ef6$var$load("1xRFJ"),
    $a05bddebe6e75ef6$var$load("7G12e"),
    $a05bddebe6e75ef6$var$load("kSgPY"),
    $a05bddebe6e75ef6$var$load("lgIhe"),
    $a05bddebe6e75ef6$var$load("aJLFD"),
    $a05bddebe6e75ef6$var$load("Wowvf"),
    $a05bddebe6e75ef6$var$load("f0ENc"),
    $a05bddebe6e75ef6$var$load("hhss7"),
    $a05bddebe6e75ef6$var$load("ffEVr"),
    $a05bddebe6e75ef6$var$load("4lu2a")
]).then(()=>parcelRequire('42CfU'));

});

parcelRegister("gO7sx", function(module, exports) {

let $c3c71a17b0ab230c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c3c71a17b0ab230c$var$load("hUbK8"),
    $c3c71a17b0ab230c$var$load("eOFeQ"),
    $c3c71a17b0ab230c$var$load("rF2nk"),
    $c3c71a17b0ab230c$var$load("xS2oU"),
    $c3c71a17b0ab230c$var$load("4jxHc"),
    $c3c71a17b0ab230c$var$load("6vAHn"),
    $c3c71a17b0ab230c$var$load("do5z1"),
    $c3c71a17b0ab230c$var$load("1Gr4q"),
    $c3c71a17b0ab230c$var$load("hS8gF"),
    $c3c71a17b0ab230c$var$load("7G12e"),
    $c3c71a17b0ab230c$var$load("g8A75"),
    $c3c71a17b0ab230c$var$load("91eG9"),
    $c3c71a17b0ab230c$var$load("kSgPY"),
    $c3c71a17b0ab230c$var$load("7EorR"),
    $c3c71a17b0ab230c$var$load("5pK3l"),
    $c3c71a17b0ab230c$var$load("Wowvf"),
    $c3c71a17b0ab230c$var$load("iZR3N"),
    $c3c71a17b0ab230c$var$load("jXM1T"),
    $c3c71a17b0ab230c$var$load("cvcNg"),
    $c3c71a17b0ab230c$var$load("aIze1"),
    $c3c71a17b0ab230c$var$load("6wr18"),
    $c3c71a17b0ab230c$var$load("4N1MY"),
    $c3c71a17b0ab230c$var$load("ffEVr"),
    $c3c71a17b0ab230c$var$load("f0ENc"),
    $c3c71a17b0ab230c$var$load("hhss7"),
    $c3c71a17b0ab230c$var$load("c70Sh")
]).then(()=>parcelRequire('cn3r4'));

});

parcelRegister("hxrh7", function(module, exports) {

let $cc4aacff241c491e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cc4aacff241c491e$var$load("iFg9Z"),
    $cc4aacff241c491e$var$load("kaExo"),
    $cc4aacff241c491e$var$load("hUbK8"),
    $cc4aacff241c491e$var$load("6OMo6"),
    $cc4aacff241c491e$var$load("aaRXj"),
    $cc4aacff241c491e$var$load("fHlIz"),
    $cc4aacff241c491e$var$load("4QwAJ"),
    $cc4aacff241c491e$var$load("3i44s"),
    $cc4aacff241c491e$var$load("5kI0b"),
    $cc4aacff241c491e$var$load("kYkz1"),
    $cc4aacff241c491e$var$load("jfYeU"),
    $cc4aacff241c491e$var$load("b4nm1"),
    $cc4aacff241c491e$var$load("geXPZ"),
    $cc4aacff241c491e$var$load("aQ5uu"),
    $cc4aacff241c491e$var$load("aQPuI"),
    $cc4aacff241c491e$var$load("7i9SF"),
    $cc4aacff241c491e$var$load("7H1j2"),
    $cc4aacff241c491e$var$load("rF2nk"),
    $cc4aacff241c491e$var$load("5iv5O"),
    $cc4aacff241c491e$var$load("jfSwd"),
    $cc4aacff241c491e$var$load("1dC87"),
    $cc4aacff241c491e$var$load("6UOty"),
    $cc4aacff241c491e$var$load("3fvOY"),
    $cc4aacff241c491e$var$load("xS2oU"),
    $cc4aacff241c491e$var$load("4jxHc"),
    $cc4aacff241c491e$var$load("1Gr4q"),
    $cc4aacff241c491e$var$load("91eG9"),
    $cc4aacff241c491e$var$load("kSgPY"),
    $cc4aacff241c491e$var$load("7EorR"),
    $cc4aacff241c491e$var$load("fV46K"),
    $cc4aacff241c491e$var$load("fAzyA"),
    $cc4aacff241c491e$var$load("9ZFGK"),
    $cc4aacff241c491e$var$load("fkLbQ"),
    $cc4aacff241c491e$var$load("bMNgp"),
    $cc4aacff241c491e$var$load("1T8H1"),
    $cc4aacff241c491e$var$load("fyKFO"),
    $cc4aacff241c491e$var$load("d9sg7"),
    $cc4aacff241c491e$var$load("l0N35"),
    $cc4aacff241c491e$var$load("bU9L5"),
    $cc4aacff241c491e$var$load("Wowvf"),
    $cc4aacff241c491e$var$load("4zz48"),
    $cc4aacff241c491e$var$load("cvcNg"),
    $cc4aacff241c491e$var$load("jw3lv"),
    $cc4aacff241c491e$var$load("7rqWx"),
    $cc4aacff241c491e$var$load("il8bj"),
    $cc4aacff241c491e$var$load("kG5Ju"),
    $cc4aacff241c491e$var$load("39XCn"),
    $cc4aacff241c491e$var$load("6wr18"),
    $cc4aacff241c491e$var$load("3Cky6"),
    $cc4aacff241c491e$var$load("jOE2W"),
    $cc4aacff241c491e$var$load("jTOhL"),
    $cc4aacff241c491e$var$load("f0ENc"),
    $cc4aacff241c491e$var$load("hhss7"),
    $cc4aacff241c491e$var$load("ffEVr"),
    $cc4aacff241c491e$var$load("bQzWg")
]).then(()=>parcelRequire('2zngr'));

});

parcelRegister("7BsWq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");

const $d70acb7f5d54408a$export$9143d6ac64592241 = ()=>{
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return (0, $cozmU.useMemo)(()=>({
            /**
			 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
			 * but cannot yet be cleaned up from editor component as pending rollout in other products first
			 */ 'lp-link-picker': true,
            'table-drag-and-drop': (0, $6mKj3.expVal)('platform_editor_tables_drag_and_drop', 'isEnabled', false),
            'table-with-fixed-column-widths-option': true
        }), []);
};
module.exports["useEditorFeatureFlags"] = $d70acb7f5d54408a$export$9143d6ac64592241;

});

parcelRegister("brsfB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $b6fxF = parcelRequire("b6fxF");


var $9UKrO = parcelRequire("9UKrO");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");


var $4qzKl = parcelRequire("4qzKl");


var $bumSD = parcelRequire("bumSD");


var $jlIaF = parcelRequire("jlIaF");


var $bQm3c = parcelRequire("bQm3c");


var $5XsiK = parcelRequire("5XsiK");


var $eLV9q = parcelRequire("eLV9q");

function $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c({ push: push, userId: userId, cloudId: cloudId, featureFlags: featureFlags }) {
    const intl = (0, $kSwu1.useIntl)();
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    const getNavigateToTeamsApp = (0, $eLV9q.useGetNavigateToTeamsApp)();
    const { orgId: orgId, userId: requestingUserId } = (0, $bQm3c.useSessionData)();
    const handleProfileCardActions = (0, $cozmU.useCallback)((pushProfileCardActions, loggedInUserId)=>(profileCardUserId)=>{
            const atlassianPeopleProfileUrl = (0, $4qzKl.getAtlassianPeopleProfileUrl)(profileCardUserId, null, (0, $jlIaF.CONTEXT_PATH));
            const teamsAppPersonProfileUrl = getNavigateToTeamsApp({
                type: 'USER',
                payload: {
                    userId: profileCardUserId
                }
            }).href;
            const followed = !!(profileCardUserId && feedFollowData?.followedUsers?.includes(profileCardUserId));
            return [
                {
                    label: intl.formatMessage({
                        id: "view.profile"
                    }),
                    callback: (0, $5XsiK.isTeamsAppEnabled)() ? undefined : ()=>{
                        pushProfileCardActions((0, $4qzKl.getAtlassianPeopleProfileUrl)(profileCardUserId, null, (0, $jlIaF.CONTEXT_PATH)));
                    },
                    target: (0, $5XsiK.isTeamsAppEnabled)() ? '_blank' : undefined,
                    link: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : atlassianPeopleProfileUrl
                },
                {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
                        followed: followed
                    }),
                    id: 'feed-follow-user',
                    callback: feedFollowData.getToggleFollowUser(profileCardUserId, followed, 'editor'),
                    shouldRender: (userData)=>feedFollowData.renderFeedFollow && Boolean(profileCardUserId) && profileCardUserId !== loggedInUserId && userData?.status === 'active'
                }
            ];
        }, [
        feedFollowData,
        getNavigateToTeamsApp,
        intl
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const providerPromise = (0, $9UKrO.getProfileCardProvider)(cloudId, handleProfileCardActions(push, userId), featureFlags ?? {});
        if (!(0, $iDrrr.fg)('people-teams_migrate-user-profile-card')) return providerPromise;
        return providerPromise.then((provider)=>({
                ...provider,
                renderUserMentionCard: ({ userId: mentionUserId, cloudId: mentionCloudId, children: children, referenceElement: referenceElement })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6fxF.UserProfileCardForMention), {
                        userId: mentionUserId,
                        cloudId: mentionCloudId,
                        orgId: orgId ?? '',
                        viewerId: requestingUserId ?? '',
                        referenceElement: referenceElement,
                        agent: {
                            resourceClient: (0, $bumSD.getProfileClient)(mentionCloudId, featureFlags ?? {})
                        }
                    }, children)
            }));
    }, [
        cloudId,
        handleProfileCardActions,
        push,
        userId,
        featureFlags,
        orgId,
        requestingUserId
    ]);
}
module.exports["useProfilecardProvider"] = $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c;

});

parcelRegister("9UKrO", function(module, exports) {

var $bumSD = parcelRequire("bumSD");

function $88671cc112964e63$export$ecc18d1a90c31bf8(cloudId, getActions, /**
	 * @deprecated This is no longer used we should remove in a future version
	 */ featureFlags) {
    return Promise.resolve({
        cloudId: cloudId,
        resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
        getActions: getActions
    });
}
module.exports["getProfileCardProvider"] = $88671cc112964e63$export$ecc18d1a90c31bf8;

});

parcelRegister("3XJlr", function(module, exports) {

let $2e2a0e524e7433bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2e2a0e524e7433bf$var$load("hhss7"),
    $2e2a0e524e7433bf$var$load("1sNyt")
]).then(()=>parcelRequire('ddUxf'));

});

parcelRegister("hMB4W", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $8pcS0 = parcelRequire("8pcS0");

const $0cc2e310acfcea5e$var$INLINE_MACRO_OUTPUT_TYPE = 'INLINE';
const $0cc2e310acfcea5e$var$MAX_ADF_CONTENT_TRAVERSAL_DEPTH = 100;
// ADF block/container node types cannot be rendered inside an inline macro wrapper.
const $0cc2e310acfcea5e$var$INLINE_UNSAFE_ADF_BLOCK_NODE_TYPES = new Set([
    'blockquote',
    (0, $8pcS0.BODIED_EXTENSION_TYPE),
    'bulletList',
    'codeBlock',
    'decisionList',
    'expand',
    (0, $8pcS0.REGULAR_EXTENSION_TYPE),
    'heading',
    'layoutColumn',
    'layoutSection',
    'mediaGroup',
    'mediaSingle',
    (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
    'nestedExpand',
    'orderedList',
    'panel',
    'rule',
    'table',
    'taskList'
]);
const $0cc2e310acfcea5e$var$isAdfLikeNode = (value)=>Boolean(value && typeof value === 'object' && 'type' in value);
const $0cc2e310acfcea5e$var$pushArrayContent = (stack, content, depth)=>{
    for(let index = content.length - 1; index >= 0; index -= 1)stack.push({
        content: content[index],
        depth: depth
    });
};
const $0cc2e310acfcea5e$var$isLegacyContentBlockExtension = (node)=>node.attrs?.extensionType === (0, $8pcS0.EXTENSION_TYPE).MIGRATION && node.type !== (0, $8pcS0.INLINE_EXTENSION_TYPE);
const $0cc2e310acfcea5e$var$isInlineUnsafeAdfBlockNode = (node)=>typeof node.type === 'string' && $0cc2e310acfcea5e$var$INLINE_UNSAFE_ADF_BLOCK_NODE_TYPES.has(node.type);
const $0cc2e310acfcea5e$var$containsInlineUnsafeContent = (initialContent)=>{
    const stack = [
        {
            content: initialContent,
            depth: 0
        }
    ];
    const visited = new WeakSet();
    while(stack.length){
        const entry = stack.pop();
        if (!entry) continue;
        const { content: currentContent, depth: depth } = entry;
        if (!currentContent || typeof currentContent === 'string') continue;
        if (depth > $0cc2e310acfcea5e$var$MAX_ADF_CONTENT_TRAVERSAL_DEPTH) return true;
        if (Array.isArray(currentContent)) {
            $0cc2e310acfcea5e$var$pushArrayContent(stack, currentContent, depth);
            continue;
        }
        if (!$0cc2e310acfcea5e$var$isAdfLikeNode(currentContent)) continue;
        if (visited.has(currentContent)) continue;
        visited.add(currentContent);
        if ($0cc2e310acfcea5e$var$isLegacyContentBlockExtension(currentContent) || $0cc2e310acfcea5e$var$isInlineUnsafeAdfBlockNode(currentContent)) return true;
        stack.push({
            content: currentContent.content,
            depth: depth + 1
        });
        stack.push({
            content: currentContent.attrs?.parameters?.nestedContent,
            depth: depth + 1
        });
    }
    return false;
};
function $0cc2e310acfcea5e$export$6eb9f199796a82af(extensionParams) {
    // Always display excerpt as block
    if (extensionParams?.extensionKey === 'excerpt') return false;
    if ($0cc2e310acfcea5e$var$containsInlineUnsafeContent(extensionParams?.content) && (0, $9wGTI.fg)('confluence_fix_migrated_macro_inline_rendering')) return false;
    return Boolean(extensionParams?.parameters?.macroParams?.['atlassian-macro-output-type']?.value === $0cc2e310acfcea5e$var$INLINE_MACRO_OUTPUT_TYPE);
}
module.exports["shouldDisplayExtensionAsInline"] = $0cc2e310acfcea5e$export$6eb9f199796a82af;

});

parcelRegister("3WO8q", function(module, exports) {
/**
 * @generated SignedSource<<fe06600cc559f558a289ccb207edd4fd>>
 * @relayHash 71c94317b822094613bae175c3a66d36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fbaa3ee68b6ac2cd5fd36baecaa22799cd3dbe90afe1df714af04960a657bb74
const $59078742ed079e5f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "taskId"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "cid",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        },
                        {
                            "kind": "Variable",
                            "name": "taskId",
                            "variableName": "taskId"
                        },
                        {
                            "kind": "Literal",
                            "name": "trigger",
                            "value": "VIEW_PAGE"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "inlineTasksInput"
                }
            ],
            "concreteType": "GraphQLMutationResponse",
            "kind": "LinkedField",
            "name": "setTaskStatus",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SetTaskStatusMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SetTaskStatusMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "71c94317b822094613bae175c3a66d36",
            "id": "fbaa3ee68b6ac2cd5fd36baecaa22799cd3dbe90afe1df714af04960a657bb74",
            "metadata": {},
            "name": "SetTaskStatusMutation",
            "operationKind": "mutation",
            "text": "mutation SetTaskStatusMutation($contentId:ID!,$taskId:ID!,$status:TaskStatus!){setTaskStatus(inlineTasksInput:{cid:$contentId,taskId:$taskId,status:$status,trigger:VIEW_PAGE}){success}}"
        }
    };
}();
$59078742ed079e5f$var$node.hash = "b0fcb034a764e654bff661127582f078";
var $59078742ed079e5f$export$2e2bcd8739ae039 = $59078742ed079e5f$var$node;



var $kSwu1 = parcelRequire("kSwu1");

const $c88a9f0357b47b1b$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "fabric-media-support.tasklist.error.flag.title",
        defaultMessage: "Something went wrong"
    },
    flagDescription: {
        id: "fabric-media-support.tasklist.error.flag.description",
        defaultMessage: "An error occurred while trying to change a task\u2019s status. Please try again later."
    }
});



var $6s78L = parcelRequire("6s78L");

class $cc5c5911f5458682$export$bfe822b045233127 {
    toggleTask(objectKey, state) {
        if (this._toggleTaskCallback) {
            this._toggleTaskCallback(objectKey, state);
            return Promise.resolve(state);
        } else /**
       * Using objectKey.objectAri may be a better alternative to passing in
       * contentId to the constructor. If it's reliable.
       */ return (0, $6s78L.mutateInterop)({
            mutation: (0, $59078742ed079e5f$export$2e2bcd8739ae039),
            variables: {
                contentId: this.contentId,
                taskId: objectKey.localId,
                status: state === 'DONE' ? 'CHECKED' : 'UNCHECKED'
            },
            __callerPackage__: "fabric-media-support"
        }).then((response)=>{
            const success = response?.data?.setTaskStatus?.success || false;
            if (!success) this.showErrorFlag();
            return state;
        }).catch(// this method is set to return `any` as a workaround for types.
        // Given that `TaskDecisionProvider.toggleTask` does not actually permit
        // `void` to be returned, what the `catch` block should probably be doing
        // is re-throwing the error that it got (at least that might match the
        // expectations). Since doing that will result in actual behavior changes
        // which I'm hesitant to perform, TS is simply silenced by `ny`-ing the
        // return type.
        (_)=>{
            /**
         * Note: there seems to be an issue whereby clicking a checkbox twice
         * quickly causes an error. I'm guessing something's not happy with a
         * mutation being issued while the previous one was still in-flight.
         * KTLO: we should probably create a queue as a workaround.
         * I'm (mdean2) not fixing this right now because I'm up against the
         * clock and the previous classic implementation suffered the same
         * problem.
         */ this.showErrorFlag();
        });
    }
    showErrorFlag() {
        this.flags.showErrorFlag({
            title: this.intl.formatMessage((0, $c88a9f0357b47b1b$export$a7357cdd1f0b0168).flagTitle),
            description: this.intl.formatMessage((0, $c88a9f0357b47b1b$export$a7357cdd1f0b0168).flagDescription)
        });
    }
    // Below are stubs, implemented to pacify TypeScript, and inherited from old
    // classic implementation.
    notifyRecentUpdates(_updateContext) {}
    subscribe(_objectKey, _handler) {}
    unsubscribe(_objectKey, _handler) {}
    unsubscribeRecentUpdates(_id) {}
    /* eslint-disable no-useless-constructor */ constructor(intl, flags, contentId, toggleTaskCallback){
        this.intl = intl;
        this.flags = flags;
        this.contentId = contentId;
        this.toggleTaskCallback = toggleTaskCallback;
        this._toggleTaskCallback = void 0;
        /**
     * eslint mistakenly thinks this is a useless constructor. It's not,
     * because TypeScript translates the 'public' arguments to actual code that
     * assigns them to instance variables.
     */ this._toggleTaskCallback = toggleTaskCallback;
    }
}
module.exports["ConfluenceTaskDecisionProvider"] = $cc5c5911f5458682$export$bfe822b045233127;

});

parcelRegister("gxhb8", function(module, exports) {
/* eslint-disable no-useless-constructor */ class $6c53b0825160fdb5$export$9a91b236871b318c {
    onFlush(callback) {
        if (!(callback instanceof Function)) throw new Error(`"onFlush" callback is supposed to be a function; saw ${typeof callback} instead`);
        this.onFlushCallback = callback;
    }
    /**
   * Forcefully flushes the batcher. Noop if current batch is empty.
   */ forceFlush() {
        // Currently force-flush is synchronous. Make sure the call sites are updated if
        // this is changed to a promise-based approach
        this.flush();
    }
    renewBatch() {
        const oldBatch = this.currentBatch;
        this.currentBatch = [];
        return oldBatch;
    }
    scheduleFlush() {
        if (!this.flushIntervalId) this.flushIntervalId = window.setInterval(this.flush, this.flushIntervalMs);
    }
    unscheduleFlush() {
        if (this.flushIntervalId) {
            window.clearInterval(this.flushIntervalId);
            this.flushIntervalId = undefined;
        }
    }
    constructor(flushIntervalMs){
        this.flushIntervalMs = flushIntervalMs;
        this.flushIntervalId = void 0;
        this.onFlushCallback = void 0;
        this.currentBatch = [];
        this.add = (item)=>{
            this.scheduleFlush();
            // If there's a previous task action for the same task, remove it
            this.currentBatch = this.currentBatch.filter((task)=>task.objectKey.localId !== item.objectKey.localId);
            this.currentBatch.push(item);
        };
        this.flush = ()=>{
            const batch = this.renewBatch();
            this.unscheduleFlush();
            if (batch.length === 0) return;
            try {
                if (this.onFlushCallback) this.onFlushCallback(batch);
            } catch (e) {
                // rethrow error asynchronously to allow other callbacks to execute
                setTimeout(()=>{
                    /* eslint-disable-next-line no-console */ console.error(`"onFlush" callback threw the below error. Please make sure your callbacks have proper error handling`);
                    throw e;
                }, 0);
            }
        };
    }
}
module.exports["TaskBatcher"] = $6c53b0825160fdb5$export$9a91b236871b318c;

});

parcelRegister("dXIrr", function(module, exports) {
/* PromptPopupContainer.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $2ot3O = parcelRequire("2ot3O");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $7EIq6 = parcelRequire("7EIq6");


var $cLo2u = parcelRequire("cLo2u");


var $kDja4 = parcelRequire("kDja4");


var $eVXGa = parcelRequire("eVXGa");


var $1xpoY = parcelRequire("1xpoY");

/**
 * @generated SignedSource<<b83f28e1481ddab674d916893c028e42>>
 * @relayHash 1f09213993754544aa08c52be2fc631e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee3ea7480262edcd30a9dd3f6f311ba153c2654db843999d0fe18c7084a28006
const $e21fff8b5a3f62da$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "contentType",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaywallContentSingle",
            "kind": "LinkedField",
            "name": "paywallContentToDisable",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "deactivationIdentifier"
                },
                {
                    "kind": "ScalarField",
                    "name": "link"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "paywallContentToDisable(contentType:\"whiteboard\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "PromptPopupPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "PromptPopupPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1f09213993754544aa08c52be2fc631e",
            "id": "ee3ea7480262edcd30a9dd3f6f311ba153c2654db843999d0fe18c7084a28006",
            "metadata": {},
            "name": "PromptPopupPaywallContentToDisableQuery",
            "operationKind": "query",
            "text": "query PromptPopupPaywallContentToDisableQuery{paywallContentToDisable(contentType:\"whiteboard\"){deactivationIdentifier,link,title}}"
        }
    };
}();
$e21fff8b5a3f62da$var$node.hash = "bb7d0d4a20298d54ac0ea3dd0fe0a1fe";
var $e21fff8b5a3f62da$export$2e2bcd8739ae039 = $e21fff8b5a3f62da$var$node;


/**
 * @generated SignedSource<<7648391b8de4ac887295688e41a4af1f>>
 * @relayHash 536bd75db3cd2df747c3923dbbdfb5dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a306fd79e49849de127258c16f0e3c415f73f67ee0a405b5bc08ec6ef1826cb1
const $c29180730df60abf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createdInContentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "type"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "createdInContentId",
                            "variableName": "createdInContentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "type",
                            "variableName": "type"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentInline",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PromptPopupCreateContentInlineMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PromptPopupCreateContentInlineMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "536bd75db3cd2df747c3923dbbdfb5dd",
            "id": "a306fd79e49849de127258c16f0e3c415f73f67ee0a405b5bc08ec6ef1826cb1",
            "metadata": {},
            "name": "PromptPopupCreateContentInlineMutation",
            "operationKind": "mutation",
            "text": "mutation PromptPopupCreateContentInlineMutation($createdInContentId:ID!,$spaceKey:String,$type:String!){createContentInline(input:{createdInContentId:$createdInContentId,spaceKey:$spaceKey,type:$type}){id}}"
        }
    };
}();
$c29180730df60abf$var$node.hash = "7e424a27911cd9ea50caa4b8ef0b5877";
var $c29180730df60abf$export$2e2bcd8739ae039 = $c29180730df60abf$var$node;






var $kSwu1 = parcelRequire("kSwu1");


var $4n1IT = parcelRequire("4n1IT");


var $hBYtq = parcelRequire("hBYtq");


var $w6R6I = parcelRequire("w6R6I");


var $dVbiN = parcelRequire("dVbiN");


var $chu6R = parcelRequire("chu6R");


var $9DHhW = parcelRequire("9DHhW");





var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $euL71 = parcelRequire("euL71");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $bMPhU = parcelRequire("bMPhU");





var $fhofE = parcelRequire("fhofE");











var $3jwuS = parcelRequire("3jwuS");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");

const $48b719f4930c6be4$export$c2b5ddd2c8b4a98c = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ mode: livePageMode }] = (0, $efvKr.useLivePageMode)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    return (0, $cozmU.useMemo)(()=>{
        if (isLivePage) return {
            isLivePage: isLivePage,
            pageMode: livePageMode || 'view' // 'edit' or 'view' for live pages
        };
        return {
            isLivePage: isLivePage,
            pageMode: isEditorPage ? 'edit' : 'view' // 'edit' or 'view' for classic pages
        };
    }, [
        isLivePage,
        livePageMode,
        isEditorPage
    ]);
};





const $6bf1a4c43dd25981$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    titleWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.title-whiteboard",
        defaultMessage: "Try Confluence whiteboards"
    },
    descriptionDefaultWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.description-default-whiteboard",
        defaultMessage: "To brainstorm and ideate without switching tools, try Confluence whiteboards."
    },
    descriptionImportWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.description-import-whiteboard",
        defaultMessage: "Reduce context switching by importing your work to a Confluence whiteboard instead."
    },
    createButtonDefaultWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.create-button-default-whiteboard",
        defaultMessage: "Create a whiteboard"
    },
    createButtonImportWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.create-button-import-whiteboard",
        defaultMessage: "Import from {competitorName}"
    },
    dismissButton: {
        id: "prompt-competitor-link.prompt-whiteboard.dismiss-button",
        defaultMessage: "Do not show for whiteboards again"
    },
    whiteboardIconAltText: {
        id: "prompt-competitor-link.prompt-whiteboard.icon-alt-text",
        defaultMessage: "Confluence Whiteboard"
    },
    successFlagTitle: {
        id: "prompt-competitor-link.prompt-whiteboard.success-flag-title",
        defaultMessage: "Whiteboard added to content tree"
    },
    successFlagDescription: {
        id: "prompt-competitor-link.prompt-whiteboard.success-flag-description",
        defaultMessage: "The whiteboard has been created in the tree. Go to the whiteboard to move its location or change its permissions."
    },
    successFlagAction: {
        id: "prompt-competitor-link.prompt-whiteboard.success-flag-action",
        defaultMessage: "Go to whiteboard"
    },
    createdFlagTitle: {
        id: "prompt-competitor-link.prompt-whiteboard.created-flag-title",
        defaultMessage: "Whiteboard successfully created"
    },
    createdFlagDescription: {
        id: "prompt-competitor-link.prompt-whiteboard.created-flag-description",
        defaultMessage: "This whiteboard was created as a child item of the content you were working on."
    },
    createdFlagAction: {
        id: "prompt-competitor-link.prompt-whiteboard.created-flag-action",
        defaultMessage: "Go back to previous content"
    },
    defaultErrorFlagTitle: {
        id: "prompt-competitor-link.prompt-whiteboard.default-error-flag-title",
        defaultMessage: "We\u2019re unable to create right now"
    },
    defaultErrorFlagDescription: {
        id: "prompt-competitor-link.prompt-whiteboard.default-error-flag-description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    }
});






var $bDjVc = parcelRequire("bDjVc");


/* PromptContent.tsx generated by @compiled/babel-plugin v0.40.0 */ 












var $4aRua = parcelRequire("4aRua");


var $4ez2K = parcelRequire("4ez2K");


var $I7hWB = parcelRequire("I7hWB");


var $lSQgn = parcelRequire("lSQgn");


var $9NPFC = parcelRequire("9NPFC");


var $6TaGl = parcelRequire("6TaGl");








var $9wGTI = parcelRequire("9wGTI");

/* DismissComponent.tsx generated by @compiled/babel-plugin v0.40.0 */ 











const $b04ce10a80ad12d8$var$styles = {
    dismissPressable: "_bfhk1bhr _ca0qpxbi _n3tdpxbi _19bv1ejb _u5f31ejb"
};
const $b04ce10a80ad12d8$export$d83330dc6e78fd41 = ({ dismissMessage: dismissMessage, onDismiss: onDismiss })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        xcss: $b04ce10a80ad12d8$var$styles.dismissPressable,
        onClick: onDismiss,
        testId: "competitor-link-prompt-dismiss-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, intl.formatMessage(dismissMessage)));
};


const $1a72f80624178457$var$styles = {
    iconContainer: "_zulppxbi",
    titleContainer: "_1bah1yb4 _4cvr1h6o _1bsb1osq",
    popupBox: "_18s8pxbi _1bsb1gwv",
    popupDescription: "_19pku2gc _otyrpxbi",
    textContainer: "_1e0c1txw _2lx21bp4 _4cvr1y6m _ca0qv77o _n3tdv77o",
    ctaStyles: "_1yt4ze3t _18s8ze3t _4bfu1r31 _1hms8stv _ajmmnqa1 _11c8fhey _syaz13af _bfhk1j28 _9oik1r31 _1bnxglyw _jf4cnqa1",
    showMoreIcon: "_bfhksm61"
};
const $1a72f80624178457$export$500652e4aa00ed2f = ({ titleText: titleText, descriptionText: descriptionText, ctaText: ctaText, dismissText: dismissText, contentIcon: ContentIcon, iconColor: iconColor, iconAltText: iconAltText, onClickAction: onClickAction, contentType: contentType, onDismiss: onDismiss, competitorName: competitorName, linkType: linkType, editorAppearance: editorAppearance, pageAnalyticsAttributes: pageAnalyticsAttributes })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isDismissMenuOpen, setIsDismissMenuOpen] = (0, $cozmU.useState)(false);
    const handleMoreMenuClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptMoreMenu',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setIsDismissMenuOpen(!isDismissMenuOpen);
    };
    const handleDismissClose = ()=>{
        setIsDismissMenuOpen(false);
    };
    const dismissPopup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        shouldRenderToParent: false,
        isOpen: isDismissMenuOpen,
        onClose: handleDismissClose,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b04ce10a80ad12d8$export$d83330dc6e78fd41), {
                dismissMessage: dismissText,
                onDismiss: ()=>{
                    onDismiss();
                    handleDismissClose();
                }
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
                ...triggerProps,
                xcss: $1a72f80624178457$var$styles.showMoreIcon,
                onClick: handleMoreMenuClick,
                testId: "competitor-link-prompt-dismiss-menu"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                label: intl.formatMessage(dismissText),
                size: "medium"
            }))
    });
    const titleSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        xcss: $1a72f80624178457$var$styles.titleContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, intl.formatMessage(titleText)), dismissPopup);
    const contentSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $1a72f80624178457$var$styles.popupDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, intl.formatMessage(descriptionText, {
        competitorName: competitorName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        onClick: onClickAction,
        xcss: $1a72f80624178457$var$styles.ctaStyles
    }, intl.formatMessage(ctaText, {
        competitorName: competitorName
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $1a72f80624178457$var$styles.popupBox,
        testId: "competitor-link-prompt-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        xcss: $1a72f80624178457$var$styles.iconContainer
    }, (0, $9wGTI.fg)('confluence_frontend_tile_object_system_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        key: `${contentType}Icon`,
        testId: `competitor-link-prompt-content-tile-${contentType}`,
        label: intl.formatMessage(iconAltText),
        backgroundColor: "color.background.accent.teal.subtle",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ContentIcon, {
        size: "small",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        key: `${contentType}Icon`,
        icon: ContentIcon,
        label: intl.formatMessage(iconAltText),
        appearance: iconColor,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $1a72f80624178457$var$styles.textContainer
    }, titleSection, contentSection)));
};



const $3309093763baedfe$export$f9c9b82deaeecce8 = ({ competitorName: competitorName, linkType: linkType, editorAppearance: editorAppearance, displayImportCta: displayImportCta, onClickAction: onClickAction, onDismiss: onDismiss })=>{
    const pageAnalyticsAttributes = (0, $48b719f4930c6be4$export$c2b5ddd2c8b4a98c)();
    // Determine content based on import CTA
    const descriptionText = displayImportCta ? (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).descriptionImportWhiteboard : (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).descriptionDefaultWhiteboard;
    const ctaText = displayImportCta ? (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).createButtonImportWhiteboard : (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).createButtonDefaultWhiteboard;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a72f80624178457$export$500652e4aa00ed2f), {
        titleText: (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).titleWhiteboard,
        descriptionText: descriptionText,
        ctaText: ctaText,
        dismissText: (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).dismissButton,
        contentIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        iconColor: "tealBold",
        iconAltText: (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).whiteboardIconAltText,
        onClickAction: onClickAction,
        contentType: "whiteboard",
        onDismiss: onDismiss,
        competitorName: competitorName,
        linkType: linkType,
        editorAppearance: editorAppearance,
        pageAnalyticsAttributes: pageAnalyticsAttributes
    });
};


const $02f57d39ae5b5c3c$var$styles = {
    pressable: "_1yt41b66 _2rko12b0 _1bsb1tcg _4t3i1tcg",
    pressableClosed: "_bfhkp2ly _irr3kca2",
    pressableOpen: "_1a37fqqo _bfhkkca2 _1cwg1i6y"
};
const $02f57d39ae5b5c3c$var$CREATE_CONTENT_INLINE = (0, $c29180730df60abf$export$2e2bcd8739ae039);
const $02f57d39ae5b5c3c$var$PAYWALL_CONTENT_TO_DISABLE = (0, $e21fff8b5a3f62da$export$2e2bcd8739ae039);
const $02f57d39ae5b5c3c$var$IMPORTER_COMPETITORS = [
    'miro',
    'mural'
];
const $02f57d39ae5b5c3c$var$PromptComponent = ({ competitorName: competitorName, linkType: linkType, contentType: contentType, editorAppearance: editorAppearance })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const spaceKey = (0, $cLo2u.useSpaceKey)() || '';
    const [currentPageId] = (0, $ep3mz.usePageContentId)();
    const [currentContentType] = (0, $ep3mz.useContentType)();
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey); // Blogs cannot have child content, so fall back to space homepage
    const parentContentId = currentContentType === 'blogpost' ? homepageId : currentPageId;
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const pageAnalyticsAttributes = (0, $48b719f4930c6be4$export$c2b5ddd2c8b4a98c)();
    const { showFlag: showFlag } = (0, $2ot3O.useFlags)();
    const isImport = $02f57d39ae5b5c3c$var$IMPORTER_COMPETITORS.some((competitor)=>competitorName?.toLowerCase().includes(competitor));
    const { data: paywallData, loading: paywallContentLoading } = (0, $jMyy4.useQueryInterop)($02f57d39ae5b5c3c$var$PAYWALL_CONTENT_TO_DISABLE, {
        skip: contentType !== 'whiteboard' || !isImport || edition === (0, $euL71.ConfluenceEdition).PREMIUM,
        fetchPolicy: 'no-cache',
        __callerPackage__: "prompt-competitor-link"
    });
    const paywallContentToDisable = paywallData?.paywallContentToDisable;
    const displayWbImportCta = contentType === 'whiteboard' && isImport && !paywallContentLoading && !(paywallContentToDisable?.deactivationIdentifier && paywallContentToDisable?.link && paywallContentToDisable?.title);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptPopup',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false',
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName,
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false'
                }
            }
        }).fire();
    }, [
        competitorName,
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        displayWbImportCta,
        contentType,
        editorAppearance
    ]);
    const [createContentInline, { loading: createContentLoading }] = (0, $308Wd.useMutationInterop)($02f57d39ae5b5c3c$var$CREATE_CONTENT_INLINE, {
        onCompleted: (data)=>{
            const contentId = data?.createContentInline?.id;
            if (!contentId) throw Error('no content id present');
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'createdByFlow',
                    actionSubject: 'content',
                    objectId: contentId,
                    objectType: contentType,
                    containerId: spaceKey,
                    containerType: 'space',
                    source: 'competitorLink',
                    attributes: {
                        flow: 'competitorLink',
                        contentType: contentType,
                        linkType: linkType,
                        isImport: displayWbImportCta ? 'true' : 'false',
                        editorAppearance: editorAppearance,
                        ...pageAnalyticsAttributes
                    },
                    nonPrivacySafeAttributes: {
                        linkDomain: competitorName
                    }
                }
            }).fire();
            setOnboardingState({
                key: (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED,
                value: 'true'
            });
            let url = (0, $fhofE.getFullWhiteboardUrl)(contentId, spaceKey);
            if (displayWbImportCta) {
                const urlObj = new URL(url);
                const searchParams = new URLSearchParams(urlObj.search);
                searchParams.set(`open${competitorName}ImportTool`, 'true');
                urlObj.search = searchParams.toString();
                url = urlObj.toString();
            }
            window.open(url, '_blank', 'noreferrer, noopener');
            showFlag?.({
                id: 'competitor-link-success-flag',
                title: intl.formatMessage((0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).successFlagTitle),
                description: intl.formatMessage((0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).successFlagDescription),
                isAutoDismiss: false,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                    color: "var(--ds-icon-success, #6A9A23)",
                    label: "success"
                }),
                actions: [
                    {
                        content: intl.formatMessage((0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).successFlagAction),
                        href: url,
                        onClick: ()=>{
                            createAnalyticsEvent({
                                type: 'sendUIEvent',
                                data: {
                                    action: 'clicked',
                                    actionSubject: 'competitorLinkPrompt',
                                    actionSubjectId: 'contentSuccessFlagAction',
                                    source: 'competitorLink',
                                    attributes: {
                                        linkContentType: contentType,
                                        linkType: linkType,
                                        ...pageAnalyticsAttributes
                                    }
                                }
                            }).fire();
                        }
                    }
                ]
            });
        },
        __callerPackage__: "prompt-competitor-link"
    });
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptDismiss',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setOnboardingState({
            key: (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED,
            value: 'true'
        });
    }, [
        setOnboardingState,
        contentType,
        createAnalyticsEvent,
        linkType,
        editorAppearance,
        pageAnalyticsAttributes
    ]);
    const handleLinkClick = async ()=>{
        if (createContentLoading || !parentContentId) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'createButton',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false',
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName,
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false'
                }
            }
        }).fire();
        await createContentInline({
            variables: {
                createdInContentId: parentContentId,
                spaceKey: spaceKey,
                type: contentType
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3309093763baedfe$export$f9c9b82deaeecce8), {
        competitorName: competitorName,
        linkType: linkType,
        editorAppearance: editorAppearance,
        displayImportCta: displayWbImportCta,
        onClickAction: handleLinkClick,
        onDismiss: handleDismiss
    }));
};
const $02f57d39ae5b5c3c$export$79356a2b3ed5a31d = ({ competitorName: competitorName, linkType: linkType, contentType: contentType, editorAppearance: editorAppearance })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const pageAnalyticsAttributes = (0, $48b719f4930c6be4$export$c2b5ddd2c8b4a98c)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptIcon',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName
                }
            }
        }).fire();
    }, [
        competitorName,
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        contentType,
        editorAppearance
    ]);
    const handlePromptPopupClose = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptPopup',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setIsOpen(false);
    }, [
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        contentType,
        editorAppearance
    ]);
    const handlePromptPopupClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen) handlePromptPopupClose();
        else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'competitorLinkPrompt',
                    actionSubjectId: 'promptIcon',
                    source: 'competitorLink',
                    attributes: {
                        linkContentType: contentType,
                        linkType: linkType,
                        editorAppearance: editorAppearance,
                        ...pageAnalyticsAttributes
                    }
                }
            }).fire();
            setIsOpen(!isOpen);
        }
    }, [
        createAnalyticsEvent,
        handlePromptPopupClose,
        isOpen,
        linkType,
        pageAnalyticsAttributes,
        contentType,
        editorAppearance
    ]);
    return(// TODO: Add `shouldRenderToParent = true` to make popup experience accessible. See https://a11y.atlassian.net/browse/JCATS-788
    // shouldRenderToParent currently forced to false to prevent popup from being rendered in the wrong place
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        shouldRenderToParent: false,
        isOpen: isOpen,
        onClose: handlePromptPopupClose,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($02f57d39ae5b5c3c$var$PromptComponent, {
                competitorName: competitorName,
                linkType: linkType,
                contentType: contentType
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
                ...triggerProps,
                onClick: handlePromptPopupClick,
                xcss: (0, $w6R6I.cx)($02f57d39ae5b5c3c$var$styles.pressable, isOpen ? $02f57d39ae5b5c3c$var$styles.pressableOpen : $02f57d39ae5b5c3c$var$styles.pressableClosed),
                testId: "competitor-link-prompt-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))), {
                color: "var(--ds-icon-discovery, #AF59E1)",
                label: intl.formatMessage((0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).titleWhiteboard)
            }))
    }));
};


const $ded78f64c507c664$var$styles = {
    promptContainer: "_1e0c116y _4cvr1h6o _2hwxv77o _18u0v77o"
};
const $ded78f64c507c664$var$VALID_LINK_TYPES = [
    'inline',
    'card',
    'embed'
];
const $ded78f64c507c664$var$WHITEBOARD_COMPETITORS = [
    {
        name: 'Miro',
        domains: [
            /miro\.com/i
        ]
    },
    {
        name: 'Mural',
        domains: [
            /mural\.co/i
        ]
    },
    {
        name: 'Lucid',
        domains: [
            /lucid\.co/i,
            /lucid\.app/i
        ]
    },
    {
        name: 'Microsoft Whiteboard',
        domains: [
            /whiteboard\.office\.com/i,
            /wbd\.ms/i,
            /whiteboard\.cloud\.microsoft/i
        ]
    },
    {
        name: 'Figjam',
        domains: [
            /figma\.com\/board/i
        ]
    },
    {
        name: 'Google Jamboard',
        domains: [
            /jamboard\.google\.com/i
        ]
    },
    // Note: Google Jamboard is EOL
    {
        name: 'Excalidraw',
        domains: [
            /excalidraw\.com/i
        ]
    },
    {
        name: 'Klaxoon',
        domains: [
            /klaxoon\.com/i
        ]
    }
];
const $ded78f64c507c664$var$PromptPopupContainerInner = ({ sourceUrl: sourceUrl, linkType: linkType, editorAppearance: editorAppearance })=>{
    const { data: onboardingStateData, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED
    ], false // skip
    );
    const { isPromptDismissed: isPromptWhiteboardDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData); // Whiteboard competitor eligibility check
    // isCreateWhiteboardEnabled checks if whiteboards are enabled for the space
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey ?? undefined);
    // isWhiteboardFeatureEnabled allows us to check if particular "whiteboard features" are enabled
    // in this case, we are checking if the entire "whiteboard feature" is enabled AND not opted out
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    // useIsAllowedToCreateWhiteboard checks user permissions to create a whiteboard
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const isEligibleCreateNewWhiteboard = isCreateWhiteboardEnabled && isWhiteboardsEnabled && isAllowedToCreateWhiteboard;
    const whiteboardCompetitor = $ded78f64c507c664$var$WHITEBOARD_COMPETITORS.find((competitor)=>competitor.domains.some((regex)=>regex.test(sourceUrl)));
    const whiteboardCompetitorName = isEligibleCreateNewWhiteboard ? whiteboardCompetitor?.name : undefined;
    const competitorContentType = whiteboardCompetitorName ? 'whiteboard' : undefined;
    const competitorName = whiteboardCompetitorName;
    if (!competitorContentType || !competitorName) return null;
    const validLinkType = linkType && $ded78f64c507c664$var$VALID_LINK_TYPES.includes(linkType) ? linkType : undefined;
    const contentTypeConfig = {
        whiteboard: {
            // config to exclude tenants or users from the feature
            // if not excluded, `cc_fd_prompt_competitor_link_config` will return `true`
            // `true` is the default value
            isFeatureEnabled: ()=>(0, $1xpoY.default).getBoolean('cc_fd_prompt_competitor_link_config', true),
            isDismissed: isPromptWhiteboardDismissed
        }
    };
    const { isFeatureEnabled: isFeatureEnabled, isDismissed: isDismissed } = contentTypeConfig[competitorContentType];
    return !loading && !error && !isDismissed && isFeatureEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $ded78f64c507c664$var$styles.promptContainer,
        "data-vc": "competitor-link-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $02f57d39ae5b5c3c$export$79356a2b3ed5a31d), {
        competitorName: competitorName,
        linkType: validLinkType,
        contentType: competitorContentType,
        editorAppearance: editorAppearance
    }));
};
const $ded78f64c507c664$export$342f0658478a7894 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ot3O.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ded78f64c507c664$var$PromptPopupContainerInner, props));
module.exports["PromptPopupContainer"] = $ded78f64c507c664$export$342f0658478a7894;

});

parcelRegister("fhofE", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $db55d2db1b1085cb$var$BASE_URL_META_SELECTOR = "meta[name='confluence-base-url']";
const $db55d2db1b1085cb$var$getBaseUrlForLocalhost = ()=>{
    const baseUrlFromMeta = window.document.querySelector($db55d2db1b1085cb$var$BASE_URL_META_SELECTOR)?.getAttribute('content') ?? 'https://hello.atlassian.net/wiki';
    return baseUrlFromMeta.substring(0, baseUrlFromMeta.length - 5);
};
const $db55d2db1b1085cb$export$f654b28f82155665 = ()=>{
    if (typeof window.location === 'undefined') return '';
    const baseUrl = window.location.origin;
    // If we are in localhost, we use the base URL from the meta tag
    if (new URL(baseUrl).hostname === 'localhost') return $db55d2db1b1085cb$var$getBaseUrlForLocalhost();
    return baseUrl;
};
const $db55d2db1b1085cb$export$420f191ed44b660f = (contentId, spaceKey)=>`${$db55d2db1b1085cb$export$f654b28f82155665()}${(0, $1NBp8.WHITEBOARD_BOARD).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    })}`;
module.exports["getFullWhiteboardUrl"] = $db55d2db1b1085cb$export$420f191ed44b660f;

});

parcelRegister("9Eka4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a4skX = parcelRequire("a4skX");


var $i3S9F = parcelRequire("i3S9F");


var $kwzZh = parcelRequire("kwzZh");


var $6oMcp = parcelRequire("6oMcp");


var $8Pm8w = parcelRequire("8Pm8w");


var $kyaLk = parcelRequire("kyaLk");


var $9DHhW = parcelRequire("9DHhW");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $krYZG = parcelRequire("krYZG");


var $h75sz = parcelRequire("h75sz");


var $i2lVL = parcelRequire("i2lVL");


var $d04Ge = parcelRequire("d04Ge");

var $5I78X = parcelRequire("5I78X");


var $iDrrr = parcelRequire("iDrrr");





var $4iudd = parcelRequire("4iudd");


var $amQv1 = parcelRequire("amQv1");

var $95bQO = parcelRequire("95bQO");


var $79ir6 = parcelRequire("79ir6");

var $4cJIQ = parcelRequire("4cJIQ");


var $3txmH = parcelRequire("3txmH");

const $31229fe543feeb5b$export$da661eaac6059c75 = ({ nodeProps: nodeProps, syncBlockStoreManager: syncBlockStoreManager, rendererOptions: rendererOptions, getAccountId: getAccountId })=>{
    const { resourceId: resourceId, localId: localId, fireAnalyticsEvent: fireAnalyticsEvent } = nodeProps;
    // `fireAnalyticsEvent` from NodeProps is typed as the generic
    // `AnalyticsEventPayload`. The synced-block consumers below
    // (`updateFireAnalyticsEvent`, `useFetchSyncBlockData`, `renderSyncedBlockContent`)
    // only ever invoke it with the narrower `RendererSyncBlockEventPayload`
    // union, which is a strict subset of `AnalyticsEventPayload`, so the cast
    // is safe.
    const syncBlockFireAnalyticsEvent = fireAnalyticsEvent;
    (0, $cozmU.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            // handleSSRErrorsAnalytics expects only `SyncedBlockSSRErrorAEP` — the
            // generic `fireAnalyticsEvent` from NodeProps is a superset, so the
            // cast is safe (the handler only ever calls back with that one AEP).
            (0, $amQv1.handleSSRErrorsAnalytics)(fireAnalyticsEvent);
        }, 0);
        return ()=>{
            clearTimeout(timeoutId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        syncBlockStoreManager.referenceManager.updateFireAnalyticsEvent(syncBlockFireAnalyticsEvent);
    }, [
        syncBlockStoreManager.referenceManager,
        syncBlockFireAnalyticsEvent
    ]);
    const { syncBlockInstance: syncBlockInstance, isLoading: isLoading, reloadData: reloadData, providerFactory: providerFactory, ssrProviders: ssrProviders } = (0, $4cJIQ.useFetchSyncBlockData)(syncBlockStoreManager, resourceId, localId, syncBlockFireAnalyticsEvent);
    const finalRendererOptions = (0, $cozmU.useMemo)(()=>{
        if (rendererOptions?.media?.ssr || // already has ssr config
        !ssrProviders?.media?.viewMediaClientConfig) return rendererOptions;
        const mediaSSR = {
            // Use synced block's media config so auth uses source contentId, not current page.
            // Server: during SSR; client: after hydration (avoids using page's MediaClient).
            mode: (0, $4iudd.isSSR)() ? 'server' : 'client',
            config: ssrProviders?.media.viewMediaClientConfig
        };
        return {
            ...rendererOptions,
            media: {
                ...rendererOptions?.media || {},
                ssr: mediaSSR
            }
        };
    }, [
        rendererOptions,
        ssrProviders
    ]);
    const errorForDisplay = syncBlockInstance?.error ?? (syncBlockInstance?.data?.status === 'deleted' ? {
        type: (0, $79ir6.SyncBlockError).NotFound,
        reason: syncBlockInstance.data?.deletionReason
    } : {
        type: (0, $79ir6.SyncBlockError).Errored,
        // Keep `reason` static — the block's `resourceId` is emitted as its own
        // analytics attribute, so interpolating it here would only leak the
        // identifier into the `error` string.
        reason: !resourceId ? 'missing resource id' : 'missing data'
    });
    const result = (0, $3txmH.renderSyncedBlockContent)({
        syncBlockInstance: syncBlockInstance ?? undefined,
        isLoading: isLoading,
        rendererOptions: finalRendererOptions,
        providerFactory: providerFactory,
        reloadData: reloadData,
        fireAnalyticsEvent: syncBlockFireAnalyticsEvent,
        resourceId: resourceId,
        error: errorForDisplay,
        getAccountId: getAccountId
    });
    if (result.isSuccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $95bQO.SyncBlockSharedCssClassName).renderer,
        [(0, $95bQO.SyncBlockRendererDataAttributeName)]: true
    }, result.element);
    return result.element;
};


const $d1eca226e08e8008$export$28a555a4d57f5843 = (doc)=>{
    const { content: content } = doc;
    const isEmpty = !content || !Array.isArray(content) || content.length === 0;
    const syncBlockNodes = isEmpty ? [] : content.map((node)=>(0, $d04Ge.convertSyncBlockJSONNodeToSyncBlockNode)(node)).filter((node)=>node !== undefined);
    return syncBlockNodes;
};
const $d1eca226e08e8008$export$2813820533ed0641 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { syncBlockNodes: syncBlockNodes, syncBlockProvider: syncBlockProvider, syncBlockRendererOptions: syncBlockRendererOptions, fireAnalyticsEvent: fireAnalyticsEvent, getAccountId: getAccountId, getPrefetchedData: getPrefetchedData } = t0;
    const syncBlockStoreManager = (0, $5I78X.useMemoizedSyncBlockStoreManager)(syncBlockProvider, fireAnalyticsEvent);
    let t1;
    let t2;
    if ($[0] !== getPrefetchedData || $[1] !== syncBlockStoreManager.referenceManager) {
        t1 = ()=>{
            if (getPrefetchedData) try {
                const prefetchedData = getPrefetchedData();
                syncBlockStoreManager.referenceManager.processPrefetchedData(prefetchedData);
            } catch  {}
        };
        t2 = [
            getPrefetchedData,
            syncBlockStoreManager.referenceManager
        ];
        $[0] = getPrefetchedData;
        $[1] = syncBlockStoreManager.referenceManager;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[4] !== syncBlockNodes || $[5] !== syncBlockStoreManager.referenceManager) {
        t3 = ()=>{
            if ((0, $iDrrr.fg)("platform_editor_blocks_patch_3")) {
                if (!(syncBlockStoreManager.referenceManager.hasDataProvider?.() ?? false)) return;
            }
            syncBlockStoreManager.referenceManager.fetchSyncBlocksData(syncBlockNodes);
        };
        t4 = [
            syncBlockNodes,
            syncBlockStoreManager.referenceManager
        ];
        $[4] = syncBlockNodes;
        $[5] = syncBlockStoreManager.referenceManager;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[8] !== fireAnalyticsEvent || $[9] !== getAccountId || $[10] !== syncBlockRendererOptions || $[11] !== syncBlockStoreManager) {
        t5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h75sz.ErrorBoundary), {
                component: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
                dispatchAnalyticsEvent: fireAnalyticsEvent,
                fallbackComponent: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i2lVL.SyncBlockActionsProvider), {
                fetchSyncBlockSourceInfo: (sourceAri)=>syncBlockStoreManager.referenceManager.fetchSyncBlockSourceInfoBySourceAri(sourceAri)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31229fe543feeb5b$export$da661eaac6059c75), {
                key: props.localId,
                nodeProps: props,
                syncBlockStoreManager: syncBlockStoreManager,
                rendererOptions: syncBlockRendererOptions,
                getAccountId: getAccountId
            })));
        $[8] = fireAnalyticsEvent;
        $[9] = getAccountId;
        $[10] = syncBlockRendererOptions;
        $[11] = syncBlockStoreManager;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ syncBlockNodes: syncBlockNodes, syncBlockProvider: syncBlockProvider, syncBlockRendererOptions: syncBlockRendererOptions, fireAnalyticsEvent: fireAnalyticsEvent, getAccountId: getAccountId, getPrefetchedData: getPrefetchedData })=>{
    const syncBlockStoreManager = (0, $5I78X.useMemoizedSyncBlockStoreManager)(syncBlockProvider, fireAnalyticsEvent);
    // Process prefetched data early, if available
    (0, $cozmU.useEffect)(()=>{
        if (getPrefetchedData) try {
            const prefetchedData = getPrefetchedData();
            syncBlockStoreManager.referenceManager.processPrefetchedData(prefetchedData);
        } catch  {
        // Silently ignore errors from getPrefetchedData so the fetch effect can still run
        }
    }, [
        getPrefetchedData,
        syncBlockStoreManager.referenceManager
    ]);
    // Initial fetch sync block data (will use SSR data as initial cache, or the prefetched data if available)
    (0, $cozmU.useEffect)(()=>{
        // On Jira the data provider resolves asynchronously (and is nulled on
        // `destroy()`), so an eager fetch can throw `Data provider not set`
        // (EDITOR-7860). Skip until ready; the effect re-runs (referenceManager
        // identity changes) once the provider resolves, fetching exactly once.
        // Readiness is nested under the gate so it is not consulted when the gate
        // is off (today's behaviour), while `fg()` stays a standalone condition so
        // gate exposure is tracked (@atlaskit/platform/no-preconditioning).
        if ((0, $iDrrr.fg)('platform_editor_blocks_patch_3')) {
            if (!(syncBlockStoreManager.referenceManager.hasDataProvider?.() ?? false)) return;
        }
        syncBlockStoreManager.referenceManager.fetchSyncBlocksData(syncBlockNodes);
    }, [
        syncBlockNodes,
        syncBlockStoreManager.referenceManager
    ]);
    return (0, $cozmU.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h75sz.ErrorBoundary), {
            component: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            dispatchAnalyticsEvent: fireAnalyticsEvent,
            fallbackComponent: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i2lVL.SyncBlockActionsProvider), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            fetchSyncBlockSourceInfo: (sourceAri)=>syncBlockStoreManager.referenceManager.fetchSyncBlockSourceInfoBySourceAri(sourceAri)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31229fe543feeb5b$export$da661eaac6059c75), {
            key: props.localId,
            nodeProps: props,
            syncBlockStoreManager: syncBlockStoreManager,
            rendererOptions: syncBlockRendererOptions,
            getAccountId: getAccountId
        }))), [
        syncBlockStoreManager,
        syncBlockRendererOptions,
        fireAnalyticsEvent,
        getAccountId
    ]);
};



var $4yccB = parcelRequire("4yccB");


var $isuYJ = parcelRequire("isuYJ");


var $6GQtz = parcelRequire("6GQtz");


var $jQQYu = parcelRequire("jQQYu");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $4IoVL = parcelRequire("4IoVL");


var $iP9x4 = parcelRequire("iP9x4");


var $dPJCf = parcelRequire("dPJCf");


var $60cDW = parcelRequire("60cDW");


var $32x2E = parcelRequire("32x2E");


var $gsPOZ = parcelRequire("gsPOZ");


var $dOBRD = parcelRequire("dOBRD");


var $dHSeC = parcelRequire("dHSeC");

const $70b9b34c85768a23$export$4128d9964cdd56b5 = (e, { shouldCheckIframe: shouldCheckIframe = false } = {})=>{
    const { metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = e.nativeEvent;
    const hasModifierKeyPressed = metaKey || ctrlKey || shiftKey;
    const isInIframe = shouldCheckIframe ? window.top !== window : false;
    return hasModifierKeyPressed || isInIframe;
};


/**
 * Duplicated from @confluence/linking-platform to avoid circular dependency.
 * Original: next/packages/linking-platform/src/utils/isExternalLink.ts
 */ const $f3e762af8cd6ff89$export$b98882f166bb7ce2 = (url)=>{
    if (!url) return false;
    try {
        const urlObj = new URL(url, window.location.origin);
        return urlObj.origin !== window.location.origin;
    } catch  {
        return false;
    }
};



var $1NBp8 = parcelRequire("1NBp8");




const $afbbb35f90e71c1c$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.ACCESS_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};


const $8cc710eb1f83f98d$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $f3e762af8cd6ff89$export$b98882f166bb7ce2)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $afbbb35f90e71c1c$export$50d92d69a5c05c70)());
    } else $8cc710eb1f83f98d$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $8cc710eb1f83f98d$var$handleClick = (e, url)=>{
    (0, $70b9b34c85768a23$export$4128d9964cdd56b5)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};


const $8b8ae4c054fbf670$export$f996105bf70a5c25 = (0, $dOBRD.default)((routesContext)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $8cc710eb1f83f98d$export$71eec072841e6b90)(routesContext, e, url)
        },
        link: {
            onClick: (e, url)=>(0, $8cc710eb1f83f98d$export$71eec072841e6b90)(routesContext, e, url)
        }
    } : undefined);



var $epn2u = parcelRequire("epn2u");

const $4a3ff359f5c9274c$export$6af91131bd465ca7 = (cloudId, userId, spaceKey)=>{
    return (0, $cozmU.useMemo)(()=>({
            createEmojiProvider: ()=>{
                return (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
                    cloudId: cloudId,
                    userId: userId || undefined,
                    allowAnonymousAccess: true
                });
            },
            createMediaProvider: ({ contentAri: contentAri, contentId: refSyncBlockContentId, contentProduct: contentProduct })=>{
                return (0, $4IoVL.createRendererMediaProvider)({
                    contentAri: contentAri,
                    contentId: refSyncBlockContentId,
                    contentProduct: contentProduct,
                    isExternalShare: false
                });
            },
            createSSRMediaProvider: ({ contentAri: contentAri, contentId: refSyncBlockContentId, contentProduct: contentProduct })=>{
                const mediaClientConfig = (0, $iP9x4.getMediaSSRModeAndAuthConfigMemoized)({
                    contentAri: contentAri,
                    contentId: refSyncBlockContentId,
                    contentProduct: contentProduct,
                    isExternalShare: false,
                    spaceKey: spaceKey
                });
                if (mediaClientConfig) // Return config for both server (SSR) and client (post-hydration) so synced block
                // media uses the source contentId for auth, not the current page's contentId.
                return {
                    viewMediaClientConfig: mediaClientConfig.config
                };
                return undefined;
            },
            // Uses the same logic as in preloadEditorNodeDataProvidersData.ts
            createSmartLinkProvider: ()=>{
                const { host: host, cloudId: ssrCloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
                const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
                if (objectResolverURL) {
                    const ssrCardClient = new (0, $4yccB.default)('custom', objectResolverURL);
                    ssrCardClient.setHeaders({
                        Cookie: (0, $jQQYu.createCookie)(userContext),
                        Origin: host.startsWith('http') ? host : `https://${host}`,
                        CloudId: ssrCloudId || cloudId
                    });
                    return Promise.resolve(new (0, $6GQtz.ConfluenceEditorCardProvider)('custom', objectResolverURL, undefined, ssrCardClient));
                }
                return Promise.resolve(new (0, $6GQtz.ConfluenceEditorCardProvider)());
            }
        }), [
        cloudId,
        userId,
        spaceKey
    ]);
};
const $4a3ff359f5c9274c$var$useMemoizedSyncedBlockProviderNodeComponentEnabled = ({ doc: doc, spaceKey: spaceKey, contentId: confluencePageId, contentType: contentType, mergedDataProviderDefinitions: mergedDataProviderDefinitions, stickyHeadersConfig: stickyHeadersConfig, contentMode: contentMode })=>{
    const syncBlockNodes = (0, $cozmU.useMemo)(()=>{
        return (0, $d1eca226e08e8008$export$28a555a4d57f5843)(doc);
    }, [
        doc
    ]);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const confluencePageAri = (0, $cozmU.useMemo)(()=>confluencePageId ? (0, $6oMcp.getConfluencePageAri)({
            pageId: confluencePageId,
            cloudId: cloudId,
            pageType: contentType === 'page' ? 'page' : 'blogpost'
        }) : undefined, [
        cloudId,
        confluencePageId,
        contentType
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { fetchProvider: blockServiceFetchProvider, writeProvider: blockServiceWriteProvider } = (0, $8Pm8w.useMemoizedBlockServiceAPIProviders)({
        parentAri: confluencePageAri ?? '',
        parentId: confluencePageId ?? '',
        product: 'confluence-page',
        cloudId: cloudId
    });
    // Wrap the fetch provider with Relay subscription support
    const relayFetchProvider = (0, $cozmU.useMemo)(()=>(0, $gsPOZ.createRelaySyncBlockFetchProvider)(blockServiceFetchProvider, cloudId), [
        blockServiceFetchProvider,
        cloudId
    ]);
    const syncedBlockNestedRendererProviderCreator = $4a3ff359f5c9274c$export$6af91131bd465ca7(cloudId, userId, spaceKey);
    const providerOptions = (0, $cozmU.useMemo)(()=>{
        return {
            parentDataProviders: {
                ...mergedDataProviderDefinitions
            },
            providerCreator: syncedBlockNestedRendererProviderCreator
        };
    }, [
        mergedDataProviderDefinitions,
        syncedBlockNestedRendererProviderCreator
    ]);
    const syncedBlockProvider = (0, $kyaLk.useMemoizedSyncedBlockProvider)({
        fetchProvider: relayFetchProvider,
        writeProvider: blockServiceWriteProvider,
        providerOptions: providerOptions,
        getSSRData: (0, $epn2u.syncedBlockLoadSSRData)
    });
    const handleSyncedBlockAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: payload
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    const syncedBlockEventHandlers = (0, $cozmU.useMemo)(()=>{
        return (0, $8b8ae4c054fbf670$export$f996105bf70a5c25)({
            matchRoute: matchRoute,
            push: push
        });
    }, [
        matchRoute,
        push
    ]);
    const SyncedBlockNodeComponent = (0, $d1eca226e08e8008$export$2813820533ed0641)({
        syncBlockProvider: syncedBlockProvider,
        syncBlockNodes: syncBlockNodes,
        syncBlockRendererOptions: {
            smartLinks: {
                ssr: true
            },
            eventHandlers: syncedBlockEventHandlers,
            stickyHeaders: stickyHeadersConfig ? {
                show: true,
                ...stickyHeadersConfig
            } : {
                show: true,
                offsetTop: 0
            },
            contentMode: contentMode
        },
        fireAnalyticsEvent: handleSyncedBlockAnalyticsEvent
    });
    // If confluencePageId is undefined, don't return the synced block node component, and don't render synced blocks
    return confluencePageId ? SyncedBlockNodeComponent : undefined;
};
const $4a3ff359f5c9274c$export$27db3e01691a7a01 = (_props)=>{
    return undefined;
};
const $4a3ff359f5c9274c$var$isFedrampOrIsolatedCloud = ()=>{
    return (0, $a4skX.isFedrampModerate)() || (0, $i3S9F.isIsolatedCloud)();
};
const $4a3ff359f5c9274c$export$e8874f89f60efbe6 = (0, $isuYJ.conditionalHooksFactory)(()=>!$4a3ff359f5c9274c$var$isFedrampOrIsolatedCloud() && (0, $6mKj3.isExperimentEnabled)('platform_synced_block'), $4a3ff359f5c9274c$var$useMemoizedSyncedBlockProviderNodeComponentEnabled, $4a3ff359f5c9274c$export$27db3e01691a7a01);
module.exports["useMemoizedSyncedBlockNestedRendererProviderCreator"] = $4a3ff359f5c9274c$export$6af91131bd465ca7;
module.exports["useMemoizedSyncedBlockProviderNodeComponent"] = $4a3ff359f5c9274c$export$e8874f89f60efbe6;

});

parcelRegister("kyaLk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3xsB6 = parcelRequire("3xsB6");


var $6oMcp = parcelRequire("6oMcp");


var $48FpT = parcelRequire("48FpT");

const $b7038d533618bb27$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $b7038d533618bb27$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $b7038d533618bb27$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $b7038d533618bb27$var$GET_SOURCE_INFO_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_SOURCE_INFO';
/**
 * Query to get the page subtype by id (i.e. live or classic)
 * @param documentARI
 * @returns subType live if livePage, subType null if classic page
 */ const $b7038d533618bb27$var$GET_SOURCE_INFO_QUERY = `query ${$b7038d533618bb27$var$GET_SOURCE_INFO_OPERATION_NAME} ($id: ID!, $status: [String]) {
	content (id: $id, status: $status) {
		nodes {
			id
			links {
				base
				editui
				webui
			}
			space {
				key
			}
			status
			subType
			title
		}
	}
}`;
const $b7038d533618bb27$var$getConfluenceSourceInfo = async (ari, status)=>{
    const variables = {
        id: ari
    };
    if (status) variables.status = status;
    const bodyData = {
        query: $b7038d533618bb27$var$GET_SOURCE_INFO_QUERY,
        operationName: $b7038d533618bb27$var$GET_SOURCE_INFO_OPERATION_NAME,
        variables: variables
    };
    const response = await (0, $48FpT.fetchWithRetry)($b7038d533618bb27$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$b7038d533618bb27$var$COMMON_HEADERS,
            ...$b7038d533618bb27$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get url: ${response.statusText}`);
    return await response.json();
};
const $b7038d533618bb27$var$resolveNoAccessPageInfo = async (ari)=>{
    const response = await fetch('/gateway/api/object-resolver/resolve/ari', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            ari: ari
        })
    });
    if (response.ok) {
        const payload = await response.json();
        const url = payload?.data?.url;
        const title = payload?.data?.name;
        return {
            url: typeof url === 'string' ? url : undefined,
            title: typeof title === 'string' ? title : undefined,
            sourceAri: ari
        };
    } else throw new Error(`Failed to resolve ari: ${response.statusText}`);
};
const $b7038d533618bb27$export$11ee05f70c94d3d7 = async (pageAri, hasAccess, localId)=>{
    if (hasAccess) {
        const status = [
            'draft',
            'archived',
            'current'
        ];
        const response = await $b7038d533618bb27$var$getConfluenceSourceInfo(pageAri, status);
        const contentData = response.data?.content?.nodes?.[0];
        const { title: title, subType: subType } = contentData || {};
        let url;
        const { base: base, editui: editui, webui: webui } = contentData?.links || {};
        const pageStatus = contentData?.status;
        if (base && editui && pageStatus !== 'archived') url = `${base}${editui}`;
        else if (base && webui && pageStatus === 'archived') url = `${base}${webui}`;
        url = url && localId ? `${url}#block-${localId}` : url;
        return Promise.resolve({
            title: title,
            url: url,
            sourceAri: pageAri,
            subType: subType
        });
    } else return await $b7038d533618bb27$var$resolveNoAccessPageInfo(pageAri);
};


/* eslint-disable require-unicode-regexp  */ 


const $a860b21f53e6eb68$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $a860b21f53e6eb68$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $a860b21f53e6eb68$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $a860b21f53e6eb68$var$GET_SOURCE_INFO_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_SOURCE_INFO';
/**
 * Query to get the work item url by id
 * @param id - the ID of the work item
 * @returns url of the work item
 */ // `issueType` is requested alongside `summary` and `webUrl` so the
// SyncedLocationDropdown can render the correct ADS issue-type icon.
const $a860b21f53e6eb68$var$GET_SOURCE_INFO_QUERY = `query ${$a860b21f53e6eb68$var$GET_SOURCE_INFO_OPERATION_NAME} ($id: ID!) {
  jira {
	issueById(id: $id) {
	id
	webUrl
	summary
	issueType {
		name
		avatar {
		xsmall
		}
	}
	}
  }}`;
const $a860b21f53e6eb68$var$getJiraWorkItemSourceInfo = async (ari)=>{
    const bodyData = {
        query: $a860b21f53e6eb68$var$GET_SOURCE_INFO_QUERY,
        operationName: $a860b21f53e6eb68$var$GET_SOURCE_INFO_OPERATION_NAME,
        variables: {
            id: ari
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($a860b21f53e6eb68$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$a860b21f53e6eb68$var$COMMON_HEADERS,
            ...$a860b21f53e6eb68$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get url: ${response.statusText}`);
    return await response.json();
};
const $a860b21f53e6eb68$var$resolveNoAccessWorkItemInfo = async (ari)=>{
    const response = await fetch('/gateway/api/object-resolver/resolve/ari', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            ari: ari
        })
    });
    if (response.ok) {
        const payload = await response.json();
        const url = payload?.data?.url;
        const title = payload?.data?.name;
        return {
            url: typeof url === 'string' ? url : undefined,
            title: typeof title === 'string' ? title : undefined,
            sourceAri: ari
        };
    } else throw new Error(`Failed to resolve ari: ${response.statusText}`);
};
const $a860b21f53e6eb68$export$5e43429d194de44c = async (workItemAri, hasAccess)=>{
    if (hasAccess) {
        const response = await $a860b21f53e6eb68$var$getJiraWorkItemSourceInfo(workItemAri);
        const contentData = response.data?.jira?.issueById;
        const webUrl = typeof contentData?.webUrl === 'string' ? contentData.webUrl : undefined;
        const summary = typeof contentData?.summary === 'string' ? contentData.summary : undefined;
        // Surface issue-type metadata for the SyncedLocationDropdown's ADS icon.
        // Defensive narrowing: only surface when `name` is a non-empty string;
        // AGG values like `{ name: null }` collapse back to `undefined`.
        const issueTypeName = contentData?.issueType?.name;
        const issueType = typeof issueTypeName === 'string' && issueTypeName.length > 0 ? {
            name: issueTypeName,
            iconUrl: typeof contentData?.issueType?.avatar?.xsmall === 'string' ? contentData.issueType.avatar.xsmall : undefined
        } : undefined;
        return Promise.resolve({
            url: webUrl,
            sourceAri: workItemAri,
            title: summary,
            issueType: issueType
        });
    } else return await $a860b21f53e6eb68$var$resolveNoAccessWorkItemInfo(workItemAri);
};



var $79ir6 = parcelRequire("79ir6");


var $drRzc = parcelRequire("drRzc");

class $25a65744798df56f$export$cd52318aefe371fb extends (0, $drRzc.NodeDataProvider) {
}


class $0b95be1fc334e182$export$ead9a287a0b743c7 extends (0, $25a65744798df56f$export$cd52318aefe371fb) {
    setProviderOptions(providerOptions) {
        this.providerOptions = providerOptions;
    }
    /**
   * Check if the node is supported by the provider
   *
   * @param node
   *
   * @returns True if the node is supported, false otherwise
   */ isNodeSupported(node) {
        return node.type === 'syncBlock' || node.type === 'bodiedSyncBlock';
    }
    /**
   * Get the data key for the node
   *
   * @param node
   *
   * @returns The data key
   */ nodeDataKey(node) {
        return node.attrs.resourceId;
    }
    /**
   * Fetch the data from the fetch provider using batch API
   *
   * @param nodes
   *
   * @returns Array of {resourceId?: string, error?: string}.
   */ async fetchNodesData(nodes) {
        const blockIdentifiers = nodes.map((node)=>({
                resourceId: node.attrs.resourceId,
                blockInstanceId: node.attrs.localId
            }));
        if (blockIdentifiers.length === 0) return [];
        try {
            return await this.fetchProvider.batchFetchData(blockIdentifiers);
        } catch  {
            // If batch fetch fails, fall back to individual fetch behavior
            // This allows loading states to be shown before errors, matching non-batch behavior
            return Promise.allSettled(blockIdentifiers.map((blockIdentifier)=>{
                return this.fetchProvider.fetchData(blockIdentifier.resourceId).then((data)=>{
                    return data;
                }, (error)=>{
                    return {
                        error: {
                            type: (0, $79ir6.SyncBlockError).Errored,
                            reason: error
                        },
                        resourceId: blockIdentifier.resourceId
                    };
                });
            })).then((results)=>{
                return results.filter((result)=>{
                    return result.status === 'fulfilled';
                }).map((result)=>result.value);
            });
        }
    }
    /**
   * Write the data to the write provider
   *
   * @param nodes
   * @param data
   *
   * @returns Array of {resourceId?: string, error?: string}.
   * resourceId: resource id of the node if write successfully , error: reason for when write failed
   */ async writeNodesData(nodes, data) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        // Use batch write only when method is available
        if (this.writeProvider.writeDataBatch) {
            // Separate data into valid (with content) and invalid (without content)
            const validDataWithIndices = [];
            const invalidResults = [];
            data.forEach((blockData)=>{
                if (blockData.content) validDataWithIndices.push(blockData);
                else invalidResults.push({
                    error: 'No Synced Block content to write',
                    resourceId: blockData.resourceId
                });
            });
            // Process valid data in batch
            let batchResults = [];
            if (validDataWithIndices.length > 0) batchResults = await this.writeProvider.writeDataBatch(validDataWithIndices);
            return [
                ...batchResults,
                ...invalidResults
            ];
        }
        // Fall back to individual writes
        const results = await Promise.allSettled(nodes.map((_node, index)=>{
            if (!this.writeProvider) return Promise.reject('Write provider not set');
            if (!data[index].content) return Promise.reject('No Synced Block content to write');
            return this.writeProvider?.writeData(data[index]);
        }));
        return results.map((result)=>{
            if (result.status === 'fulfilled') return result.value;
            else return {
                error: result.reason
            };
        });
    }
    createNodeData(data) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        return this.writeProvider.createData(data).then((result)=>result, (error)=>({
                error: error
            }));
    }
    /**
   * Delete the data from the write provider
   *
   * @param resourceIds
   *
   * @returns Array of {resourceId?: string, error?: string}.
   */ async deleteNodesData(resourceIds, deletionReason) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        const results = await Promise.allSettled(resourceIds.map((resourceId)=>{
            if (!this.writeProvider) return Promise.reject('Write provider not set');
            return this.writeProvider.deleteData(resourceId, deletionReason);
        }));
        return results.map((result, index)=>{
            if (result.status === 'fulfilled') return result.value;
            else return {
                resourceId: resourceIds[index],
                success: false,
                error: result.reason
            };
        });
    }
    /**
   * Fetch the source info from the source id
   *
   * @param params
   * @param params.sourceAri - The source ARI
   * @param params.sourceProduct - The source product. e.g. 'confluence-page', 'jira-work-item'
   *
   * @returns The source info
   */ async fetchSyncBlockSourceInfo(localId, sourceAri, sourceProduct, hasAccess = true) {
        const ari = sourceAri ?? this.writeProvider?.parentAri;
        const product = sourceProduct ?? (0, $3xsB6.getProductFromSourceAri)(ari);
        if (!ari || !product) return Promise.reject(new Error('Source ari or source product is undefined'));
        switch(product){
            case 'confluence-page':
                {
                    const sourceInfo = await (0, $b7038d533618bb27$export$11ee05f70c94d3d7)(ari, hasAccess, localId);
                    if (!sourceInfo) return Promise.resolve(undefined);
                    return {
                        ...sourceInfo,
                        onSameDocument: this.writeProvider?.parentAri === ari,
                        productType: product
                    };
                }
            case 'jira-work-item':
                {
                    // Note: `subType`, archived URL handling, and `isUnpublished` are intentionally
                    // omitted here — Jira work items have no equivalent page subtype or archived state.
                    // The `localId` param is intentionally not forwarded: the current Jira issue view
                    // does not scroll to `#block-{localId}` anchors, so passing it would only pollute
                    // the URL. See the parity-notes JSDoc on `fetchJiraWorkItemInfo` for the full
                    // rationale and the conditions under which this should be revisited.
                    const sourceInfo = await (0, $a860b21f53e6eb68$export$5e43429d194de44c)(ari, hasAccess);
                    if (!sourceInfo) return Promise.resolve(undefined);
                    return {
                        ...sourceInfo,
                        onSameDocument: this.writeProvider?.parentAri === ari,
                        productType: product
                    };
                }
            default:
                return Promise.reject(new Error(`${product} source product not supported`));
        }
    }
    generateResourceId() {
        const localId = crypto.randomUUID();
        const resourceId = crypto.randomUUID();
        return {
            localId: localId,
            resourceId: resourceId
        };
    }
    generateResourceIdForReference(sourceId) {
        if (!this.writeProvider) throw new Error('Write provider not set');
        return this.writeProvider.generateResourceIdForReference(sourceId);
    }
    /**
   * Get the synced block renderer provider options
   *
   * @returns The synced block renderer provider options
   */ getSyncedBlockRendererProviderOptions() {
        return this.providerOptions;
    }
    /**
   * Retrieve the parent info for the sync block
   *
   * @param sourceAri - The source ARI
   * @param sourceProduct - The source product. e.g. 'confluence-page', 'jira-work-item'
   *
   * @returns The parent info for the sync block
   */ retrieveSyncBlockParentInfo(sourceAri, sourceProduct) {
        if (!sourceAri || !sourceProduct) return undefined;
        switch(sourceProduct){
            case 'confluence-page':
                return {
                    contentAri: sourceAri,
                    contentId: (0, $6oMcp.getPageIdAndTypeFromConfluencePageAri)({
                        ari: sourceAri
                    }).id,
                    contentProduct: sourceProduct
                };
            case 'jira-work-item':
                return {
                    contentAri: sourceAri,
                    contentId: sourceAri,
                    contentProduct: sourceProduct
                };
            default:
                throw new Error(`${sourceProduct} source product not supported`);
        }
    }
    updateReferenceData(blocks, noContent) {
        if (!this.writeProvider) throw new Error('Write provider not set');
        return this.writeProvider.updateReferenceData(blocks, noContent);
    }
    fetchReferences(resourceId, isSource) {
        if (!this.fetchProvider) throw new Error('Fetch provider not set');
        return this.fetchProvider.fetchReferences(isSource ? this.generateResourceIdForReference(resourceId) : resourceId);
    }
    /**
   * Subscribes to real-time updates for a specific block.
   * @param resourceId - The resource ID of the block to subscribe to
   * @param onUpdate - Callback function invoked when the block is updated
   * @param onError - Optional callback function invoked on subscription errors
   * @returns Unsubscribe function to stop receiving updates, or undefined if not supported
   */ subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete) {
        if (this.fetchProvider.subscribeToBlockUpdates) return this.fetchProvider.subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete);
        return undefined;
    }
    /**
   * Constructor for the SyncedBlockProvider
   *
   * @param fetchProvider
   * @param writeProvider
   * @param nestedRendererDataProviders
   */ constructor(fetchProvider, writeProvider){
        super();
        this.name = 'syncBlockProvider';
        this.fetchProvider = void 0;
        this.writeProvider = void 0;
        this.providerOptions = void 0;
        this.fetchProvider = fetchProvider;
        this.writeProvider = writeProvider;
        this.providerOptions = {};
    }
}
const $0b95be1fc334e182$var$createSyncedBlockProvider = ({ fetchProvider: fetchProvider, writeProvider: writeProvider })=>{
    return new $0b95be1fc334e182$export$ead9a287a0b743c7(fetchProvider, writeProvider);
};
const $0b95be1fc334e182$export$ae97d432056ca005 = ({ fetchProvider: fetchProvider, writeProvider: writeProvider, providerOptions: providerOptions, getSSRData: getSSRData })=>{
    const syncBlockProvider = (0, $cozmU.useMemo)(()=>$0b95be1fc334e182$var$createSyncedBlockProvider({
            fetchProvider: fetchProvider,
            writeProvider: writeProvider
        }), [
        fetchProvider,
        writeProvider
    ]);
    const prevProviderOptionsRef = (0, $cozmU.useRef)(undefined);
    if (providerOptions !== prevProviderOptionsRef.current) {
        prevProviderOptionsRef.current = providerOptions;
        syncBlockProvider.setProviderOptions(providerOptions);
    }
    const prevSSRDataRef = (0, $cozmU.useRef)(undefined);
    const ssrData = getSSRData?.();
    if (ssrData !== prevSSRDataRef.current) {
        prevSSRDataRef.current = ssrData;
        if (ssrData) syncBlockProvider.setSSRData(ssrData);
    }
    return syncBlockProvider;
};
module.exports["useMemoizedSyncedBlockProvider"] = $0b95be1fc334e182$export$ae97d432056ca005;

});

parcelRegister("amQv1", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $4iudd = parcelRequire("4iudd");


var $gb05o = parcelRequire("gb05o");

const $59f6e19db6d712cc$var$isSyncedBlocksSSRErrorObj = (maybeSSRErrorObj)=>{
    if (!maybeSSRErrorObj || typeof maybeSSRErrorObj !== 'object') return false;
    const errorWrapper = maybeSSRErrorObj;
    // Check for meta object with valid code
    const hasValidMeta = errorWrapper.meta && typeof errorWrapper.meta === 'object' && Object.values((0, $gb05o.SyncedBlocksSSRErrorCodeMap)).includes(errorWrapper.meta.code);
    return Boolean(hasValidMeta);
};
/**
 * Get the first SSR error for synced blocks from the window.__SSR_ERROR__ array.
 *
 * Expected structure of error objects stored in confluence window.__SSR_ERROR__ for synced blocks SSR errors:
 *
 * @example
 * {
 *   error: {
 *     message: "Synced blocks fetch operation timed out",
 *     stack: "Error: Synced blocks fetch operation timed out\n    at /tmp/script.js:xxx:xxx"
 *   },
 *   meta: {
 *     code: "SYNCED_BLOCKS_FETCH_TIMEOUT",
 *     contentId: "XXXXXX",
 *     cloudId: "XXXX-XXXX-XXXX-XXXX-XXXX",
 *     isBlog: false,
 *     identifiers: [
 *       {
 *         resourceId: "confluence-page/XXXXXX/XXXX-XXXX-XXXX-XXXX-XXXX",
 *         blockInstanceId: "XXXX-XXXX-XXXX-XXXX-XXXX"
 *       }
 *     ]
 *   }
 * }
 *
 * @returns The first SSR error metadata, or undefined if no error found
 */ const $59f6e19db6d712cc$var$getSyncedBlocksSSRError = ()=>{
    if ((0, $4iudd.isSSR)()) return undefined;
    const ssrErrors = window.__SSR_ERROR__;
    if (Array.isArray(ssrErrors)) {
        const syncedBlockErrors = ssrErrors.filter($59f6e19db6d712cc$var$isSyncedBlocksSSRErrorObj).map((errorWrapper)=>errorWrapper.meta);
        return syncedBlockErrors.length > 0 ? syncedBlockErrors[0] : undefined;
    }
    return undefined;
};
const $59f6e19db6d712cc$export$8be916857642095b = (()=>{
    let called = false;
    // I want this fireAnalyticsEvent only takes in SyncedBlockSSRErrorAEP
    return (fireAnalyticsEvent)=>{
        if (called) return;
        called = true;
        if (!fireAnalyticsEvent) return;
        const error = $59f6e19db6d712cc$var$getSyncedBlocksSSRError();
        if (error) fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SSR_ERROR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                code: error.code,
                isBlog: error.isBlog,
                syncedBlocksCount: error.identifiers?.length || 0,
                missingSyncedBlocksCount: error.missingIdentifiers?.length || 0,
                errorMessage: error.errorMessage,
                errorName: error.errorName
            }
        });
    };
})();
module.exports["handleSSRErrorsAnalytics"] = $59f6e19db6d712cc$export$8be916857642095b;

});

parcelRegister("3txmH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $79ir6 = parcelRequire("79ir6");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $kSwu1 = parcelRequire("kSwu1");


var $aI2Eh = parcelRequire("aI2Eh");


var $6lXol = parcelRequire("6lXol");

var $3BY7M = parcelRequire("3BY7M");

var $8Kasn = parcelRequire("8Kasn");


var $hRnS5 = parcelRequire("hRnS5");


var $kS1Yv = parcelRequire("kS1Yv");


var $lpNn5 = parcelRequire("lpNn5");

const $8039e8ec23b90f97$var$ValidationContextWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            allowNestedTables: true
        };
        $[0] = t1;
    } else t1 = $[0];
    const validationContextValue = t1;
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Kasn.ValidationContextProvider), {
            value: validationContextValue
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>{
    const validationContextValue = (0, $cozmU.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Kasn.ValidationContextProvider), {
        value: validationContextValue
    }, children);
};
const $8039e8ec23b90f97$var$DisabledTaskWithTooltip = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let componentKey;
    let props;
    if ($[0] !== t0) {
        ({ componentKey: componentKey, ...props } = t0);
        $[0] = t0;
        $[1] = componentKey;
        $[2] = props;
    } else {
        componentKey = $[1];
        props = $[2];
    }
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[3] !== formatMessage) {
        t1 = formatMessage((0, $aI2Eh.syncBlockMessages).taskInDestinationSyncedBlockTooltip);
        $[3] = formatMessage;
        $[4] = t1;
    } else t1 = $[4];
    const tooltipContent = t1;
    const Component = (0, $6lXol.nodeToReact)[componentKey];
    let t2;
    if ($[5] !== Component || $[6] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...props,
            disableOnChange: true
        });
        $[5] = Component;
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== t2 || $[9] !== tooltipContent) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipContent,
            position: "auto-start"
        }, t2);
        $[8] = t2;
        $[9] = tooltipContent;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ componentKey: componentKey, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tooltipContent = formatMessage((0, $aI2Eh.syncBlockMessages).taskInDestinationSyncedBlockTooltip);
    const Component = (0, $6lXol.nodeToReact)[componentKey];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipContent,
        position: "auto-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        ...props,
        disableOnChange: true
    }));
};
const $8039e8ec23b90f97$var$defaultOptions = {
    appearance: 'full-width',
    allowAltTextOnImages: true,
    allowAnnotations: true,
    allowColumnSorting: true,
    allowCopyToClipboard: true,
    allowCustomPanels: true,
    allowPlaceholderText: true,
    allowRendererContainerStyles: true,
    allowSelectAllTrap: true,
    allowUgcScrubber: true,
    allowWrapCodeBlock: true,
    emojiResourceConfig: undefined,
    media: {
        allowLinking: true,
        allowCaptions: true,
        featureFlags: {
            mediaInline: true
        }
    },
    smartLinks: {
        ssr: true
    }
};
const $8039e8ec23b90f97$export$cc2ec5e10e7ca244 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { doc: doc, dataProviders: dataProviders, options: options } = t0;
    let t1;
    if ($[0] !== options) {
        const mergedOptions = {
            ...$8039e8ec23b90f97$var$defaultOptions,
            ...options
        };
        t1 = mergedOptions ?? {};
        $[0] = options;
        $[1] = t1;
    } else t1 = $[1];
    const { appearance: appearance, allowAltTextOnImages: allowAltTextOnImages, allowAnnotations: allowAnnotations, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowCustomPanels: allowCustomPanels, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowRendererContainerStyles: allowRendererContainerStyles, allowSelectAllTrap: allowSelectAllTrap, allowUgcScrubber: allowUgcScrubber, allowWrapCodeBlock: allowWrapCodeBlock, emojiResourceConfig: emojiResourceConfig, eventHandlers: eventHandlers, media: media, smartLinks: smartLinks, stickyHeaders: stickyHeaders, contentMode: contentMode } = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            taskItem: $8039e8ec23b90f97$var$_temp,
            blockTaskItem: $8039e8ec23b90f97$var$_temp2
        };
        $[2] = t2;
    } else t2 = $[2];
    const nodeComponents = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            nestedRendererType: "syncedBlock"
        };
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== allowAltTextOnImages || $[5] !== allowAnnotations || $[6] !== allowColumnSorting || $[7] !== allowCopyToClipboard || $[8] !== allowCustomPanels || $[9] !== allowHeadingAnchorLinks || $[10] !== allowPlaceholderText || $[11] !== allowRendererContainerStyles || $[12] !== allowSelectAllTrap || $[13] !== allowUgcScrubber || $[14] !== allowWrapCodeBlock || $[15] !== appearance || $[16] !== contentMode || $[17] !== dataProviders || $[18] !== doc || $[19] !== emojiResourceConfig || $[20] !== eventHandlers || $[21] !== media || $[22] !== smartLinks || $[23] !== stickyHeaders) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8039e8ec23b90f97$var$ValidationContextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kS1Yv.RendererContextProvider), {
            value: t3
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "sync-block-renderer-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            appearance: appearance,
            adfStage: "stage0",
            document: doc,
            disableHeadingIDs: true,
            dataProviders: dataProviders,
            nodeComponents: nodeComponents,
            allowAltTextOnImages: allowAltTextOnImages,
            allowAnnotations: allowAnnotations,
            allowColumnSorting: allowColumnSorting,
            allowCopyToClipboard: allowCopyToClipboard,
            allowCustomPanels: allowCustomPanels,
            allowHeadingAnchorLinks: allowHeadingAnchorLinks,
            allowPlaceholderText: allowPlaceholderText,
            allowRendererContainerStyles: allowRendererContainerStyles,
            allowSelectAllTrap: allowSelectAllTrap,
            allowUgcScrubber: allowUgcScrubber,
            allowWrapCodeBlock: allowWrapCodeBlock,
            disableTableOverflowShadow: true,
            emojiResourceConfig: emojiResourceConfig,
            eventHandlers: eventHandlers,
            media: media,
            smartLinks: smartLinks,
            stickyHeaders: stickyHeaders,
            contentMode: contentMode
        })))));
        $[4] = allowAltTextOnImages;
        $[5] = allowAnnotations;
        $[6] = allowColumnSorting;
        $[7] = allowCopyToClipboard;
        $[8] = allowCustomPanels;
        $[9] = allowHeadingAnchorLinks;
        $[10] = allowPlaceholderText;
        $[11] = allowRendererContainerStyles;
        $[12] = allowSelectAllTrap;
        $[13] = allowUgcScrubber;
        $[14] = allowWrapCodeBlock;
        $[15] = appearance;
        $[16] = contentMode;
        $[17] = dataProviders;
        $[18] = doc;
        $[19] = emojiResourceConfig;
        $[20] = eventHandlers;
        $[21] = media;
        $[22] = smartLinks;
        $[23] = stickyHeaders;
        $[24] = t4;
    } else t4 = $[24];
    return t4;
} : ({ doc: doc, dataProviders: dataProviders, options: options })=>{
    const mergedOptions = {
        ...$8039e8ec23b90f97$var$defaultOptions,
        ...options
    };
    const { appearance: appearance, allowAltTextOnImages: allowAltTextOnImages, allowAnnotations: allowAnnotations, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowCustomPanels: allowCustomPanels, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowRendererContainerStyles: allowRendererContainerStyles, allowSelectAllTrap: allowSelectAllTrap, allowUgcScrubber: allowUgcScrubber, allowWrapCodeBlock: allowWrapCodeBlock, emojiResourceConfig: emojiResourceConfig, eventHandlers: eventHandlers, media: media, smartLinks: smartLinks, stickyHeaders: stickyHeaders, contentMode: contentMode } = mergedOptions ?? {};
    const nodeComponents = (0, $cozmU.useMemo)(()=>{
        return {
            taskItem: (props)=>{
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8039e8ec23b90f97$var$DisabledTaskWithTooltip, {
                    componentKey: "taskItem",
                    ...props
                });
            },
            blockTaskItem: (props_0)=>{
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8039e8ec23b90f97$var$DisabledTaskWithTooltip, {
                    componentKey: "blockTaskItem",
                    ...props_0
                });
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8039e8ec23b90f97$var$ValidationContextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kS1Yv.RendererContextProvider), {
        value: {
            nestedRendererType: 'syncedBlock'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "sync-block-renderer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        appearance: appearance,
        adfStage: "stage0",
        document: doc,
        disableHeadingIDs: true,
        dataProviders: dataProviders,
        nodeComponents: nodeComponents,
        allowAltTextOnImages: allowAltTextOnImages,
        allowAnnotations: allowAnnotations,
        allowColumnSorting: allowColumnSorting,
        allowCopyToClipboard: allowCopyToClipboard,
        allowCustomPanels: allowCustomPanels,
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        allowPlaceholderText: allowPlaceholderText,
        allowRendererContainerStyles: allowRendererContainerStyles,
        allowSelectAllTrap: allowSelectAllTrap,
        allowUgcScrubber: allowUgcScrubber,
        allowWrapCodeBlock: allowWrapCodeBlock,
        disableTableOverflowShadow: true,
        emojiResourceConfig: emojiResourceConfig,
        eventHandlers: eventHandlers,
        media: media,
        smartLinks: smartLinks,
        stickyHeaders: stickyHeaders,
        contentMode: contentMode
    })))));
});
function $8039e8ec23b90f97$var$_temp(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8039e8ec23b90f97$var$DisabledTaskWithTooltip, {
        componentKey: "taskItem",
        ...props
    });
}
function $8039e8ec23b90f97$var$_temp2(props_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8039e8ec23b90f97$var$DisabledTaskWithTooltip, {
        componentKey: "blockTaskItem",
        ...props_0
    });
}












var $jv11C = parcelRequire("jv11C");


var $95bQO = parcelRequire("95bQO");


var $916Gd = parcelRequire("916Gd");

var $d04Ge = parcelRequire("d04Ge");










var $iDrrr = parcelRequire("iDrrr");

















var $eO7Q2 = parcelRequire("eO7Q2");


var $8y86q = parcelRequire("8y86q");


var $7vK9E = parcelRequire("7vK9E");











var $i1agE = parcelRequire("i1agE");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $72138bd1ab4464da$var$styles = {
    wrapper: "_zulppxbi _1rjc12x7 _bozgpxbi _1e0c1txw _1bahv2br _4cvr1h6o",
    container: "_1e0c1txw"
};
const $72138bd1ab4464da$export$dc0ab13618635cb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, description: description, icon: icon } = t0;
    const Icon = icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($i1agE)));
    let t1;
    if ($[0] !== Icon) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            color: "var(--ds-icon-subtle, #505258)",
            label: ""
        });
        $[0] = Icon;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== description) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtle"
        }, description);
        $[2] = description;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $72138bd1ab4464da$var$styles.wrapper
        }, t1, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== children || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $72138bd1ab4464da$var$styles.container
        }, t3, children);
        $[7] = children;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ children: children, description: description, icon: icon })=>{
    const Icon = icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($i1agE)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $72138bd1ab4464da$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $72138bd1ab4464da$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtle"
    }, description)), children);
};


const $202942cf525bcf92$var$styles = {
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $202942cf525bcf92$export$c15feb10af1ecdbf = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $aI2Eh.syncBlockMessages).entityNotFoundDescription, {
            link: $202942cf525bcf92$var$_temp
        });
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    const description = t0;
    let t1;
    if ($[2] !== description) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
            description: description,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
        });
        $[2] = description;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const description = formatMessage((0, $aI2Eh.syncBlockMessages).entityNotFoundDescription, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
                href: (0, $eO7Q2.SYNCED_BLOCKS_DOCUMENTATION_URL),
                target: "_blank",
                rel: "noopener noreferrer",
                xcss: $202942cf525bcf92$var$styles.link
            }, chunks)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
        description: description,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
    });
};
function $202942cf525bcf92$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
        href: (0, $eO7Q2.SYNCED_BLOCKS_DOCUMENTATION_URL),
        target: "_blank",
        rel: "noopener noreferrer",
        xcss: $202942cf525bcf92$var$styles.link
    }, chunks);
}


















const $1a0d19bd28fd7127$export$59b0b39f63011407 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $aI2Eh.syncBlockMessages).generalErrorDescription);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
            description: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
        description: formatMessage((0, $aI2Eh.syncBlockMessages).generalErrorDescription)
    });
};















var $ad7Ou = parcelRequire("ad7Ou");








const $57c81f4ea1b2a29a$var$styles = {
    buttonContainer: "_18u0u2gc _1e0c1txw _4cvr1h6o"
};
const $57c81f4ea1b2a29a$export$ca85b0be86ccfb26 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { onRetry: onRetry, isLoading: isLoading } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== onRetry) {
        t1 = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            onRetry?.();
        };
        $[0] = onRetry;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $aI2Eh.syncBlockMessages).retryButton);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== isLoading || $[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            spacing: "compact",
            onClick: t1,
            isLoading: isLoading,
            testId: "sync-block-retry-btn"
        }, t2);
        $[4] = isLoading;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const button = t3;
    let t4;
    if ($[8] !== formatMessage) {
        t4 = formatMessage((0, $aI2Eh.syncBlockMessages).generalErrorDescription);
        $[8] = formatMessage;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== button || $[11] !== onRetry) {
        t5 = onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $57c81f4ea1b2a29a$var$styles.buttonContainer
        }, button);
        $[10] = button;
        $[11] = onRetry;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
            description: t4
        }, t5);
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ onRetry: onRetry, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "compact",
        onClick: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            onRetry?.();
        },
        isLoading: isLoading,
        testId: "sync-block-retry-btn"
    }, formatMessage((0, $aI2Eh.syncBlockMessages).retryButton));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
        description: formatMessage((0, $aI2Eh.syncBlockMessages).generalErrorDescription)
    }, onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $57c81f4ea1b2a29a$var$styles.buttonContainer
    }, button));
};















var $1sCHt = parcelRequire("1sCHt");


var $2xhuI = parcelRequire("2xhuI");




var $i2lVL = parcelRequire("i2lVL");


var $l3wuH = parcelRequire("l3wuH");


var $bsSbN = parcelRequire("bsSbN");










var $lfoFx = parcelRequire("lfoFx");


const $aa923ad5452fda0c$var$styles = {
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1",
    spinner: "_1rjcutpp _1e0c1txw _1bah1h6o",
    closeButton: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bahesu3"
};
const $aa923ad5452fda0c$var$errorMap = {
    'source-block-unsynced': {
        description: (0, $aI2Eh.syncBlockMessages).sourceUnsyncedDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
    },
    'source-block-deleted': {
        description: (0, $aI2Eh.syncBlockMessages).sourceDeletedDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
    },
    'source-block-unpublished': {
        description: (0, $aI2Eh.syncBlockMessages).sourceDeletedDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
    },
    'source-document-deleted': {
        description: (0, $aI2Eh.syncBlockMessages).notFoundDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN)))
    },
    generic: {
        description: (0, $aI2Eh.syncBlockMessages).genericNotFoundDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q)))
    }
};
const $aa923ad5452fda0c$var$useErrorInfo = (0, $gtMdU.isReactCompilerActivePlatform)() ? (reason, url, title)=>{
    const $ = (0, $bDgLe.c)(18);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (reason === "source-document-deleted") {
        const { icon: icon, description: description } = $aa923ad5452fda0c$var$errorMap["source-document-deleted"];
        let t0;
        if ($[0] !== formatMessage) {
            t0 = formatMessage(description);
            $[0] = formatMessage;
            $[1] = t0;
        } else t0 = $[1];
        let t1;
        if ($[2] !== t0) {
            t1 = {
                description: t0,
                icon: icon
            };
            $[2] = t0;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    if (!url || !title) {
        const { icon: icon_0, description: description_0 } = $aa923ad5452fda0c$var$errorMap.generic;
        let t0;
        if ($[4] !== formatMessage) {
            t0 = formatMessage(description_0);
            $[4] = formatMessage;
            $[5] = t0;
        } else t0 = $[5];
        let t1;
        if ($[6] !== t0) {
            t1 = {
                description: t0,
                icon: icon_0
            };
            $[6] = t0;
            $[7] = t1;
        } else t1 = $[7];
        return t1;
    }
    const { icon: icon_1, description: description_1 } = $aa923ad5452fda0c$var$errorMap[reason || "generic"] ?? $aa923ad5452fda0c$var$errorMap.generic;
    let t0;
    if ($[8] !== url) {
        t0 = (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
                href: url,
                target: "_blank",
                rel: "noopener noreferrer",
                xcss: $aa923ad5452fda0c$var$styles.link
            }, chunk);
        $[8] = url;
        $[9] = t0;
    } else t0 = $[9];
    let t1;
    if ($[10] !== description_1 || $[11] !== formatMessage || $[12] !== t0 || $[13] !== title) {
        t1 = formatMessage(description_1, {
            title: title,
            a: t0
        });
        $[10] = description_1;
        $[11] = formatMessage;
        $[12] = t0;
        $[13] = title;
        $[14] = t1;
    } else t1 = $[14];
    let t2;
    if ($[15] !== icon_1 || $[16] !== t1) {
        t2 = {
            description: t1,
            icon: icon_1
        };
        $[15] = icon_1;
        $[16] = t1;
        $[17] = t2;
    } else t2 = $[17];
    return t2;
} : (reason, url, title)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (reason === 'source-document-deleted') {
        const { icon: icon, description: description } = $aa923ad5452fda0c$var$errorMap['source-document-deleted'];
        return {
            description: formatMessage(description),
            icon: icon
        };
    }
    if (!url || !title) {
        const { icon: icon_0, description: description_0 } = $aa923ad5452fda0c$var$errorMap['generic'];
        return {
            description: formatMessage(description_0),
            icon: icon_0
        };
    }
    const { icon: icon_1, description: description_1 } = $aa923ad5452fda0c$var$errorMap[reason || 'generic'] ?? $aa923ad5452fda0c$var$errorMap['generic'];
    return {
        description: formatMessage(description_1, {
            title: title,
            a: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
                    href: url,
                    target: "_blank",
                    rel: 'noopener noreferrer',
                    xcss: $aa923ad5452fda0c$var$styles.link
                }, chunk)
        }),
        icon: icon_1
    };
};
const $aa923ad5452fda0c$export$3f73b17e61025be6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { reason: t1, sourceAri: sourceAri } = t0;
    const reason = t1 === undefined ? "source-block-deleted" : t1;
    const { deleteSyncBlock: deleteSyncBlock, fetchSourceInfo: fetchSourceInfo } = (0, $i2lVL.useSyncBlockActions)() ?? {};
    const [sourceInfo, setSourceInfo] = (0, $cozmU.useState)(undefined);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    let t3;
    if ($[0] !== fetchSourceInfo || $[1] !== reason || $[2] !== sourceAri) {
        t2 = ()=>{
            if (!sourceAri || ![
                "source-block-deleted",
                "source-block-unsynced",
                "source-block-unpublished"
            ].includes(reason)) {
                setSourceInfo({});
                return;
            }
            const getSourceInfo = async ()=>{
                const sourceInfo_0 = await fetchSourceInfo?.(sourceAri, true);
                setSourceInfo({
                    url: sourceInfo_0?.url,
                    title: sourceInfo_0?.title
                });
            };
            getSourceInfo();
        };
        t3 = [
            reason,
            sourceAri,
            fetchSourceInfo
        ];
        $[0] = fetchSourceInfo;
        $[1] = reason;
        $[2] = sourceAri;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const { description: description, icon: icon } = $aa923ad5452fda0c$var$useErrorInfo(reason, sourceInfo?.url, sourceInfo?.title);
    let t4;
    if ($[5] !== deleteSyncBlock || $[6] !== description || $[7] !== formatMessage || $[8] !== icon || $[9] !== sourceInfo) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, sourceInfo === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $aa923ad5452fda0c$var$styles.spinner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
            description: description,
            icon: icon
        }, deleteSyncBlock && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $aa923ad5452fda0c$var$styles.closeButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: formatMessage((0, $2xhuI.default).delete),
            onClick: deleteSyncBlock
        }))));
        $[5] = deleteSyncBlock;
        $[6] = description;
        $[7] = formatMessage;
        $[8] = icon;
        $[9] = sourceInfo;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ reason: reason = 'source-block-deleted', sourceAri: sourceAri })=>{
    const { deleteSyncBlock: deleteSyncBlock, fetchSourceInfo: fetchSourceInfo } = (0, $i2lVL.useSyncBlockActions)() ?? {};
    const [sourceInfo, setSourceInfo] = (0, $cozmU.useState)(undefined);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        if (!sourceAri || // Only fetch source info for these 3 cases
        ![
            'source-block-deleted',
            'source-block-unsynced',
            'source-block-unpublished'
        ].includes(reason)) {
            setSourceInfo({});
            return;
        }
        const getSourceInfo = async ()=>{
            const sourceInfo_0 = await fetchSourceInfo?.(sourceAri, true);
            setSourceInfo({
                url: sourceInfo_0?.url,
                title: sourceInfo_0?.title
            });
        };
        getSourceInfo();
    }, [
        reason,
        sourceAri,
        fetchSourceInfo
    ]);
    const { description: description, icon: icon } = $aa923ad5452fda0c$var$useErrorInfo(reason, sourceInfo?.url, sourceInfo?.title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, sourceInfo === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $aa923ad5452fda0c$var$styles.spinner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
        description: description,
        icon: icon
    }, deleteSyncBlock && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $aa923ad5452fda0c$var$styles.closeButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $2xhuI.default).delete),
        onClick: deleteSyncBlock
    }))));
};


















const $5d62db625936e51f$export$8a461f6033aecd80 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $aI2Eh.syncBlockMessages).offlineError);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
            description: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
        description: formatMessage((0, $aI2Eh.syncBlockMessages).offlineError)
    });
};








/**
 * @generated SignedSource<<0c6c51fca90b1d8be221569188b41155>>
 * @relayHash 676631e44ffd7d0d16b3a7e96ba02def
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68a651ca7e5a5c9b5a075954ed948672c451b0f8c255f4edbd3219fe4947484d
const $eb40956e546afb46$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "requestPageAccessInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "requestPageAccessInput",
                    "variableName": "requestPageAccessInput"
                }
            ],
            "concreteType": "RequestPageAccessPayload",
            "kind": "LinkedField",
            "name": "requestPageAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "68a651ca7e5a5c9b5a075954ed948672c451b0f8c255f4edbd3219fe4947484d",
            "metadata": {},
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$eb40956e546afb46$var$node.hash = "d0d4982ad805583380d2436a8e21ee6a";
var $eb40956e546afb46$export$2e2bcd8739ae039 = $eb40956e546afb46$var$node;









var $6SsN4 = parcelRequire("6SsN4");







/**
 * Sends a "request access" notification for a Jira work item the current viewer
 * cannot see. A copy of jira/src/packages/platform/space-not-found-with-request-access/src/requestSpaceAccess.tsx
 */ const $13f179472afcb5ea$var$REQUEST_ACCESS_URL = '/rest/internal/latest/project-access/access-requested';
const $13f179472afcb5ea$export$47e85d58c126fc4d = (payload)=>{
    // we return nothing on purpose to be vague, not disclose if the project exists or not,
    // so we use fetch instead of performPutRequest as performPutRequest will return null for empty response
    return fetch($13f179472afcb5ea$var$REQUEST_ACCESS_URL, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
};



var $I7hWB = parcelRequire("I7hWB");


var $chu6R = parcelRequire("chu6R");


var $cJ0FD = parcelRequire("cJ0FD");




var $4ez2K = parcelRequire("4ez2K");

var $dinVW = parcelRequire("dinVW");



var $5c2c84add641dd06$exports = {};
$5c2c84add641dd06$exports = new URL("PermissionDenied.bfcb6211.svg", import.meta.url).toString();



const $b7d8f9d435e66778$var$styles = {
    wrapper: "_zulppxbi _ca0qv47k _n3tdv47k _19bvv47k _u5f3v47k _1e0c1txw _1bahv2br _4cvr1h6o"
};
var $b7d8f9d435e66778$var$RequestAccessState = /*#__PURE__*/ function(RequestAccessState) {
    RequestAccessState["default"] = "default";
    RequestAccessState["errored"] = "errored";
    RequestAccessState["loading"] = "loading";
    RequestAccessState["pending"] = "pending";
    return RequestAccessState;
}($b7d8f9d435e66778$var$RequestAccessState || {});
const $b7d8f9d435e66778$var$SyncedBlockPermissionDeniedConfluencePage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { sourceContentId: sourceContentId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [requestAccessState, setRequestAccessState] = (0, $cozmU.useState)("default");
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRequestAccessState("pending");
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleRequestComplete = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setRequestAccessState("errored");
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleRequestError = t2;
    const [commitMutation] = (0, $6SsN4.useMutation)((0, $eb40956e546afb46$export$2e2bcd8739ae039));
    let t3;
    if ($[2] !== commitMutation || $[3] !== sourceContentId) {
        t3 = ()=>{
            setRequestAccessState("loading");
            commitMutation({
                variables: {
                    requestPageAccessInput: {
                        pageId: sourceContentId,
                        accessType: "VIEW"
                    }
                },
                onCompleted: ()=>{
                    handleRequestComplete();
                },
                onError: handleRequestError
            });
        };
        $[2] = commitMutation;
        $[3] = sourceContentId;
        $[4] = t3;
    } else t3 = $[4];
    const onClick = t3;
    let t4;
    if ($[5] !== formatMessage) {
        t4 = formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedAltText);
        $[5] = formatMessage;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5c2c84add641dd06$exports))),
            alt: t4,
            width: "48",
            height: "48"
        });
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== formatMessage) {
        t6 = formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedHeading);
        $[9] = formatMessage;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, t6);
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== formatMessage) {
        t8 = formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedDescription);
        $[13] = formatMessage;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtle"
        }, t8);
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== formatMessage || $[18] !== onClick || $[19] !== requestAccessState) {
        t10 = requestAccessState === "pending" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
            columnGap: "space.050",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            size: "small",
            color: "var(--ds-icon-subtle, #505258)",
            label: formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtlest",
            weight: "bold",
            testId: "sync-block-access-requested-msg"
        }, formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
            columnGap: "space.100",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            spacing: "compact",
            onClick: onClick,
            isLoading: requestAccessState === "loading",
            testId: "sync-block-request-access-btn"
        }, formatMessage((0, $aI2Eh.syncBlockMessages).requestAccessButton)), requestAccessState === "errored" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.warning",
            testId: "sync-block-access-error-msg"
        }, formatMessage((0, $aI2Eh.syncBlockMessages).requestAccessError)));
        $[17] = formatMessage;
        $[18] = onClick;
        $[19] = requestAccessState;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10 || $[22] !== t7 || $[23] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.100"
        }, t7, t9, t10);
        $[21] = t10;
        $[22] = t7;
        $[23] = t9;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t11 || $[26] !== t5) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $b7d8f9d435e66778$var$styles.wrapper
        }, t5, t11);
        $[25] = t11;
        $[26] = t5;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
} : ({ sourceContentId: sourceContentId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [requestAccessState, setRequestAccessState] = (0, $cozmU.useState)("default");
    const handleRequestComplete = ()=>{
        setRequestAccessState("pending");
    };
    const handleRequestError = ()=>{
        setRequestAccessState("errored");
    };
    const [commitMutation] = (0, $6SsN4.useMutation)((0, $eb40956e546afb46$export$2e2bcd8739ae039));
    const onClick = ()=>{
        setRequestAccessState("loading");
        commitMutation({
            variables: {
                requestPageAccessInput: {
                    pageId: sourceContentId,
                    accessType: 'VIEW'
                }
            },
            onCompleted: ()=>{
                handleRequestComplete();
            },
            onError: handleRequestError
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $b7d8f9d435e66778$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5c2c84add641dd06$exports))),
        alt: formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedAltText),
        width: "48",
        height: "48"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtle"
    }, formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedDescription)), requestAccessState === "pending" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        columnGap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        size: "small",
        color: "var(--ds-icon-subtle, #505258)",
        label: formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtlest",
        weight: "bold",
        testId: "sync-block-access-requested-msg"
    }, formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        columnGap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "compact",
        onClick: onClick,
        isLoading: requestAccessState === "loading",
        testId: "sync-block-request-access-btn"
    }, formatMessage((0, $aI2Eh.syncBlockMessages).requestAccessButton)), requestAccessState === "errored" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.warning",
        testId: "sync-block-access-error-msg"
    }, formatMessage((0, $aI2Eh.syncBlockMessages).requestAccessError)))));
};
const $b7d8f9d435e66778$var$SyncedBlockPermissionDeniedJiraWorkItem = ({ sourceContentId: sourceContentId, accountId: accountId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [requestAccessState, setRequestAccessState] = (0, $cozmU.useState)("default");
    const onClick = (0, $cozmU.useCallback)(async ()=>{
        setRequestAccessState("loading"); // Fire and forget. Per the Jira backend contract the response is
        // intentionally opaque (empty 204 on success, generic on failure) to
        // prevent issue-existence enumeration. We always end in `pending`.
        try {
            await (0, $13f179472afcb5ea$export$47e85d58c126fc4d)({
                accountId: accountId,
                issueId: Number(sourceContentId) || null,
                projectKey: null
            });
        } catch (_e) {}
        setRequestAccessState("pending");
    }, [
        accountId,
        sourceContentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $b7d8f9d435e66778$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5c2c84add641dd06$exports))),
        alt: formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedAltText),
        width: "48",
        height: "48"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtle"
    }, formatMessage((0, $aI2Eh.syncBlockMessages).permissionDeniedDescription)), requestAccessState === "pending" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        columnGap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        size: "small",
        color: "var(--ds-icon-subtle, #505258)",
        label: formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtlest",
        weight: "bold",
        testId: "sync-block-access-requested-msg"
    }, formatMessage((0, $aI2Eh.syncBlockMessages).accessRequested))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        columnGap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "compact",
        onClick: onClick,
        isLoading: requestAccessState === "loading",
        testId: "sync-block-request-access-btn"
    }, formatMessage((0, $aI2Eh.syncBlockMessages).requestAccessButton)))));
};
const $b7d8f9d435e66778$export$33325aff698460b9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { sourceContentId: sourceContentId, sourceProduct: sourceProduct, accountId: accountId } = t0;
    switch(sourceProduct){
        case "confluence-page":
            {
                let t1;
                if ($[0] !== sourceContentId) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7d8f9d435e66778$var$SyncedBlockPermissionDeniedConfluencePage, {
                        sourceContentId: sourceContentId
                    });
                    $[0] = sourceContentId;
                    $[1] = t1;
                } else t1 = $[1];
                return t1;
            }
        case "jira-work-item":
            {
                let t1;
                if ($[2] !== accountId || $[3] !== sourceContentId) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7d8f9d435e66778$var$SyncedBlockPermissionDeniedJiraWorkItem, {
                        sourceContentId: sourceContentId,
                        accountId: accountId
                    });
                    $[2] = accountId;
                    $[3] = sourceContentId;
                    $[4] = t1;
                } else t1 = $[4];
                return t1;
            }
        default:
            {
                let t1;
                if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a0d19bd28fd7127$export$59b0b39f63011407), null);
                    $[5] = t1;
                } else t1 = $[5];
                return t1;
            }
    }
} : ({ sourceContentId: sourceContentId, sourceProduct: sourceProduct, accountId: accountId })=>{
    switch(sourceProduct){
        case 'confluence-page':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7d8f9d435e66778$var$SyncedBlockPermissionDeniedConfluencePage, {
                sourceContentId: sourceContentId
            });
        case 'jira-work-item':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7d8f9d435e66778$var$SyncedBlockPermissionDeniedJiraWorkItem, {
                sourceContentId: sourceContentId,
                accountId: accountId
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a0d19bd28fd7127$export$59b0b39f63011407), null);
    }
};
























const $a4467333f2a8d6b8$var$styles = {
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $a4467333f2a8d6b8$export$a78c0479e6ca5528 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { sourceURL: sourceURL, sourceProduct: sourceProduct } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = sourceProduct === "jira-work-item" ? (0, $aI2Eh.syncBlockMessages).unpublishedErrorJiraWorkItem : (0, $aI2Eh.syncBlockMessages).unpublishedError;
    let t1;
    if ($[0] !== sourceURL) {
        t1 = (chunks)=>sourceURL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
                href: sourceURL,
                target: "_blank",
                rel: "noopener noreferrer",
                xcss: $a4467333f2a8d6b8$var$styles.link
            }, chunks) : chunks;
        $[0] = sourceURL;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage || $[3] !== message || $[4] !== t1) {
        t2 = formatMessage(message, {
            link: t1
        });
        $[2] = formatMessage;
        $[3] = message;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const description = t2;
    let t3;
    if ($[6] !== description) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
            description: description,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN)))
        });
        $[6] = description;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ sourceURL: sourceURL, sourceProduct: sourceProduct })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // Pick the product-specific copy. Jira work items are described as "the item's
    // description is saved" rather than "the page is published" because Jira issues
    // don't have a page-level publish action — the description field is what's
    // being authored.
    const message = sourceProduct === 'jira-work-item' ? (0, $aI2Eh.syncBlockMessages).unpublishedErrorJiraWorkItem : (0, $aI2Eh.syncBlockMessages).unpublishedError;
    const description = formatMessage(message, {
        link: (chunks)=>sourceURL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
                href: sourceURL,
                target: "_blank",
                rel: 'noopener noreferrer',
                xcss: $a4467333f2a8d6b8$var$styles.link
            }, chunks) : chunks
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72138bd1ab4464da$export$dc0ab13618635cb1), {
        description: description,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN)))
    });
};


const $2a4f71ad51426bfa$var$getForbiddenErrorContent = (resourceId, fireAnalyticsEvent, getAccountId)=>{
    try {
        if (!resourceId) throw new Error('Missing resource id');
        const { sourceContentId: sourceContentId, sourceProduct: sourceProduct } = (0, $d04Ge.getContentIdAndProductFromResourceId)(resourceId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7d8f9d435e66778$export$33325aff698460b9), {
            sourceContentId: sourceContentId,
            sourceProduct: sourceProduct,
            accountId: getAccountId?.() ?? null
        });
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-renderer/SyncedBlockErrorComponent'
        });
        fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(error.message));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a0d19bd28fd7127$export$59b0b39f63011407), null);
    }
};
const $2a4f71ad51426bfa$export$f4d17ad2341a04f8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { error: error, isLoading: isLoading, onRetry: onRetry, resourceId: resourceId, fireAnalyticsEvent: fireAnalyticsEvent, sourceURL: sourceURL, getAccountId: getAccountId } = t0;
    let t1;
    if ($[0] !== error?.originalMessage || $[1] !== error?.reason || $[2] !== error?.statusCode || $[3] !== error?.type || $[4] !== fireAnalyticsEvent || $[5] !== resourceId) {
        t1 = ()=>{
            const gateEnabled = (0, $iDrrr.fg)("platform_editor_blocks_patch_4");
            const rawError = error?.originalMessage || error?.reason || error?.type || "unknown";
            fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(`${rawError}: error component rendered`, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)(gateEnabled, rawError, error?.statusCode)));
        };
        $[0] = error?.originalMessage;
        $[1] = error?.reason;
        $[2] = error?.statusCode;
        $[3] = error?.type;
        $[4] = fireAnalyticsEvent;
        $[5] = resourceId;
        $[6] = t1;
    } else t1 = $[6];
    const t2 = error?.originalMessage;
    const t3 = error?.reason;
    const t4 = error?.type;
    const t5 = error?.statusCode;
    let t6;
    if ($[7] !== fireAnalyticsEvent || $[8] !== resourceId || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
        t6 = [
            t2,
            t3,
            t4,
            t5,
            resourceId,
            fireAnalyticsEvent
        ];
        $[7] = fireAnalyticsEvent;
        $[8] = resourceId;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    (0, $cozmU.useEffect)(t1, t6);
    let t7;
    bb0: switch(error?.type){
        case (0, $79ir6.SyncBlockError).EntityNotFound:
            {
                let t8;
                if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
                    t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $202942cf525bcf92$export$c15feb10af1ecdbf), null);
                    $[14] = t8;
                } else t8 = $[14];
                t7 = t8;
                break bb0;
            }
        case (0, $79ir6.SyncBlockError).Offline:
            {
                let t8;
                if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
                    t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d62db625936e51f$export$8a461f6033aecd80), null);
                    $[15] = t8;
                } else t8 = $[15];
                t7 = t8;
                break bb0;
            }
        case (0, $79ir6.SyncBlockError).Forbidden:
            {
                let t8;
                if ($[16] !== fireAnalyticsEvent || $[17] !== getAccountId || $[18] !== resourceId) {
                    t8 = $2a4f71ad51426bfa$var$getForbiddenErrorContent(resourceId, fireAnalyticsEvent, getAccountId);
                    $[16] = fireAnalyticsEvent;
                    $[17] = getAccountId;
                    $[18] = resourceId;
                    $[19] = t8;
                } else t8 = $[19];
                t7 = t8;
                break bb0;
            }
        case (0, $79ir6.SyncBlockError).NotFound:
            {
                let t8;
                if ($[20] !== error.reason || $[21] !== error.sourceAri) {
                    t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aa923ad5452fda0c$export$3f73b17e61025be6), {
                        reason: error.reason,
                        sourceAri: error.sourceAri
                    });
                    $[20] = error.reason;
                    $[21] = error.sourceAri;
                    $[22] = t8;
                } else t8 = $[22];
                t7 = t8;
                break bb0;
            }
        case (0, $79ir6.SyncBlockError).Unpublished:
            {
                let t8;
                if ($[23] !== resourceId) {
                    t8 = (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId);
                    $[23] = resourceId;
                    $[24] = t8;
                } else t8 = $[24];
                let t9;
                if ($[25] !== sourceURL || $[26] !== t8) {
                    t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4467333f2a8d6b8$export$a78c0479e6ca5528), {
                        sourceURL: sourceURL,
                        sourceProduct: t8
                    });
                    $[25] = sourceURL;
                    $[26] = t8;
                    $[27] = t9;
                } else t9 = $[27];
                t7 = t9;
                break bb0;
            }
        case (0, $79ir6.SyncBlockError).Errored:
        case (0, $79ir6.SyncBlockError).RateLimited:
        case (0, $79ir6.SyncBlockError).ServerError:
            {
                let t8;
                if ($[28] !== isLoading || $[29] !== onRetry) {
                    t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57c81f4ea1b2a29a$export$ca85b0be86ccfb26), {
                        onRetry: onRetry,
                        isLoading: isLoading
                    });
                    $[28] = isLoading;
                    $[29] = onRetry;
                    $[30] = t8;
                } else t8 = $[30];
                t7 = t8;
                break bb0;
            }
        default:
            {
                let t8;
                if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
                    t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a0d19bd28fd7127$export$59b0b39f63011407), null);
                    $[31] = t8;
                } else t8 = $[31];
                t7 = t8;
            }
    }
    const getErrorContent = t7;
    let t8;
    if ($[32] !== getErrorContent) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "sync-block-error",
            className: (0, $95bQO.SyncBlockSharedCssClassName).error
        }, getErrorContent);
        $[32] = getErrorContent;
        $[33] = t8;
    } else t8 = $[33];
    return t8;
} : ({ error: error, isLoading: isLoading, onRetry: onRetry, resourceId: resourceId, fireAnalyticsEvent: fireAnalyticsEvent, sourceURL: sourceURL, getAccountId: getAccountId })=>{
    (0, $cozmU.useEffect)(()=>{
        // Emit structured attribution via the shared builder instead of an opaque
        // `errored`-only blob. Prefer the PII-safe `originalMessage` so the classifier
        // can bucket the real cause; fall back to `reason` then the bare `type`.
        // Gate-off is a no-op (builder returns undefined → no new attributes).
        const gateEnabled = (0, $iDrrr.fg)('platform_editor_blocks_patch_4');
        const rawError = error?.originalMessage || error?.reason || error?.type || 'unknown';
        fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(`${rawError}: error component rendered`, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)(gateEnabled, rawError, error?.statusCode)));
    }, [
        error?.originalMessage,
        error?.reason,
        error?.type,
        error?.statusCode,
        resourceId,
        fireAnalyticsEvent
    ]);
    const getErrorContent = (0, $cozmU.useMemo)(()=>{
        switch(error?.type){
            case (0, $79ir6.SyncBlockError).EntityNotFound:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $202942cf525bcf92$export$c15feb10af1ecdbf), null);
            case (0, $79ir6.SyncBlockError).Offline:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d62db625936e51f$export$8a461f6033aecd80), null);
            case (0, $79ir6.SyncBlockError).Forbidden:
                return $2a4f71ad51426bfa$var$getForbiddenErrorContent(resourceId, fireAnalyticsEvent, getAccountId);
            case (0, $79ir6.SyncBlockError).NotFound:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aa923ad5452fda0c$export$3f73b17e61025be6), {
                    reason: error.reason,
                    sourceAri: error.sourceAri
                });
            case (0, $79ir6.SyncBlockError).Unpublished:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4467333f2a8d6b8$export$a78c0479e6ca5528), {
                    sourceURL: sourceURL,
                    sourceProduct: (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)
                });
            case (0, $79ir6.SyncBlockError).Errored:
            case (0, $79ir6.SyncBlockError).RateLimited:
            case (0, $79ir6.SyncBlockError).ServerError:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57c81f4ea1b2a29a$export$ca85b0be86ccfb26), {
                    onRetry: onRetry,
                    isLoading: isLoading
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a0d19bd28fd7127$export$59b0b39f63011407), null);
        }
    }, [
        error,
        isLoading,
        onRetry,
        resourceId,
        fireAnalyticsEvent,
        sourceURL,
        getAccountId
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "sync-block-error",
        className: (0, $95bQO.SyncBlockSharedCssClassName).error
    }, getErrorContent));
};


























const $200d4e51d938dcb9$var$styles = {
    wrapper: "_1tkevbgk _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $200d4e51d938dcb9$export$6d2e5b4986b73a9a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $aI2Eh.syncBlockMessages).loadingSyncedContent);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $95bQO.SyncBlockSharedCssClassName).loading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $200d4e51d938dcb9$var$styles.wrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small",
            label: t0
        })));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $95bQO.SyncBlockSharedCssClassName).loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $200d4e51d938dcb9$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        label: formatMessage((0, $aI2Eh.syncBlockMessages).loadingSyncedContent)
    }))));
};


function $753b4334064f552c$export$6942d731e9271481({ syncBlockInstance: syncBlockInstance, isLoading: isLoading, rendererOptions: rendererOptions, providerFactory: providerFactory, reloadData: reloadData, fireAnalyticsEvent: fireAnalyticsEvent, resourceId: resourceId, isOffline: isOffline, error: error, getAccountId: getAccountId }) {
    const isSSRMode = (0, $4iudd.isSSR)();
    if (isOffline && !isSSRMode) return {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2a4f71ad51426bfa$export$f4d17ad2341a04f8), {
            error: {
                type: (0, $79ir6.SyncBlockError).Offline
            }
        }),
        isSuccess: false
    };
    if (isLoading && !syncBlockInstance) return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $200d4e51d938dcb9$export$6d2e5b4986b73a9a), null),
        isSuccess: false
    };
    if (isSSRMode && syncBlockInstance?.error) return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $200d4e51d938dcb9$export$6d2e5b4986b73a9a), null),
        isSuccess: false
    };
    if (!resourceId || syncBlockInstance?.error || !syncBlockInstance?.data || syncBlockInstance.data.status === 'deleted') {
        const errorToDisplay = error ?? syncBlockInstance?.error ?? (syncBlockInstance?.data?.status === 'deleted' ? {
            type: (0, $79ir6.SyncBlockError).NotFound
        } : {
            type: (0, $79ir6.SyncBlockError).Errored
        });
        return {
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2a4f71ad51426bfa$export$f4d17ad2341a04f8), {
                error: errorToDisplay,
                resourceId: resourceId,
                onRetry: reloadData,
                isLoading: isLoading,
                fireAnalyticsEvent: fireAnalyticsEvent,
                getAccountId: getAccountId
            }),
            isSuccess: false
        };
    }
    if (syncBlockInstance?.data?.status === 'unpublished') return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2a4f71ad51426bfa$export$f4d17ad2341a04f8), {
            /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ error: {
                type: (0, $79ir6.SyncBlockError).Unpublished
            },
            resourceId: resourceId,
            sourceURL: syncBlockInstance.data?.sourceURL,
            fireAnalyticsEvent: fireAnalyticsEvent,
            getAccountId: getAccountId
        }),
        isSuccess: false
    };
    const syncBlockDoc = {
        content: syncBlockInstance.data.content,
        version: 1,
        type: 'doc'
    };
    return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8039e8ec23b90f97$export$cc2ec5e10e7ca244), {
            doc: syncBlockDoc,
            dataProviders: providerFactory,
            options: rendererOptions
        }),
        isSuccess: true
    };
}
module.exports["renderSyncedBlockContent"] = $753b4334064f552c$export$6942d731e9271481;

});

parcelRegister("gsPOZ", function(module, exports) {
/**
 * @generated SignedSource<<eba967ef43ce0005d9aebfc0d15e70bc>>
 * @relayHash 3e442d5d3227540b5f9648827533c2f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd1ae3e91e6cce9d7c559a091c26b1b5d144b0cbd98427fa9498628b398d03cd
const $11aa77d8f290fc7b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "resourceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "concreteType": "BlockServiceBlockPayload",
            "kind": "LinkedField",
            "name": "blockService_onBlockUpdated",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "blockAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "blockInstanceId"
                },
                {
                    "kind": "ScalarField",
                    "name": "content"
                },
                {
                    "kind": "ScalarField",
                    "name": "contentUpdatedAt"
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAt"
                },
                {
                    "kind": "ScalarField",
                    "name": "createdBy"
                },
                {
                    "kind": "ScalarField",
                    "name": "deletionReason"
                },
                {
                    "kind": "ScalarField",
                    "name": "product"
                },
                {
                    "kind": "ScalarField",
                    "name": "sourceAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "relaySyncBlockFetchProviderSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "relaySyncBlockFetchProviderSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3e442d5d3227540b5f9648827533c2f8",
            "id": "cd1ae3e91e6cce9d7c559a091c26b1b5d144b0cbd98427fa9498628b398d03cd",
            "metadata": {},
            "name": "relaySyncBlockFetchProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription relaySyncBlockFetchProviderSubscription($resourceId:ID!){blockService_onBlockUpdated(resourceId:$resourceId){blockAri,blockInstanceId,content,contentUpdatedAt,createdAt,createdBy,deletionReason,product,sourceAri,status}}"
        }
    };
}();
$11aa77d8f290fc7b$var$node.hash = "f3661ea7b2ab697a90b3ec5ef8d55382";
var $11aa77d8f290fc7b$export$2e2bcd8739ae039 = $11aa77d8f290fc7b$var$node;



var $eqEJl = parcelRequire("eqEJl");


var $3xsB6 = parcelRequire("3xsB6");


var $9HB34 = parcelRequire("9HB34");

/**
 * Converts a Relay subscription response to SyncBlockInstance format.
 */ function $8642b45e2aee2bb6$var$convertRelayResponseToSyncBlockInstance(response, resourceId) {
    let createdAt;
    if (response.createdAt !== undefined && response.createdAt !== null) try {
        createdAt = new Date(response.createdAt).toISOString();
    } catch  {
        createdAt = undefined;
    }
    let contentUpdatedAt;
    if (response.contentUpdatedAt !== undefined && response.contentUpdatedAt !== null) try {
        contentUpdatedAt = new Date(response.contentUpdatedAt).toISOString();
    } catch  {
        contentUpdatedAt = undefined;
    }
    return {
        data: {
            content: JSON.parse(response.content),
            contentUpdatedAt: contentUpdatedAt,
            resourceId: response.blockAri,
            blockInstanceId: response.blockInstanceId,
            sourceAri: response.sourceAri,
            product: response.product,
            createdAt: createdAt,
            createdBy: response.createdBy,
            status: response.status
        },
        resourceId: resourceId
    };
}
function $8642b45e2aee2bb6$export$7a629188ade23de0(baseProvider, cloudId) {
    const subscription = (0, $11aa77d8f290fc7b$export$2e2bcd8739ae039);
    // Create a new provider that preserves all methods from baseProvider
    // Preserve the prototype chain to ensure all methods are accessible
    const wrappedProvider = Object.create(Object.getPrototypeOf(baseProvider));
    Object.assign(wrappedProvider, baseProvider);
    // Override subscribeToBlockUpdates with Relay subscription support
    wrappedProvider.subscribeToBlockUpdates = function(resourceId, onUpdate, onError, onComplete) {
        // Get the Relay environment — returns null when SSR or tests haven't initialised it.
        const environment = (0, $9HB34.getRelayEnvironment)();
        if (!environment) {
            onError?.(new Error('Relay environment not available'));
            return ()=>{};
        }
        // Convert resourceId to blockAri for the subscription
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: cloudId,
            resourceId: resourceId
        });
        let disposable = null;
        try {
            disposable = (0, $eqEJl.requestSubscription)(environment, {
                subscription: subscription,
                variables: {
                    resourceId: blockAri
                },
                onNext: (response)=>{
                    if (response?.blockService_onBlockUpdated) {
                        const syncBlockInstance = $8642b45e2aee2bb6$var$convertRelayResponseToSyncBlockInstance(response.blockService_onBlockUpdated, resourceId);
                        onUpdate(syncBlockInstance);
                    }
                },
                onError: (error)=>{
                    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                    onError?.(error);
                },
                onCompleted: ()=>{
                    onComplete?.();
                }
            });
        } catch (error) {
            onError?.(error instanceof Error ? error : new Error(String(error)));
            // Return a no-op unsubscribe if subscription fails
            return ()=>{};
        }
        return ()=>{
            if (disposable) disposable.dispose();
        };
    };
    return wrappedProvider;
}
module.exports["createRelaySyncBlockFetchProvider"] = $8642b45e2aee2bb6$export$7a629188ade23de0;

});

parcelRegister("epn2u", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $950ecc7cad6e8d10$export$e09386e914855e84 = ()=>{
    // Fire a client-side exposure for the SSR preload experiment. The experiment is only
    // evaluated in SSR preload code where the Statsig JS SDK is not initialized, so exposures
    // never reach Statsig from SSR alone. Calling manuallyLogExpExposure here — at the exact
    // point where the SSR-preloaded sync block data is consumed on the client — ensures every
    // page load records an exposure, allowing us to measure the experiment's effect accurately.
    // Once the optimal value is found, this will be converted to a permanent Statsig config.
    (0, $6mKj3.manuallyLogExpExposure)('platform_editor_sync_block_ssr_config');
    const rawSyncBlockData = typeof globalThis !== 'undefined' ? globalThis.__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__?.syncBlocks : undefined;
    if (rawSyncBlockData) return rawSyncBlockData.reduce((acc, item)=>{
        acc[item.resourceId] = item;
        return acc;
    }, {});
    return undefined;
};
module.exports["syncedBlockLoadSSRData"] = $950ecc7cad6e8d10$export$e09386e914855e84;

});

parcelRegister("BjpgS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $eDtFr = parcelRequire("eDtFr");


var $fJCU9 = parcelRequire("fJCU9");


var $9FoVw = parcelRequire("9FoVw");


var $8i27m = parcelRequire("8i27m");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");

const $fcc85c86573dc170$var$i18n = (0, $kSwu1.defineMessages)({
    viewCommentsLabel: {
        id: "editor-features.media-viewer.view-comments.label",
        defaultMessage: "View comments"
    },
    commentUnavailableTitle: {
        id: "editor-features.media-viewer.comment-unavailable.title",
        defaultMessage: "This comment isn't available"
    },
    commentUnavailableDescription: {
        id: "editor-features.media-viewer.comment-unavailable.description",
        defaultMessage: "It may have been resolved or deleted."
    }
});
const $fcc85c86573dc170$var$MEDIA_VIEWER_POPUP_SELECTOR = '[data-testid="media-viewer-popup"]';
// This function exists because navigating in between previewed elements only uses the file id.
// We need a way to map that back to the annotation ID used by comments, however keeping track of
// this at a global level is likely too heavy relative to usage. Better to just compute on the fly.
function $fcc85c86573dc170$var$findAnnotationForMediaFile(annotationIds, fileId, isViewPage) {
    const activeSet = new Set(annotationIds);
    // Locate the media element directly by file ID.
    // - Renderer nodes use: <div data-node-type="media" data-id="<fileId>">
    // - Editor nodes use:   <div data-prosemirror-node-name="media" id="<fileId>">
    const mediaElement = isViewPage ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(`[data-node-type="media"][data-id="${fileId}"]`) : // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById(fileId);
    if (!mediaElement) return undefined;
    // Walk up the DOM to find the enclosing annotation element, but stop once we
    // leave the relevant content root for the current mode.
    let current = mediaElement.parentElement;
    while(current){
        if (current.getAttribute('data-mark-annotation-type') === 'inlineComment') {
            const annotationId = current.id;
            // For view pages the mark must also be in the 'active' state.
            if (isViewPage && current.getAttribute('data-mark-annotation-state') !== 'active') return undefined;
            return activeSet.has(annotationId) ? annotationId : undefined;
        }
        // Once we reach the top of the renderer / editor container, it's safe to assume this element is not within an annotation
        if (isViewPage && current.classList.contains('ak-renderer-wrapper') || !isViewPage && current.classList.contains('ProseMirror')) return undefined;
        current = current.parentElement;
    }
    return undefined;
}
function $fcc85c86573dc170$export$4905f58a835caea6(annotationId, isCommentsPanelOpen = false) {
    (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
        annotationIds: [
            annotationId
        ],
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        eventTarget: document.getElementById(annotationId)
    });
    (0, $9FoVw.handleKeyboardShortcutNavigation)({
        scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
        block: 'center',
        annotationId: annotationId,
        commentType: 'INLINE',
        isCommentsPanelOpen: isCommentsPanelOpen,
        context: (0, $9FoVw.NavigationContext).RENDERER
    });
}
function $fcc85c86573dc170$export$4485dd592403beab(annotationId, isCommentsPanelOpen = false) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const markElement = document.getElementById(annotationId);
    if (markElement) {
        (0, $gfqXk.getEditorAnnotationEventEmitter)().emit('setselectedannotation', annotationId);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: annotationId,
            commentType: 'INLINE',
            isCommentsPanelOpen: isCommentsPanelOpen,
            context: (0, $9FoVw.NavigationContext).EDITOR
        });
    }
}
// Used to handle cases where another user removed this comment
function $fcc85c86573dc170$var$showUnavailableCommentFlag(flags, title, description) {
    flags?.showWarningFlag({
        id: 'media-viewer-comment-unavailable',
        title: title,
        description: description
    });
}
const $fcc85c86573dc170$var$MEDIA_VIEWER_UNMOUNT_TIMEOUT_MS = 2000;
/**
 * Waits for the media viewer popup to be removed from the DOM before invoking `callback`.
 * If the popup is already gone (e.g. it unmounted synchronously), the callback fires on
 * the next animation frame. A safety timeout ensures the callback always fires even if
 * the DOM mutation is never observed.
 */ function $fcc85c86573dc170$var$waitForMediaViewerUnmount(callback) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const popup = document.querySelector($fcc85c86573dc170$var$MEDIA_VIEWER_POPUP_SELECTOR);
    if (!popup) {
        // Already unmounted — fire after a rAF to let React finish any pending work.
        requestAnimationFrame(callback);
        return;
    }
    const observer = new MutationObserver(()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!document.querySelector($fcc85c86573dc170$var$MEDIA_VIEWER_POPUP_SELECTOR)) {
            observer.disconnect();
            clearTimeout(safetyTimer);
            requestAnimationFrame(callback);
        }
    });
    // The media viewer is rendered inside an Atlaskit portal (atlaskit-portal-container),
    // so we observe document.body with subtree:true to catch the removal regardless of
    // how deep in the portal tree the popup lives.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Safety net: if the observer never fires (e.g. the popup is removed in an
    // unexpected way), ensure we still invoke the callback.
    const safetyTimer = window.setTimeout(()=>{
        observer.disconnect();
        callback();
    }, $fcc85c86573dc170$var$MEDIA_VIEWER_UNMOUNT_TIMEOUT_MS);
}
function $fcc85c86573dc170$export$bd892f36627deebf({ isViewPage: isViewPage, analyticsSource: analyticsSource, flags: flags }) {
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { getCurrentCommentsPanelState: getCurrentCommentsPanelState } = (0, $8i27m.useCommentsDataActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const isCommentsPanelShown = isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel;
    return (0, $cozmU.useMemo)(()=>{
        if (!(0, $6mKj3.expValEquals)('cc_comments_media_preview_integration', 'isEnabled', true)) return undefined;
        const getActiveAnnotationIds = ()=>getCurrentCommentsPanelState().orderedActiveAnnotationIdList?.map(({ threadKey: threadKey })=>threadKey) ?? [];
        return {
            headerActions: [
                {
                    label: intl.formatMessage($fcc85c86573dc170$var$i18n.viewCommentsLabel),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                        label: "",
                        spacing: "spacious"
                    }),
                    isVisible: (identifier)=>{
                        // Only show icon when image has comments
                        // NOTE - this is called whenever the header section is rendered (can be multiple times per image), so be careful with non-performant updates!
                        // Media viewer identifiers can also be external-image items, which do not have an `id`.
                        if (!('id' in identifier)) return false;
                        const annotationId = $fcc85c86573dc170$var$findAnnotationForMediaFile(getActiveAnnotationIds(), identifier.id, isViewPage);
                        return !!annotationId;
                    },
                    onClick: (identifier, actions)=>{
                        // Media viewer identifiers can also be external-image items, which do not have an `id`.
                        if (!('id' in identifier)) return;
                        // Re-check on click in case the comment was deleted or resolved after the button rendered.
                        const annotationId = $fcc85c86573dc170$var$findAnnotationForMediaFile(getActiveAnnotationIds(), identifier.id, isViewPage);
                        // Fire regardless of outcome, so we can get proper click data
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'mediaPreviewCommentsButton',
                                source: analyticsSource,
                                attributes: {
                                    context: 'mediaViewer',
                                    fileId: identifier.id,
                                    annotationId: annotationId ?? null
                                }
                            }
                        }).fire();
                        if (!annotationId) {
                            $fcc85c86573dc170$var$showUnavailableCommentFlag(flags, intl.formatMessage($fcc85c86573dc170$var$i18n.commentUnavailableTitle), intl.formatMessage($fcc85c86573dc170$var$i18n.commentUnavailableDescription));
                            return;
                        }
                        actions.close();
                        // Defer navigation until after the viewer close has started so selection and scrolling
                        // happen against the underlying page, not the still-open modal.
                        if (isViewPage) requestAnimationFrame(()=>{
                            $fcc85c86573dc170$export$4905f58a835caea6(annotationId, isCommentsPanelShown);
                        });
                        else $fcc85c86573dc170$var$waitForMediaViewerUnmount(()=>{
                            $fcc85c86573dc170$export$4485dd592403beab(annotationId, isCommentsPanelShown);
                        });
                    }
                }
            ]
        };
    }, [
        analyticsSource,
        createAnalyticsEvent,
        flags,
        getCurrentCommentsPanelState,
        intl,
        isCommentsPanelShown,
        isViewPage
    ]);
}
module.exports["useMediaCommentExtensions"] = $fcc85c86573dc170$export$bd892f36627deebf;

});

parcelRegister("8wppk", function(module, exports) {

var $8z3oB = parcelRequire("8z3oB");

const $f3689d580c651296$var$CONNECT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.macro.core';
const $f3689d580c651296$var$FORGE_EXTENSION_TYPE = 'com.atlassian.ecosystem';
const $f3689d580c651296$var$EMBEDDED_FAUS_MESSAGE_PREFIX = 'messageFromEmbeddedFAUS_';
const $f3689d580c651296$var$EMBEDDED_FAUS_ANALYTICS_PREFIX = 'analyticsFromEmbeddedFAUS_';
const $f3689d580c651296$var$EMBEDDED_FAUS_FETCH_APP_KEY_PREFIX = 'fetchAppKeyFromEmbeddedFAUS_';
let $f3689d580c651296$var$postRobotOn = null;

if (typeof window !== 'undefined') $f3689d580c651296$var$postRobotOn = (parcelRequire("9rzZK")).postRobotOn;
const $f3689d580c651296$var$getFausDomain = ()=>{
    // allow all domains in development mode
    return `${window.location.protocol}//${window.location.hostname}`;
};
const $f3689d580c651296$var$hasForgeDescendant = (nodes)=>{
    if (!nodes) return false;
    for (const node of nodes){
        if ((node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension') && node.attrs?.extensionType === $f3689d580c651296$var$FORGE_EXTENSION_TYPE) return true;
        if ($f3689d580c651296$var$hasForgeDescendant(node.content)) return true;
    }
    return false;
};
const $f3689d580c651296$var$getConnectMacroIdentifiers = (node)=>{
    const localId = node.attrs?.localId;
    const macroId = node.attrs?.parameters?.macroMetadata?.macroId?.value;
    return [
        localId,
        macroId
    ].filter((value)=>typeof value === 'string');
};
/**
 * Walk the ADF tree and return identifiers for Connect bodied macros whose
 * body content contains at least one Forge extension.
 *
 * Note: forwarded FAUS messages currently target the Connect macro's
 * `macroMetadata.macroId.value`, not the ADF node `attrs.localId`.
 */ const $f3689d580c651296$var$findConnectBodiedMacrosWithForgeChildren = (adf)=>{
    const result = new Set();
    if (!adf?.content) return result;
    const walk = (nodes)=>{
        for (const node of nodes){
            if (node.type === 'bodiedExtension' && node.attrs?.extensionType === $f3689d580c651296$var$CONNECT_MACRO_EXTENSION_TYPE && $f3689d580c651296$var$hasForgeDescendant(node.content)) for (const identifier of $f3689d580c651296$var$getConnectMacroIdentifiers(node))result.add(identifier);
            if (node.content) walk(node.content);
        }
    };
    walk(adf.content);
    return result;
};
/**
 * Walk the ADF tree and return `localId` values for Forge extension nodes
 * (`com.atlassian.ecosystem`) that are nested inside Connect bodied macros.
 *
 * FAUS uses the Forge extension's own `localId` as the channel identifier
 * when forwarding bridge calls via `messageFromEmbeddedFAUS_<localId>`.
 */ const $f3689d580c651296$var$findForgeMacroLocalIds = (adf)=>{
    const result = new Set();
    if (!adf?.content) return result;
    const walk = (nodes, insideConnectMacro)=>{
        for (const node of nodes){
            const isConnectBodiedMacro = node.type === 'bodiedExtension' && node.attrs?.extensionType === $f3689d580c651296$var$CONNECT_MACRO_EXTENSION_TYPE;
            if (insideConnectMacro && (node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension') && node.attrs?.extensionType === $f3689d580c651296$var$FORGE_EXTENSION_TYPE && node.attrs?.localId) result.add(node.attrs.localId);
            if (node.content) walk(node.content, insideConnectMacro || isConnectBodiedMacro);
        }
    };
    walk(adf.content, false);
    return result;
};
const $f3689d580c651296$var$buildBridgeEventHandlers = (flagProvider, options)=>{
    const handlers = {};
    if (flagProvider) {
        handlers.showFlag = (payload)=>{
            const actions = payload.actions;
            const flagActions = actions?.map((action)=>({
                    ...action,
                    onClick: action.onClick ? action.onClick : ()=>{}
                }));
            flagProvider.showFlag({
                ...payload,
                actions: flagActions
            });
        };
        handlers.closeFlag = (payload)=>{
            flagProvider.closeFlag(payload);
        };
    }
    if (options?.onEmbeddedForgeOpenModal) {
        const onOpenModal = options.onEmbeddedForgeOpenModal;
        handlers.openModal = (payload)=>{
            // `payload.extension` is required to render the modal — if it's
            // missing the bridge call is malformed and we silently drop it
            // rather than rendering an empty modal.
            if (!payload.extension) return;
            onOpenModal(payload);
        };
    }
    return handlers;
};
/**
 * Register postRobot listeners for a single Connect-macro identifier.
 *
 * Sets up a message channel (`messageFromEmbeddedFAUS_<id>`) that dispatches
 * incoming bridge calls to the matching handler, and an analytics channel
 * (`analyticsFromEmbeddedFAUS_<id>`) that acknowledges events to prevent
 * "No handler found" errors from postRobot.
 *
 * @returns An array of cancel functions for every registered listener.
 */ const $f3689d580c651296$var$setupBridgeListeners = (on, identifier, productHostname, handlers)=>{
    const cancelFns = [];
    const originDomain = $f3689d580c651296$var$getFausDomain();
    const messageHandler = on(`${$f3689d580c651296$var$EMBEDDED_FAUS_MESSAGE_PREFIX}${identifier}`, {
        domain: originDomain
    }, (event)=>{
        const originUrl = new URL(event.origin);
        if (originUrl.hostname !== productHostname) return Promise.resolve();
        const { eventKey: eventKey, ...payload } = event.data ?? {};
        const handler = typeof eventKey === 'string' ? handlers[eventKey] : undefined;
        if (handler) handler(payload);
        return Promise.resolve();
    });
    cancelFns.push(messageHandler.cancel);
    // FAUS also sends a one-shot `analyticsFromEmbeddedFAUS_<id>` message per
    // identifier so embedded Forge apps can forward analytics events (UI, track,
    // operational, screen) to the product. In the normal Forge-in-Forge case this
    // is handled by ForgeUIExtensionPointProvider which has access to the product's
    // AnalyticsWebClient (see ForgeUIExtensionPointProvider.tsx). In the
    // Connect-bodied-macro case there is no parent Forge provider, so we register
    // the listener here to prevent "No handler found" errors from postRobot.
    const analyticsHandler = on(`${$f3689d580c651296$var$EMBEDDED_FAUS_ANALYTICS_PREFIX}${identifier}`, {
        domain: originDomain
    }, (_event)=>{
        // TODO: forward events to the Confluence analytics pipeline once an
        // AnalyticsWebClient is plumbed through to this helper.
        // https://product-fabric.atlassian.net/browse/SCALE-8758
        return Promise.resolve();
    });
    cancelFns.push(analyticsHandler.cancel);
    return cancelFns;
};
const $f3689d580c651296$export$2710834bb826f82 = (adf, flags, options)=>{
    if (!$f3689d580c651296$var$postRobotOn) return;
    const connectMacroIdentifiers = $f3689d580c651296$var$findConnectBodiedMacrosWithForgeChildren(adf);
    const forgeMacroLocalIds = $f3689d580c651296$var$findForgeMacroLocalIds(adf);
    if (connectMacroIdentifiers.size === 0 && forgeMacroLocalIds.size === 0) return;
    const flagProvider = flags ? (0, $8z3oB.getFlagProvider)(flags) : null;
    const productHostname = window.location.hostname;
    const handlers = $f3689d580c651296$var$buildBridgeEventHandlers(flagProvider, options);
    const cancelFns = [];
    for (const identifier of connectMacroIdentifiers)cancelFns.push(...$f3689d580c651296$var$setupBridgeListeners($f3689d580c651296$var$postRobotOn, identifier, productHostname, handlers));
    for (const forgeMacroLocalId of forgeMacroLocalIds)cancelFns.push(...$f3689d580c651296$var$setupBridgeListeners($f3689d580c651296$var$postRobotOn, forgeMacroLocalId, productHostname, handlers));
    return ()=>{
        for (const cancel of cancelFns)cancel();
    };
};
const $f3689d580c651296$var$appKeyListenerRegistry = new Map();
const $f3689d580c651296$export$9039814cc3b5c36b = ()=>{
    $f3689d580c651296$var$appKeyListenerRegistry.clear();
};
const $f3689d580c651296$export$22c0e5b0fd0b5778 = (bridgeIdentifier, macroOrigin, macroId, targetWindow)=>{
    if (!$f3689d580c651296$var$postRobotOn || !macroOrigin || !bridgeIdentifier || !macroId) return;
    const requestName = `${$f3689d580c651296$var$EMBEDDED_FAUS_FETCH_APP_KEY_PREFIX}${bridgeIdentifier}`;
    const appKeyInfo = {
        connectIdentifier: bridgeIdentifier,
        connectMacroOrigin: macroOrigin,
        connectMacroId: macroId
    };
    const existingEntry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
    if (existingEntry) {
        existingEntry.byWindow.set(targetWindow, appKeyInfo);
        return ()=>{
            const entry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
            if (!entry) return;
            entry.byWindow.delete(targetWindow);
            if (entry.byWindow.size === 0) {
                entry.listenerCancel();
                $f3689d580c651296$var$appKeyListenerRegistry.delete(requestName);
            }
        };
    }
    const byWindow = new Map();
    byWindow.set(targetWindow, appKeyInfo);
    const listener = $f3689d580c651296$var$postRobotOn(requestName, {
        domain: $f3689d580c651296$var$getFausDomain()
    }, (event)=>{
        const entry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
        if (!entry || entry.byWindow.size === 0) return Promise.reject(new Error('No listeners registered for request'));
        const responseFromSource = event.source ? entry.byWindow.get(event.source) : undefined;
        const fallbackResponse = !responseFromSource && entry.byWindow.size === 1 ? entry.byWindow.values().next().value : undefined;
        const response = responseFromSource ?? fallbackResponse;
        if (!response) return Promise.reject(new Error('No listener registered for source window'));
        return Promise.resolve(response);
    });
    $f3689d580c651296$var$appKeyListenerRegistry.set(requestName, {
        listenerCancel: listener.cancel,
        byWindow: byWindow
    });
    return ()=>{
        const entry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
        if (!entry) return;
        entry.byWindow.delete(targetWindow);
        if (entry.byWindow.size === 0) {
            entry.listenerCancel();
            $f3689d580c651296$var$appKeyListenerRegistry.delete(requestName);
        }
    };
};
module.exports["registerEmbeddedMacroListeners"] = $f3689d580c651296$export$2710834bb826f82;
module.exports["registerEmbeddedFausAppKeyListener"] = $f3689d580c651296$export$22c0e5b0fd0b5778;

});

parcelRegister("6Trhx", function(module, exports) {
/**
 * @generated SignedSource<<7b142a9e5bf037e5bf84df26b0f166d8>>
 * @relayHash 5cd532f1dbaa98f680938803d44a7622
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5ac65b8296456b7407a8600258ddf7c3aacc70dded453a67ff3cc8dff3a53e3
const $8905400aadac7d47$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offset"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "draft"
            ]
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "offset",
            "variableName": "offset"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fallbackMediaNameFetcherQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fallbackMediaNameFetcherQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5cd532f1dbaa98f680938803d44a7622",
            "id": "e5ac65b8296456b7407a8600258ddf7c3aacc70dded453a67ff3cc8dff3a53e3",
            "metadata": {},
            "name": "fallbackMediaNameFetcherQuery",
            "operationKind": "query",
            "text": "query fallbackMediaNameFetcherQuery($contentId:ID!,$offset:Int,$first:Int){content(id:$contentId,status:[\"current\",\"draft\"]){edges{node{attachments(first:$first,offset:$offset){nodes{title,extensions{key,value},id},pageInfo{hasNextPage}},id}}}}"
        }
    };
}();
$8905400aadac7d47$var$node.hash = "86d114dcacd8ef1cb2ec5aab70e98d80";
var $8905400aadac7d47$export$2e2bcd8739ae039 = $8905400aadac7d47$var$node;



var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $c0rhi = parcelRequire("c0rhi");

const $16afe942cafdcc72$var$PAGE_SIZE = 50;
// setting max iterations to avoid ever getting into an infinite loop just in case
const $16afe942cafdcc72$var$MAX_ITERATIONS = 50;
const $16afe942cafdcc72$var$fallbackMediaNameFetcherQueryNode = (0, $8905400aadac7d47$export$2e2bcd8739ae039);
const $16afe942cafdcc72$export$8632f0c995082e2a = (contentId)=>async (id)=>{
        let offset = 0;
        let iterations = 0;
        let hasNextPage = true;
        while(hasNextPage && iterations < $16afe942cafdcc72$var$MAX_ITERATIONS){
            const { data: data } = await (0, $c0rhi.queryInterop)({
                query: $16afe942cafdcc72$var$fallbackMediaNameFetcherQueryNode,
                variables: {
                    contentId: contentId,
                    offset: offset,
                    first: $16afe942cafdcc72$var$PAGE_SIZE
                },
                fetchPolicy: 'cache-first',
                __callerPackage__: "editor-features"
            }).catch((e)=>{
                if ((0, $1uFM6.isUnauthorizedError)(e) || (0, $6fil2.containsNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
                return {
                    data: null
                };
            });
            const attachments = data?.content?.edges?.[0]?.node?.attachments;
            const nodes = attachments?.nodes ?? [];
            for (const node of nodes){
                const fileId = node?.extensions?.find((ext)=>ext?.key === 'fileId')?.value;
                if (fileId === id && node?.title) return node.title;
            }
            hasNextPage = attachments?.pageInfo?.hasNextPage ?? false;
            offset += $16afe942cafdcc72$var$PAGE_SIZE;
            iterations += 1;
        }
        throw new Error(`Attachment with fileId ${id} not found on page ${contentId}`);
    };
module.exports["createFallbackMediaNameFetcher"] = $16afe942cafdcc72$export$8632f0c995082e2a;

});

parcelRegister("edEsl", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ 
var $hfrng = parcelRequire("hfrng");


var $04e9M = parcelRequire("04e9M");


var $9wGTI = parcelRequire("9wGTI");

const $027ba4852fb11225$var$requests = new Map();
const $027ba4852fb11225$var$setCacheWithTimeout = (fileId, req)=>$027ba4852fb11225$var$requests.set(fileId, req) && void setTimeout(()=>$027ba4852fb11225$var$requests.delete(fileId), 3000);
const $027ba4852fb11225$var$isDownloadEvent = (options)=>(0, $9wGTI.fg)('confluence_publish_attachment_audit_log_event') && options.viewingLevel === 'download';
const $027ba4852fb11225$var$getNotifyRequestBody = (options)=>{
    if ($027ba4852fb11225$var$isDownloadEvent(options)) return {
        attachmentDownloaded: {
            fileStoreId: options.fileId
        }
    };
    return {
        attachmentViewed: {
            fileStoreId: options.fileId
        }
    };
};
const $027ba4852fb11225$var$getTrackEventPayload = (options, contentType)=>{
    const action = $027ba4852fb11225$var$isDownloadEvent(options) ? 'downloaded' : 'viewed';
    return {
        source: 'ui',
        actionSubject: 'attachment',
        action: action,
        name: `attachment ${action}`,
        attributes: {
            activationId: options.fileId,
            pageType: contentType
        }
    };
};
const $027ba4852fb11225$var$globalMediaViewedListener = (options, contentType)=>{
    // To avoid case when user opens media-picker (and we don't want to call BE API after that)
    if (!options.isUserCollection) {
        // Sometimes globalEventMediaEmitter will invoke the globalMediaViewedListener callback
        // multiple times for a single `media-viewed` event. For this reason we return a cached
        // request promise if one exists
        const priorRequestForTheSameFileID = $027ba4852fb11225$var$requests.get(options?.fileId);
        return priorRequestForTheSameFileID || (()=>{
            const mediaViewedReq = (0, $9wGTI.fg)('confluence_event_notifier_deprecation') ? Promise.resolve({}) : fetch('/wiki/rest/internal/1.0/eventnotifier/notify', {
                method: 'POST',
                body: JSON.stringify($027ba4852fb11225$var$getNotifyRequestBody(options)),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if ((0, $9wGTI.fg)('confluence_event_notifier_updates')) (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendTrackEvent($027ba4852fb11225$var$getTrackEventPayload(options, contentType));
            });
            $027ba4852fb11225$var$setCacheWithTimeout(options.fileId, mediaViewedReq);
            return mediaViewedReq;
        })();
    }
};
// Reference count of registrants sharing the singleton listener (view renderers, comment renderers,
// the editor). Only detach on the last remove, so one unmount can't kill the listener for others.
let $027ba4852fb11225$var$registrationCount = 0;
// make sure currentListener is a stable reference so it can be removed by .off event handler
let $027ba4852fb11225$var$currentListener = null;
const $027ba4852fb11225$export$dbbc14ed63c88dd4 = ({ contentType: contentType })=>{
    if ($027ba4852fb11225$var$registrationCount === 0) {
        $027ba4852fb11225$var$currentListener = (options)=>{
            $027ba4852fb11225$var$globalMediaViewedListener(options, contentType);
        };
        (0, $hfrng.globalMediaEventEmitter).on('media-viewed', $027ba4852fb11225$var$currentListener);
    }
    $027ba4852fb11225$var$registrationCount += 1;
};
const $027ba4852fb11225$export$29046bd16724fad9 = ()=>{
    if ($027ba4852fb11225$var$registrationCount === 0) return;
    $027ba4852fb11225$var$registrationCount -= 1;
    if ($027ba4852fb11225$var$registrationCount === 0 && $027ba4852fb11225$var$currentListener) {
        (0, $hfrng.globalMediaEventEmitter).off('media-viewed', $027ba4852fb11225$var$currentListener);
        $027ba4852fb11225$var$currentListener = null;
    }
};
module.exports["registerGlobalMediaViewedListener"] = $027ba4852fb11225$export$dbbc14ed63c88dd4;
module.exports["removeGlobalMediaViewedListener"] = $027ba4852fb11225$export$29046bd16724fad9;

});

parcelRegister("eXfot", function(module, exports) {
/**
 * @generated SignedSource<<8ed8dc03028e55b4cdab4438310d33a6>>
 * @relayHash 3f8b7bb91ace1543a1f04562b04091b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a2e2b777c5ee42b9bf48b2d4941abddb1ed952d85e1942a2be06c0d3dae63930
const $0c16356697ac10ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tasks"
        },
        {
            "defaultValue": "VIEW_PAGE",
            "kind": "LocalArgument",
            "name": "trigger"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "tasks",
                            "variableName": "tasks"
                        },
                        {
                            "kind": "Variable",
                            "name": "trigger",
                            "variableName": "trigger"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "batchedInlineTasksInput"
                }
            ],
            "concreteType": "GraphQLMutationResponse",
            "kind": "LinkedField",
            "name": "setBatchedTaskStatus",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SetBatchedTaskStatusMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SetBatchedTaskStatusMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3f8b7bb91ace1543a1f04562b04091b2",
            "id": "a2e2b777c5ee42b9bf48b2d4941abddb1ed952d85e1942a2be06c0d3dae63930",
            "metadata": {},
            "name": "SetBatchedTaskStatusMutation",
            "operationKind": "mutation",
            "text": "mutation SetBatchedTaskStatusMutation($contentId:ID!,$tasks:[InlineTask]!,$trigger:PageUpdateTrigger=VIEW_PAGE){setBatchedTaskStatus(batchedInlineTasksInput:{contentId:$contentId,tasks:$tasks,trigger:$trigger}){success}}"
        }
    };
}();
$0c16356697ac10ff$var$node.hash = "69534ca77b812c2f6a503bd25527650c";
var $0c16356697ac10ff$export$2e2bcd8739ae039 = $0c16356697ac10ff$var$node;


const $408d997ca1cff4e4$export$2fe8e9e635ca9d7a = (0, $0c16356697ac10ff$export$2e2bcd8739ae039);
module.exports["SetBatchedTaskStatusMutation"] = $408d997ca1cff4e4$export$2fe8e9e635ca9d7a;

});

parcelRegister("5IQv3", function(module, exports) {

let $42a9c93584d3a986$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $42a9c93584d3a986$var$load("6wr18"),
    $42a9c93584d3a986$var$load("ffEVr"),
    $42a9c93584d3a986$var$load("8VYL2")
]).then(()=>parcelRequire('yAmxl'));

});


$parcel$global.rlb("h9ofP")
//# sourceMappingURL=FullPageEditorComponent.ee4103c0.js.map
